(window.theme = window.theme || {}),
    (window.themeInfo = { name: "Vantage" }),
    (function () {
        var e, t;
        (e = window),
            (t = (function (e, t) {
                "use strict";
                if (t.getElementsByClassName) {
                    var i,
                        n,
                        o = t.documentElement,
                        r = e.Date,
                        a = e.HTMLPictureElement,
                        s = "addEventListener",
                        c = "getAttribute",
                        l = e[s],
                        u = e.setTimeout,
                        d = e.requestAnimationFrame || u,
                        h = e.requestIdleCallback,
                        p = /^picture$/i,
                        f = ["load", "error", "lazyincluded", "_lazyloaded"],
                        m = {},
                        y = Array.prototype.forEach,
                        v = function (e, t) {
                            return m[t] || (m[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), m[t].test(e[c]("class") || "") && m[t];
                        },
                        g = function (e, t) {
                            v(e, t) || e.setAttribute("class", (e[c]("class") || "").trim() + " " + t);
                        },
                        b = function (e, t) {
                            var i;
                            (i = v(e, t)) && e.setAttribute("class", (e[c]("class") || "").replace(i, " "));
                        },
                        w = function (e, t, i) {
                            var n = i ? s : "removeEventListener";
                            i && w(e, t),
                                f.forEach(function (i) {
                                    e[n](i, t);
                                });
                        },
                        S = function (e, n, o, r, a) {
                            var s = t.createEvent("CustomEvent");
                            return o || (o = {}), (o.instance = i), s.initCustomEvent(n, !r, !a, o), e.dispatchEvent(s), s;
                        },
                        E = function (t, i) {
                            var o;
                            !a && (o = e.picturefill || n.pf) ? o({ reevaluate: !0, elements: [t] }) : i && i.src && (t.src = i.src);
                        },
                        x = function (e, t) {
                            return (getComputedStyle(e, null) || {})[t];
                        },
                        _ = function (e, t, i) {
                            for (i = i || e.offsetWidth; i < n.minSize && t && !e._lazysizesWidth; ) (i = t.offsetWidth), (t = t.parentNode);
                            return i;
                        },
                        A = (function () {
                            var e,
                                i,
                                n = [],
                                o = [],
                                r = n,
                                a = function () {
                                    var t = r;
                                    for (r = n.length ? o : n, e = !0, i = !1; t.length; ) t.shift()();
                                    e = !1;
                                },
                                s = function (n, o) {
                                    e && !o ? n.apply(this, arguments) : (r.push(n), i || ((i = !0), (t.hidden ? u : d)(a)));
                                };
                            return (s._lsFlush = a), s;
                        })(),
                        L = function (e, t) {
                            return t
                                ? function () {
                                      A(e);
                                  }
                                : function () {
                                      var t = this,
                                          i = arguments;
                                      A(function () {
                                          e.apply(t, i);
                                      });
                                  };
                        },
                        C = function (e) {
                            var t,
                                i = 0,
                                o = 125,
                                a = n.ricTimeout,
                                s = function () {
                                    (t = !1), (i = r.now()), e();
                                },
                                c =
                                    h && n.ricTimeout
                                        ? function () {
                                              h(s, { timeout: a }), a !== n.ricTimeout && (a = n.ricTimeout);
                                          }
                                        : L(function () {
                                              u(s);
                                          }, !0);
                            return function (e) {
                                var n;
                                (e = !0 === e) && (a = 33), t || ((t = !0), 0 > (n = o - (r.now() - i)) && (n = 0), e || (9 > n && h) ? c() : u(c, n));
                            };
                        },
                        k = function (e) {
                            var t,
                                i,
                                n = 99,
                                o = function () {
                                    (t = null), e();
                                },
                                a = function () {
                                    var e = r.now() - i;
                                    n > e ? u(a, n - e) : (h || o)(o);
                                };
                            return function () {
                                (i = r.now()), t || (t = u(a, n));
                            };
                        };
                    !(function () {
                        var t,
                            i = {
                                lazyClass: "lazyload",
                                loadedClass: "lazyloaded",
                                loadingClass: "lazyloading",
                                preloadClass: "lazypreload",
                                errorClass: "lazyerror",
                                autosizesClass: "lazyautosizes",
                                srcAttr: "data-src",
                                srcsetAttr: "data-srcset",
                                sizesAttr: "data-sizes",
                                minSize: 40,
                                customMedia: {},
                                init: !0,
                                expFactor: 1.5,
                                hFac: 0.8,
                                loadMode: 2,
                                loadHidden: !0,
                                ricTimeout: 300,
                            };
                        for (t in ((n = e.lazySizesConfig || e.lazysizesConfig || {}), i)) t in n || (n[t] = i[t]);
                        (e.lazySizesConfig = n),
                            u(function () {
                                n.init && T();
                            });
                    })();
                    var q = (function () {
                            var a,
                                d,
                                h,
                                f,
                                m,
                                _,
                                q,
                                T,
                                D,
                                P,
                                j,
                                M,
                                z,
                                F,
                                O = /^img$/i,
                                N = /^iframe$/i,
                                H = "onscroll" in e && !/glebot/.test(navigator.userAgent),
                                U = 0,
                                R = 0,
                                B = 0,
                                W = -1,
                                V = function (e) {
                                    B--, e && e.target && w(e.target, V), (!e || 0 > B || !e.target) && (B = 0);
                                },
                                G = function (e, i) {
                                    var n,
                                        r = e,
                                        a = "hidden" == x(t.body, "visibility") || "hidden" != x(e, "visibility");
                                    for (T -= i, j += i, D -= i, P += i; a && (r = r.offsetParent) && r != t.body && r != o; )
                                        (a = (x(r, "opacity") || 1) > 0) && "visible" != x(r, "overflow") && ((n = r.getBoundingClientRect()), (a = P > n.left && D < n.right && j > n.top - 1 && T < n.bottom + 1));
                                    return a;
                                },
                                $ = function () {
                                    var e,
                                        r,
                                        s,
                                        l,
                                        u,
                                        h,
                                        p,
                                        m,
                                        y,
                                        v = i.elements;
                                    if ((f = n.loadMode) && 8 > B && (e = v.length)) {
                                        (r = 0),
                                            W++,
                                            null == z && ("expand" in n || (n.expand = o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370), (M = n.expand), (z = M * n.expFactor)),
                                            z > R && 1 > B && W > 2 && f > 2 && !t.hidden ? ((R = z), (W = 0)) : (R = f > 1 && W > 1 && 6 > B ? M : U);
                                        for (; e > r; r++)
                                            if (v[r] && !v[r]._lazyRace)
                                                if (H)
                                                    if (
                                                        (((m = v[r][c]("data-expand")) && (h = 1 * m)) || (h = R),
                                                        y !== h && ((_ = innerWidth + h * F), (q = innerHeight + h), (p = -1 * h), (y = h)),
                                                        (s = v[r].getBoundingClientRect()),
                                                        (j = s.bottom) >= p &&
                                                            (T = s.top) <= q &&
                                                            (P = s.right) >= p * F &&
                                                            (D = s.left) <= _ &&
                                                            (j || P || D || T) &&
                                                            (n.loadHidden || "hidden" != x(v[r], "visibility")) &&
                                                            ((d && 3 > B && !m && (3 > f || 4 > W)) || G(v[r], h)))
                                                    ) {
                                                        if ((te(v[r]), (u = !0), B > 9)) break;
                                                    } else !u && d && !l && 4 > B && 4 > W && f > 2 && (a[0] || n.preloadAfterLoad) && (a[0] || (!m && (j || P || D || T || "auto" != v[r][c](n.sizesAttr)))) && (l = a[0] || v[r]);
                                                else te(v[r]);
                                        l && !u && te(l);
                                    }
                                },
                                Z = C($),
                                X = function (e) {
                                    g(e.target, n.loadedClass), b(e.target, n.loadingClass), w(e.target, K), S(e.target, "lazyloaded");
                                },
                                Y = L(X),
                                K = function (e) {
                                    Y({ target: e.target });
                                },
                                J = function (e, t) {
                                    try {
                                        e.contentWindow.location.replace(t);
                                    } catch (i) {
                                        e.src = t;
                                    }
                                },
                                Q = function (e) {
                                    var t,
                                        i = e[c](n.srcsetAttr);
                                    (t = n.customMedia[e[c]("data-media") || e[c]("media")]) && e.setAttribute("media", t), i && e.setAttribute("srcset", i);
                                },
                                ee = L(function (e, t, i, o, r) {
                                    var a, s, l, d, f, m;
                                    (f = S(e, "lazybeforeunveil", t)).defaultPrevented ||
                                        (o && (i ? g(e, n.autosizesClass) : e.setAttribute("sizes", o)),
                                        (s = e[c](n.srcsetAttr)),
                                        (a = e[c](n.srcAttr)),
                                        r && (d = (l = e.parentNode) && p.test(l.nodeName || "")),
                                        (m = t.firesLoad || ("src" in e && (s || a || d))),
                                        (f = { target: e }),
                                        m && (w(e, V, !0), clearTimeout(h), (h = u(V, 2500)), g(e, n.loadingClass), w(e, K, !0)),
                                        d && y.call(l.getElementsByTagName("source"), Q),
                                        s ? e.setAttribute("srcset", s) : a && !d && (N.test(e.nodeName) ? J(e, a) : (e.src = a)),
                                        r && (s || d) && E(e, { src: a })),
                                        e._lazyRace && delete e._lazyRace,
                                        b(e, n.lazyClass),
                                        A(function () {
                                            (!m || (e.complete && e.naturalWidth > 1)) && (m ? V(f) : B--, X(f));
                                        }, !0);
                                }),
                                te = function (e) {
                                    var t,
                                        i = O.test(e.nodeName),
                                        o = i && (e[c](n.sizesAttr) || e[c]("sizes")),
                                        r = "auto" == o;
                                    ((!r && d) || !i || (!e[c]("src") && !e.srcset) || e.complete || v(e, n.errorClass) || !v(e, n.lazyClass)) &&
                                        ((t = S(e, "lazyunveilread").detail), r && I.updateElem(e, !0, e.offsetWidth), (e._lazyRace = !0), B++, ee(e, t, r, o, i));
                                },
                                ie = function () {
                                    if (!d) {
                                        if (r.now() - m < 999) return void u(ie, 999);
                                        var e = k(function () {
                                            (n.loadMode = 3), Z();
                                        });
                                        (d = !0),
                                            (n.loadMode = 3),
                                            Z(),
                                            l(
                                                "scroll",
                                                function () {
                                                    3 == n.loadMode && (n.loadMode = 2), e();
                                                },
                                                !0
                                            );
                                    }
                                };
                            return {
                                _: function () {
                                    (m = r.now()),
                                        (i.elements = t.getElementsByClassName(n.lazyClass)),
                                        (a = t.getElementsByClassName(n.lazyClass + " " + n.preloadClass)),
                                        (F = n.hFac),
                                        l("scroll", Z, !0),
                                        l("resize", Z, !0),
                                        e.MutationObserver ? new MutationObserver(Z).observe(o, { childList: !0, subtree: !0, attributes: !0 }) : (o[s]("DOMNodeInserted", Z, !0), o[s]("DOMAttrModified", Z, !0), setInterval(Z, 999)),
                                        l("hashchange", Z, !0),
                                        ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (e) {
                                            t[s](e, Z, !0);
                                        }),
                                        /d$|^c/.test(t.readyState) ? ie() : (l("load", ie), t[s]("DOMContentLoaded", Z), u(ie, 2e4)),
                                        i.elements.length ? ($(), A._lsFlush()) : Z();
                                },
                                checkElems: Z,
                                unveil: te,
                            };
                        })(),
                        I = (function () {
                            var e,
                                i = L(function (e, t, i, n) {
                                    var o, r, a;
                                    if (((e._lazysizesWidth = n), (n += "px"), e.setAttribute("sizes", n), p.test(t.nodeName || ""))) for (r = 0, a = (o = t.getElementsByTagName("source")).length; a > r; r++) o[r].setAttribute("sizes", n);
                                    i.detail.dataAttr || E(e, i.detail);
                                }),
                                o = function (e, t, n) {
                                    var o,
                                        r = e.parentNode;
                                    r && ((n = _(e, r, n)), (o = S(e, "lazybeforesizes", { width: n, dataAttr: !!t })).defaultPrevented || ((n = o.detail.width) && n !== e._lazysizesWidth && i(e, r, o, n)));
                                },
                                r = function () {
                                    var t,
                                        i = e.length;
                                    if (i) for (t = 0; i > t; t++) o(e[t]);
                                },
                                a = k(r);
                            return {
                                _: function () {
                                    (e = t.getElementsByClassName(n.autosizesClass)), l("resize", a);
                                },
                                checkElems: a,
                                updateElem: o,
                            };
                        })(),
                        T = function () {
                            T.i || ((T.i = !0), I._(), q._());
                        };
                    return (i = { cfg: n, autoSizer: I, loader: q, init: T, uP: E, aC: g, rC: b, hC: v, fire: S, gW: _, rAF: A });
                }
            })(e, e.document)),
            (e.lazySizes = t),
            "object" == typeof module && module.exports && (module.exports = t),
            (function (e, t) {
                var i = function () {
                    t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
                };
                (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? i() : e.addEventListener("lazyunveilread", i, !0);
            })(window, function (e, t, i) {
                "use strict";
                if (e.addEventListener) {
                    var n = /\s+/g,
                        o = /\s*\|\s+|\s+\|\s*/g,
                        r = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
                        a = /\(|\)|'/,
                        s = { contain: 1, cover: 1 },
                        c = function (e, i, a) {
                            var s = t.createElement("picture"),
                                c = i.getAttribute(lazySizesConfig.sizesAttr),
                                l = i.getAttribute("data-ratio"),
                                u = i.getAttribute("data-optimumx");
                            i._lazybgset && i._lazybgset.parentNode == i && i.removeChild(i._lazybgset),
                                Object.defineProperty(a, "_lazybgset", { value: i, writable: !0 }),
                                Object.defineProperty(i, "_lazybgset", { value: s, writable: !0 }),
                                (e = e.replace(n, " ").split(o)),
                                (s.style.display = "none"),
                                (a.className = lazySizesConfig.lazyClass),
                                1 != e.length || c || (c = "auto"),
                                e.forEach(function (e) {
                                    var i = t.createElement("source");
                                    c && "auto" != c && i.setAttribute("sizes", c),
                                        e.match(r) && (i.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && i.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                                        s.appendChild(i);
                                }),
                                c && (a.setAttribute(lazySizesConfig.sizesAttr, c), i.removeAttribute(lazySizesConfig.sizesAttr), i.removeAttribute("sizes")),
                                u && a.setAttribute("data-optimumx", u),
                                l && a.setAttribute("data-ratio", l),
                                s.appendChild(a),
                                i.appendChild(s);
                        },
                        l = function (e) {
                            if (e.target._lazybgset) {
                                var t = e.target,
                                    n = t._lazybgset,
                                    o = t.currentSrc || t.src;
                                o && (n.style.backgroundImage = "url(" + (a.test(o) ? JSON.stringify(o) : o) + ")"), t._lazybgsetLoading && (i.fire(n, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading);
                            }
                        };
                    addEventListener("lazybeforeunveil", function (e) {
                        var n, o, r;
                        !e.defaultPrevented &&
                            (n = e.target.getAttribute("data-bgset")) &&
                            ((r = e.target),
                            ((o = t.createElement("img")).alt = ""),
                            (o._lazybgsetLoading = !0),
                            (e.detail.firesLoad = !0),
                            c(n, r, o),
                            setTimeout(function () {
                                i.loader.unveil(o),
                                    i.rAF(function () {
                                        i.fire(o, "_lazyloaded", {}, !0, !0), o.complete && l({ target: o });
                                    });
                            }));
                    }),
                        t.addEventListener("load", l, !0),
                        e.addEventListener(
                            "lazybeforesizes",
                            function (e) {
                                if (e.detail.instance == i && e.target._lazybgset && e.detail.dataAttr) {
                                    var t = (function (e) {
                                        var t;
                                        return (t = (getComputedStyle(e) || { getPropertyValue: function () {} }).getPropertyValue("background-size")), !s[t] && s[e.style.backgroundSize] && (t = e.style.backgroundSize), t;
                                    })(e.target._lazybgset);
                                    s[t] &&
                                        ((e.target._lazysizesParentFit = t),
                                        i.rAF(function () {
                                            e.target.setAttribute("data-parent-fit", t), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit;
                                        }));
                                }
                            },
                            !0
                        ),
                        t.documentElement.addEventListener("lazybeforesizes", function (e) {
                            !e.defaultPrevented &&
                                e.target._lazybgset &&
                                e.detail.instance == i &&
                                (e.detail.width = (function (e) {
                                    var t = i.gW(e, e.parentNode);
                                    return (!e._lazysizesWidth || t > e._lazysizesWidth) && (e._lazysizesWidth = t), e._lazysizesWidth;
                                })(e.target._lazybgset));
                        });
                }
            }),
            (function (e, t) {
                var i = function () {
                    t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
                };
                (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? i() : e.addEventListener("lazyunveilread", i, !0);
            })(window, function (e, t, i) {
                "use strict";
                function n(t, i) {
                    var n,
                        o,
                        r,
                        a,
                        s = e.getComputedStyle(t);
                    for (n in ((o = t.parentNode),
                    (a = { isPicture: !(!o || !d.test(o.nodeName || "")) }),
                    (r = function (e, i) {
                        var n = t.getAttribute("data-" + e);
                        if (!n) {
                            var o = s.getPropertyValue("--ls-" + e);
                            o && (n = o.trim());
                        }
                        if (n) {
                            if ("true" == n) n = !0;
                            else if ("false" == n) n = !1;
                            else if (u.test(n)) n = parseFloat(n);
                            else if ("function" == typeof c[e]) n = c[e](t, n);
                            else if (m.test(n))
                                try {
                                    n = JSON.parse(n);
                                } catch (e) {}
                            a[e] = n;
                        } else e in c && "function" != typeof c[e] ? (a[e] = c[e]) : i && "function" == typeof c[e] && (a[e] = c[e](t, n));
                    }),
                    c))
                        r(n);
                    return (
                        i.replace(f, function (e, t) {
                            t in a || r(t, !0);
                        }),
                        a
                    );
                }
                function o(e, i, n) {
                    var o = 0,
                        r = 0,
                        a = n;
                    if (e) {
                        if ("container" === i.ratio) {
                            for (o = a.scrollWidth, r = a.scrollHeight; !((o && r) || a === t); ) (o = (a = a.parentNode).scrollWidth), (r = a.scrollHeight);
                            o && r && (i.ratio = r / o);
                        }
                        (e = (function (e, t) {
                            var i = [];
                            return (
                                (i.srcset = []),
                                t.absUrl && (v.setAttribute("href", e), (e = v.href)),
                                (e = ((t.prefix || "") + e + (t.postfix || "")).replace(f, function (e, i) {
                                    return l[typeof t[i]] ? t[i] : e;
                                })),
                                t.widths.forEach(function (n) {
                                    var o = t.widthmap[n] || n,
                                        r = { u: e.replace(h, o).replace(p, t.ratio ? Math.round(n * t.ratio) : ""), w: n };
                                    i.push(r), i.srcset.push((r.c = r.u + " " + n + "w"));
                                }),
                                i
                            );
                        })(e, i)),
                            (e.isPicture = i.isPicture),
                            b && "IMG" == n.nodeName.toUpperCase() ? n.removeAttribute(s.srcsetAttr) : n.setAttribute(s.srcsetAttr, e.srcset.join(", ")),
                            Object.defineProperty(n, "_lazyrias", { value: e, writable: !0 });
                    }
                }
                function r(e, t) {
                    var o = n(e, t);
                    return c.modifyOptions.call(e, { target: e, details: o, detail: o }), i.fire(e, "lazyriasmodifyoptions", o), o;
                }
                function a(e) {
                    return e.getAttribute(e.getAttribute("data-srcattr") || c.srcAttr) || e.getAttribute(s.srcsetAttr) || e.getAttribute(s.srcAttr) || e.getAttribute("data-pfsrcset") || "";
                }
                var s,
                    c,
                    l = { string: 1, number: 1 },
                    u = /^\-*\+*\d+\.*\d*$/,
                    d = /^picture$/i,
                    h = /\s*\{\s*width\s*\}\s*/i,
                    p = /\s*\{\s*height\s*\}\s*/i,
                    f = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
                    m = /^\[.*\]|\{.*\}$/,
                    y = /^(?:auto|\d+(px)?)$/,
                    v = t.createElement("a"),
                    g = t.createElement("img"),
                    b = "srcset" in g && !("sizes" in g),
                    w = !!e.HTMLPictureElement && !b;
                !(function () {
                    var t,
                        n = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: function () {}, widthmap: {}, ratio: !1 };
                    for (t in ((s = (i && i.cfg) || e.lazySizesConfig) || ((s = {}), (e.lazySizesConfig = s)),
                    s.supportsType ||
                        (s.supportsType = function (e) {
                            return !e;
                        }),
                    s.rias || (s.rias = {}),
                    "widths" in (c = s.rias) ||
                        ((c.widths = []),
                        (function (e) {
                            for (var t, i = 0; !t || 3e3 > t; ) (i += 5) > 30 && (i += 1), (t = 36 * i), e.push(t);
                        })(c.widths)),
                    n))
                        t in c || (c[t] = n[t]);
                })(),
                    addEventListener(
                        "lazybeforesizes",
                        function (e) {
                            var t, n, l, u, d, p, f, m, v, g, b, E, x;
                            if (e.detail.instance == i && ((t = e.target), e.detail.dataAttr && !e.defaultPrevented && !c.disabled && (v = t.getAttribute(s.sizesAttr) || t.getAttribute("sizes")) && y.test(v))) {
                                if (((l = r(t, (n = a(t)))), (b = h.test(l.prefix) || h.test(l.postfix)), l.isPicture && (u = t.parentNode)))
                                    for (p = 0, f = (d = u.getElementsByTagName("source")).length; f > p; p++) (b || h.test((m = a(d[p])))) && (o(m, l, d[p]), (E = !0));
                                b || h.test(n) ? (o(n, l, t), (E = !0)) : E && (((x = []).srcset = []), (x.isPicture = !0), Object.defineProperty(t, "_lazyrias", { value: x, writable: !0 })),
                                    E && (w ? t.removeAttribute(s.srcAttr) : "auto" != v && ((g = { width: parseInt(v, 10) }), S({ target: t, detail: g })));
                            }
                        },
                        !0
                    );
                var S = (function () {
                    var n = function (e, t) {
                            return e.w - t.w;
                        },
                        o = function (e, t) {
                            var n;
                            return (
                                !e._lazyrias &&
                                    i.pWS &&
                                    (n = i.pWS(e.getAttribute(s.srcsetAttr || ""))).length &&
                                    (Object.defineProperty(e, "_lazyrias", { value: n, writable: !0 }), t && e.parentNode && (n.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
                                e._lazyrias
                            );
                        },
                        r = function (t) {
                            var n = e.devicePixelRatio || 1,
                                o = i.getX && i.getX(t);
                            return Math.min(o || n, 2.4, n);
                        },
                        a = function (t, i) {
                            var a, s, c, l, u, d;
                            if ((u = t._lazyrias).isPicture && e.matchMedia)
                                for (s = 0, c = (a = t.parentNode.getElementsByTagName("source")).length; c > s; s++)
                                    if (o(a[s]) && !a[s].getAttribute("type") && (!(l = a[s].getAttribute("media")) || (matchMedia(l) || {}).matches)) {
                                        u = a[s]._lazyrias;
                                        break;
                                    }
                            return (
                                (!u.w || u.w < i) &&
                                    ((u.w = i),
                                    (u.d = r(t)),
                                    (d = (function (e) {
                                        for (var t, i, n = e.length, o = e[n - 1], r = 0; n > r; r++)
                                            if ((((o = e[r]).d = o.w / e.w), o.d >= e.d)) {
                                                !o.cached && (t = e[r - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((i = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * i), t.d + (o.d - e.d) * i > e.d && (o = t));
                                                break;
                                            }
                                        return o;
                                    })(u.sort(n)))),
                                d
                            );
                        },
                        c = function (n) {
                            if (n.detail.instance == i) {
                                var r,
                                    l = n.target;
                                return !b && (e.respimage || e.picturefill || lazySizesConfig.pf)
                                    ? void t.removeEventListener("lazybeforesizes", c)
                                    : void (
                                          ("_lazyrias" in l || (n.detail.dataAttr && o(l, !0))) &&
                                          ((r = a(l, n.detail.width)),
                                          r &&
                                              r.u &&
                                              l._lazyrias.cur != r.u &&
                                              ((l._lazyrias.cur = r.u),
                                              (r.cached = !0),
                                              i.rAF(function () {
                                                  l.setAttribute(s.srcAttr, r.u), l.setAttribute("src", r.u);
                                              })))
                                      );
                            }
                        };
                    return w ? (c = function () {}) : addEventListener("lazybeforesizes", c), c;
                })();
            });
    })(),
    window.NodeList &&
        !NodeList.prototype.forEach &&
        (NodeList.prototype.forEach = function (e, t) {
            t = t || window;
            for (var i = 0; i < this.length; i++) e.call(t, this[i], i, this);
        }),
    String.prototype.includes ||
        (String.prototype.includes = function (e, t) {
            "use strict";
            return "number" != typeof t && (t = 0), !(t + e.length > this.length) && -1 !== this.indexOf(e, t);
        }),
    [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function (e) {
        e.hasOwnProperty("remove") ||
            Object.defineProperty(e, "remove", {
                configurable: !0,
                enumerable: !0,
                writable: !0,
                value: function () {
                    this.parentNode.removeChild(this);
                },
            });
    }),
    (function () {
        window.Modernizr = (function (e, t, i) {
            function n(e) {
                m.cssText = e;
            }
            function o(e, t) {
                return typeof e === t;
            }
            function r(e, t) {
                return !!~("" + e).indexOf(t);
            }
            function a(e, t) {
                for (var n in e) {
                    var o = e[n];
                    if (!r(o, "-") && m[o] !== i) return "pfx" != t || o;
                }
                return !1;
            }
            function s(e, t, n) {
                for (var r in e) {
                    var a = t[e[r]];
                    if (a !== i) return !1 === n ? e[r] : o(a, "function") ? a.bind(n || t) : a;
                }
                return !1;
            }
            function c(e, t, i) {
                var n = e.charAt(0).toUpperCase() + e.slice(1),
                    r = (e + " " + g.join(n + " ") + n).split(" ");
                return o(t, "string") || o(t, "undefined") ? a(r, t) : s((r = (e + " " + b.join(n + " ") + n).split(" ")), t, i);
            }
            var l,
                u,
                d = {},
                h = t.documentElement,
                p = "modernizr",
                f = t.createElement(p),
                m = f.style,
                y = " -webkit- -moz- -o- -ms- ".split(" "),
                v = "Webkit Moz O ms",
                g = v.split(" "),
                b = v.toLowerCase().split(" "),
                w = {},
                S = [],
                E = S.slice,
                x = function (e, i, n, o) {
                    var r,
                        a,
                        s,
                        c,
                        l = t.createElement("div"),
                        u = t.body,
                        d = u || t.createElement("body");
                    if (parseInt(n, 10)) for (; n--; ) ((s = t.createElement("div")).id = o ? o[n] : p + (n + 1)), l.appendChild(s);
                    return (
                        (r = ["&#173;", '<style id="s', p, '">', e, "</style>"].join("")),
                        (l.id = p),
                        ((u ? l : d).innerHTML += r),
                        d.appendChild(l),
                        u || ((d.style.background = ""), (d.style.overflow = "hidden"), (c = h.style.overflow), (h.style.overflow = "hidden"), h.appendChild(d)),
                        (a = i(l, e)),
                        u ? l.parentNode.removeChild(l) : (d.parentNode.removeChild(d), (h.style.overflow = c)),
                        !!a
                    );
                },
                _ = {}.hasOwnProperty;
            for (var A in ((u =
                o(_, "undefined") || o(_.call, "undefined")
                    ? function (e, t) {
                          return t in e && o(e.constructor.prototype[t], "undefined");
                      }
                    : function (e, t) {
                          return _.call(e, t);
                      }),
            Function.prototype.bind ||
                (Function.prototype.bind = function (e) {
                    var t = this;
                    if ("function" != typeof t) throw new TypeError();
                    var i = E.call(arguments, 1),
                        n = function () {
                            if (this instanceof n) {
                                var o = function () {};
                                o.prototype = t.prototype;
                                var r = new o(),
                                    a = t.apply(r, i.concat(E.call(arguments)));
                                return Object(a) === a ? a : r;
                            }
                            return t.apply(e, i.concat(E.call(arguments)));
                        };
                    return n;
                }),
            (w.touch = function () {
                var i;
                return (
                    "ontouchstart" in e || (e.DocumentTouch && t instanceof DocumentTouch)
                        ? (i = !0)
                        : x(["@media (", y.join("touch-enabled),("), p, ")", "{#modernizr{top:9px;position:absolute}}"].join(""), function (e) {
                              i = 9 === e.offsetTop;
                          }),
                    i
                );
            }),
            (w.csstransforms = function () {
                return !!c("transform");
            }),
            (w.csstransforms3d = function () {
                var e = !!c("perspective");
                return (
                    e &&
                        "webkitPerspective" in h.style &&
                        x("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}", function (t, i) {
                            e = 9 === t.offsetLeft && 3 === t.offsetHeight;
                        }),
                    e
                );
            }),
            (w.fontface = function () {
                var e;
                return (
                    x('@font-face {font-family:"font";src:url("https://")}', function (i, n) {
                        var o = t.getElementById("smodernizr"),
                            r = o.sheet || o.styleSheet,
                            a = r ? (r.cssRules && r.cssRules[0] ? r.cssRules[0].cssText : r.cssText || "") : "";
                        e = /src/i.test(a) && 0 === a.indexOf(n.split(" ")[0]);
                    }),
                    e
                );
            }),
            w))
                u(w, A) && ((l = A.toLowerCase()), (d[l] = w[A]()), S.push((d[l] ? "" : "no-") + l));
            return (
                (d.addTest = function (e, t) {
                    if ("object" == typeof e) for (var n in e) u(e, n) && d.addTest(n, e[n]);
                    else {
                        if (((e = e.toLowerCase()), d[e] !== i)) return d;
                        (t = "function" == typeof t ? t() : t), (h.className += " supports-" + (t ? "" : "no-") + e), (d[e] = t);
                    }
                    return d;
                }),
                n(""),
                (f = null),
                (d._version = "2.8.2"),
                (d._prefixes = y),
                (d._domPrefixes = b),
                (d._cssomPrefixes = g),
                (d.testProp = function (e) {
                    return a([e]);
                }),
                (d.testAllProps = c),
                (d.testStyles = x),
                (h.className = h.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + " supports-js supports-" + S.join(" supports-")),
                d
            );
        })(this, this.document);
    })(),
    (function (e) {
        var t;
        if (("function" == typeof define && define.amd && (define(e), (t = !0)), "object" == typeof exports && ((module.exports = e()), (t = !0)), !t)) {
            var i = window.Cookies,
                n = (window.Cookies = e());
            n.noConflict = function () {
                return (window.Cookies = i), n;
            };
        }
    })(function () {
        function e() {
            for (var e = 0, t = {}; e < arguments.length; e++) {
                var i = arguments[e];
                for (var n in i) t[n] = i[n];
            }
            return t;
        }
        function t(e) {
            return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
        }
        return (function i(n) {
            function o() {}
            function r(t, i, r) {
                if ("undefined" != typeof document) {
                    "number" == typeof (r = e({ path: "/" }, o.defaults, r)).expires && (r.expires = new Date(1 * new Date() + 864e5 * r.expires)), (r.expires = r.expires ? r.expires.toUTCString() : "");
                    try {
                        var a = JSON.stringify(i);
                        /^[\{\[]/.test(a) && (i = a);
                    } catch (e) {}
                    (i = n.write ? n.write(i, t) : encodeURIComponent(String(i)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent)),
                        (t = encodeURIComponent(String(t))
                            .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
                            .replace(/[\(\)]/g, escape));
                    var s = "";
                    for (var c in r) r[c] && ((s += "; " + c), !0 !== r[c] && (s += "=" + r[c].split(";")[0]));
                    return (document.cookie = t + "=" + i + s);
                }
            }
            function a(e, i) {
                if ("undefined" != typeof document) {
                    for (var o = {}, r = document.cookie ? document.cookie.split("; ") : [], a = 0; a < r.length; a++) {
                        var s = r[a].split("="),
                            c = s.slice(1).join("=");
                        i || '"' !== c.charAt(0) || (c = c.slice(1, -1));
                        try {
                            var l = t(s[0]);
                            if (((c = (n.read || n)(c, l) || t(c)), i))
                                try {
                                    c = JSON.parse(c);
                                } catch (e) {}
                            if (((o[l] = c), e === l)) break;
                        } catch (e) {}
                    }
                    return e ? o[e] : o;
                }
            }
            return (
                (o.set = r),
                (o.get = function (e) {
                    return a(e, !1);
                }),
                (o.getJSON = function (e) {
                    return a(e, !0);
                }),
                (o.remove = function (t, i) {
                    r(t, "", e(i, { expires: -1 }));
                }),
                (o.defaults = {}),
                (o.withConverter = i),
                o
            );
        })(function () {});
    }),
    (function () {
        (function () {
            function e(e, t) {
                for (var i = -1, n = t.length, o = e.length; ++i < n; ) e[o + i] = t[i];
                return e;
            }
            function t(e, t, i) {
                for (var n = -1, o = e.length; ++n < o; ) {
                    var r = e[n],
                        a = t(r);
                    if (null != a && (s === ee ? a == a : i(a, s)))
                        var s = a,
                            c = r;
                }
                return c;
            }
            function i(e, t, i, n, o) {
                return (
                    o(e, function (e, o, r) {
                        i = n ? ((n = !1), e) : t(i, e, o, r);
                    }),
                    i
                );
            }
            function n(e) {
                return e && e.Object === Object ? e : null;
            }
            function o(e) {
                return oe[e];
            }
            function r(e) {
                var t = !1;
                if (null != e && "function" != typeof e.toString)
                    try {
                        t = !!(e + "");
                    } catch (e) {}
                return t;
            }
            function a(e, t) {
                return (e = "number" == typeof e || ne.test(e) ? +e : -1) > -1 && 0 == e % 1 && (null == t ? 9007199254740991 : t) > e;
            }
            function s(e) {
                if (W(e) && !Pe(e)) {
                    if (e instanceof c) return e;
                    if (me.call(e, "__wrapped__")) {
                        var t = new c(e.__wrapped__, e.__chain__);
                        return (t.__actions__ = x(e.__actions__)), t;
                    }
                }
                return new c(e);
            }
            function c(e, t) {
                (this.__wrapped__ = e), (this.__actions__ = []), (this.__chain__ = !!t);
            }
            function l(e, t, i, n) {
                var o;
                return (o = e === ee) || (o = (e === (o = fe[i]) || (e != e && o != o)) && !me.call(n, i)), o ? t : e;
            }
            function u(e) {
                return B(e) ? Se(e) : {};
            }
            function d(e, t, i) {
                if ("function" != typeof e) throw new TypeError("Expected a function");
                return setTimeout(function () {
                    e.apply(ee, i);
                }, t);
            }
            function h(e, t) {
                var i = [];
                return (
                    Le(e, function (e, n, o) {
                        t(e, n, o) && i.push(e);
                    }),
                    i
                );
            }
            function p(t, i, n, o) {
                o || (o = []);
                for (var r = -1, a = t.length; ++r < a; ) {
                    var s = t[r];
                    i > 0 && W(s) && H(s) && (n || Pe(s) || N(s)) ? (i > 1 ? p(s, i - 1, n, o) : e(o, s)) : n || (o[o.length] = s);
                }
                return o;
            }
            function f(e, t) {
                return e && Ce(e, t, X);
            }
            function m(e, t) {
                return h(t, function (t) {
                    return U(e[t]);
                });
            }
            function y(e, t, i, n, o) {
                return (
                    e === t ||
                    (null == e || null == t || (!B(e) && !W(t))
                        ? e != e && t != t
                        : (function (e, t, i, n, o, a) {
                              var s = Pe(e),
                                  c = Pe(t),
                                  l = "[object Array]",
                                  u = "[object Array]";
                              s || ("[object Arguments]" == (l = ve.call(e)) && (l = "[object Object]")), c || ("[object Arguments]" == (u = ve.call(t)) && (u = "[object Object]"));
                              var d = "[object Object]" == l && !r(e);
                              c = "[object Object]" == u && !r(t);
                              return !(u = l == u) || s || d
                                  ? 2 & o || ((l = d && me.call(e, "__wrapped__")), (c = c && me.call(t, "__wrapped__")), !l && !c)
                                      ? !!u &&
                                        (a || (a = []),
                                        (l = P(a, function (t) {
                                            return t[0] === e;
                                        })) && l[1]
                                            ? l[1] == t
                                            : (a.push([e, t]), (t = (s ? k : q)(e, t, i, n, o, a)), a.pop(), t))
                                      : i(l ? e.value() : e, c ? t.value() : t, n, o, a)
                                  : (function (e, t, i) {
                                        switch (i) {
                                            case "[object Boolean]":
                                            case "[object Date]":
                                                return +e == +t;
                                            case "[object Error]":
                                                return e.name == t.name && e.message == t.message;
                                            case "[object Number]":
                                                return e != +e ? t != +t : e == +t;
                                            case "[object RegExp]":
                                            case "[object String]":
                                                return e == t + "";
                                        }
                                        return !1;
                                    })(e, t, l);
                          })(e, t, y, i, n, o))
                );
            }
            function v(e) {
                var t = typeof e;
                return "function" == t ? e : null == e ? J : ("object" == t ? w : S)(e);
            }
            function g(e) {
                e = null == e ? e : Object(e);
                var t,
                    i = [];
                for (t in e) i.push(t);
                return i;
            }
            function b(e, t) {
                var i = -1,
                    n = H(e) ? Array(e.length) : [];
                return (
                    Le(e, function (e, o, r) {
                        n[++i] = t(e, o, r);
                    }),
                    n
                );
            }
            function w(e) {
                var t = X(e);
                return function (i) {
                    var n = t.length;
                    if (null == i) return !n;
                    for (i = Object(i); n--; ) {
                        var o = t[n];
                        if (!(o in i) || !y(e[o], i[o], ee, 3)) return !1;
                    }
                    return !0;
                };
            }
            function S(e) {
                return function (t) {
                    return null == t ? ee : t[e];
                };
            }
            function E(e, t, i) {
                var n = -1,
                    o = e.length;
                for (0 > t && (t = -t > o ? 0 : o + t), 0 > (i = i > o ? o : i) && (i += o), o = t > i ? 0 : (i - t) >>> 0, t >>>= 0, i = Array(o); ++n < o; ) i[n] = e[n + t];
                return i;
            }
            function x(e) {
                return E(e, 0, e.length);
            }
            function _(e, t) {
                var i;
                return (
                    Le(e, function (e, n, o) {
                        return !(i = t(e, n, o));
                    }),
                    !!i
                );
            }
            function A(e, t, i, n) {
                i || (i = {});
                for (var o = -1, r = t.length; ++o < r; ) {
                    var a = t[o],
                        s = n ? n(i[a], e[a], a, i, e) : e[a],
                        c = i,
                        l = c[a];
                    (me.call(c, a) && (l === s || (l != l && s != s)) && (s !== ee || a in c)) || (c[a] = s);
                }
                return i;
            }
            function L(e) {
                return F(function (t, i) {
                    var n = -1,
                        o = i.length,
                        r = "function" == typeof (r = o > 1 ? i[o - 1] : ee) ? (o--, r) : ee;
                    for (t = Object(t); ++n < o; ) {
                        var a = i[n];
                        a && e(t, a, n, r);
                    }
                    return t;
                });
            }
            function C(e, t, i) {
                if ("function" != typeof e) throw new TypeError("Expected a function");
                var n = (function (e) {
                    return function () {
                        var t = arguments,
                            i = u(e.prototype);
                        return B((t = e.apply(i, t))) ? t : i;
                    };
                })(e);
                return function o() {
                    for (var r = -1, a = arguments.length, s = -1, c = i.length, l = Array(c + a), u = this && this !== he && this instanceof o ? n : e; ++s < c; ) l[s] = i[s];
                    for (; a--; ) l[s++] = arguments[++r];
                    return u.apply(t, l);
                };
            }
            function k(e, t, i, n, o, r) {
                var a = -1,
                    s = 1 & o,
                    c = e.length,
                    l = t.length;
                if (c != l && !(2 & o && l > c)) return !1;
                for (l = !0; ++a < c; ) {
                    var u = e[a],
                        d = t[a];
                    if (s) {
                        if (
                            !_(t, function (e) {
                                return u === e || i(u, e, n, o, r);
                            })
                        ) {
                            l = !1;
                            break;
                        }
                    } else if (u !== d && !i(u, d, n, o, r)) {
                        l = !1;
                        break;
                    }
                }
                return l;
            }
            function q(e, t, i, n, o, r) {
                var a = 2 & o,
                    s = X(e),
                    c = s.length,
                    l = X(t).length;
                if (c != l && !a) return !1;
                for (var u = c; u--; ) {
                    var d = s[u];
                    if (!(a ? d in t : me.call(t, d))) return !1;
                }
                for (l = !0; ++u < c; ) {
                    var h = e[(d = s[u])],
                        p = t[d];
                    if (h !== p && !i(h, p, n, o, r)) {
                        l = !1;
                        break;
                    }
                    a || (a = "constructor" == d);
                }
                return l && !a && (i = e.constructor) != (n = t.constructor) && "constructor" in e && "constructor" in t && !("function" == typeof i && i instanceof i && "function" == typeof n && n instanceof n) && (l = !1), l;
            }
            function I(e) {
                var t = e ? e.length : ee;
                if (R(t) && (Pe(e) || G(e) || N(e))) {
                    e = String;
                    for (var i = -1, n = Array(t); ++i < t; ) n[i] = e(i);
                    t = n;
                } else t = null;
                return t;
            }
            function T(e) {
                var t;
                return e === (t = (U((t = e && e.constructor)) && t.prototype) || fe);
            }
            function D(e) {
                return e ? e[0] : ee;
            }
            function P(e, t) {
                return (function (e, t, i) {
                    var n;
                    return (
                        i(e, function (e, i, o) {
                            return t(e, i, o) ? ((n = e), !1) : void 0;
                        }),
                        n
                    );
                })(e, v(t), Le);
            }
            function j(e, t) {
                return Le(e, "function" == typeof t ? t : J);
            }
            function M(e, t, n) {
                return i(e, v(t), n, 3 > arguments.length, Le);
            }
            function z(e, t) {
                var i;
                if ("function" != typeof t) throw new TypeError("Expected a function");
                return (
                    (e = je(e)),
                    function () {
                        return 0 < --e && (i = t.apply(this, arguments)), 1 >= e && (t = ee), i;
                    }
                );
            }
            function F(e) {
                var t;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                return (
                    (t = Ae(t === ee ? e.length - 1 : je(t), 0)),
                    function () {
                        for (var i = arguments, n = -1, o = Ae(i.length - t, 0), r = Array(o); ++n < o; ) r[n] = i[t + n];
                        for (o = Array(t + 1), n = -1; ++n < t; ) o[n] = i[n];
                        return (o[t] = r), e.apply(this, o);
                    }
                );
            }
            function O(e, t) {
                return e > t;
            }
            function N(e) {
                return W(e) && H(e) && me.call(e, "callee") && (!Ee.call(e, "callee") || "[object Arguments]" == ve.call(e));
            }
            function H(e) {
                return null != e && !("function" == typeof e && U(e)) && R(ke(e));
            }
            function U(e) {
                return "[object Function]" == (e = B(e) ? ve.call(e) : "") || "[object GeneratorFunction]" == e;
            }
            function R(e) {
                return "number" == typeof e && e > -1 && 0 == e % 1 && 9007199254740991 >= e;
            }
            function B(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function W(e) {
                return !!e && "object" == typeof e;
            }
            function V(e) {
                return "number" == typeof e || (W(e) && "[object Number]" == ve.call(e));
            }
            function G(e) {
                return "string" == typeof e || (!Pe(e) && W(e) && "[object String]" == ve.call(e));
            }
            function $(e, t) {
                return t > e;
            }
            function Z(e) {
                return "string" == typeof e ? e : null == e ? "" : e + "";
            }
            function X(e) {
                var t = T(e);
                if (!t && !H(e)) return _e(Object(e));
                var i,
                    n,
                    o = !!(n = I(e)),
                    r = (n = n || []).length;
                for (i in e) !me.call(e, i) || (o && ("length" == i || a(i, r))) || (t && "constructor" == i) || n.push(i);
                return n;
            }
            function Y(e) {
                for (var t, i = -1, n = T(e), o = g(e), r = o.length, s = !!(t = I(e)), c = (t = t || []).length; ++i < r; ) {
                    var l = o[i];
                    (s && ("length" == l || a(l, c))) || ("constructor" == l && (n || !me.call(e, l))) || t.push(l);
                }
                return t;
            }
            function K(e) {
                return e
                    ? (function (e, t) {
                          return b(t, function (t) {
                              return e[t];
                          });
                      })(e, X(e))
                    : [];
            }
            function J(e) {
                return e;
            }
            function Q(t, i, n) {
                var o = X(i),
                    r = m(i, o);
                null != n || (B(i) && (r.length || !o.length)) || ((n = i), (i = t), (t = this), (r = m(i, X(i))));
                var a = !B(n) || !("chain" in n) || n.chain,
                    s = U(t);
                return (
                    Le(r, function (n) {
                        var o = i[n];
                        (t[n] = o),
                            s &&
                                (t.prototype[n] = function () {
                                    var i = this.__chain__;
                                    if (a || i) {
                                        var n = t(this.__wrapped__);
                                        return (n.__actions__ = x(this.__actions__)).push({ func: o, args: arguments, thisArg: t }), (n.__chain__ = i), n;
                                    }
                                    return o.apply(t, e([this.value()], arguments));
                                });
                    }),
                    t
                );
            }
            var ee,
                te = /[&<>"'`]/g,
                ie = RegExp(te.source),
                ne = /^(?:0|[1-9]\d*)$/,
                oe = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;" },
                re = { function: !0, object: !0 },
                ae = re[typeof exports] && exports && !exports.nodeType ? exports : ee,
                se = re[typeof module] && module && !module.nodeType ? module : ee,
                ce = se && se.exports === ae ? ae : ee,
                le = n(re[typeof self] && self),
                ue = n(re[typeof window] && window),
                de = n(re[typeof this] && this),
                he = n(ae && se && "object" == typeof global && global) || (ue !== (de && de.window) && ue) || le || de || Function("return this")(),
                pe = Array.prototype,
                fe = Object.prototype,
                me = fe.hasOwnProperty,
                ye = 0,
                ve = fe.toString,
                ge = he._,
                be = he.Reflect,
                we = be ? be.f : ee,
                Se = Object.create,
                Ee = fe.propertyIsEnumerable,
                xe = he.isFinite,
                _e = Object.keys,
                Ae = Math.max,
                Le = (function (e, t) {
                    return function (t, i) {
                        if (null == t) return t;
                        if (!H(t)) return e(t, i);
                        for (var n = t.length, o = -1, r = Object(t); ++o < n && !1 !== i(r[o], o, r); );
                        return t;
                    };
                })(f),
                Ce = function (e, t, i) {
                    for (var n = -1, o = Object(e), r = (i = i(e)).length; r--; ) {
                        var a = i[++n];
                        if (!1 === t(o[a], a, o)) break;
                    }
                    return e;
                };
            we &&
                !Ee.call({ valueOf: 1 }, "valueOf") &&
                (g = function (e) {
                    e = we(e);
                    for (var t, i = []; !(t = e.next()).done; ) i.push(t.value);
                    return i;
                });
            var ke = S("length"),
                qe = F(function (t, i) {
                    return Pe(t) || (t = null == t ? [] : [Object(t)]), p(i, 1), e(x(t), K);
                }),
                Ie = F(function (e, t, i) {
                    return C(e, t, i);
                }),
                Te = F(function (e, t) {
                    return d(e, 1, t);
                }),
                De = F(function (e, t, i) {
                    return d(e, Me(t) || 0, i);
                }),
                Pe = Array.isArray,
                je = Number,
                Me = Number,
                ze = L(function (e, t) {
                    A(t, X(t), e);
                }),
                Fe = L(function (e, t) {
                    A(t, Y(t), e);
                }),
                Oe = L(function (e, t, i, n) {
                    A(t, Y(t), e, n);
                }),
                Ne = F(function (e) {
                    return e.push(ee, l), Oe.apply(ee, e);
                }),
                He = F(function (e, t) {
                    return null == e
                        ? {}
                        : (function (e, t) {
                              return (
                                  (e = Object(e)),
                                  M(
                                      t,
                                      function (t, i) {
                                          return i in e && (t[i] = e[i]), t;
                                      },
                                      {}
                                  )
                              );
                          })(e, p(t, 1));
                }),
                Ue = v;
            (c.prototype = u(s.prototype)),
                (c.prototype.constructor = c),
                (s.assignIn = Fe),
                (s.before = z),
                (s.bind = Ie),
                (s.chain = function (e) {
                    return ((e = s(e)).__chain__ = !0), e;
                }),
                (s.compact = function (e) {
                    return h(e, Boolean);
                }),
                (s.concat = qe),
                (s.create = function (e, t) {
                    var i = u(e);
                    return t ? ze(i, t) : i;
                }),
                (s.defaults = Ne),
                (s.defer = Te),
                (s.delay = De),
                (s.filter = function (e, t) {
                    return h(e, v(t));
                }),
                (s.flatten = function (e) {
                    return e && e.length ? p(e, 1) : [];
                }),
                (s.flattenDeep = function (e) {
                    return e && e.length ? p(e, Infinity) : [];
                }),
                (s.iteratee = Ue),
                (s.keys = X),
                (s.map = function (e, t) {
                    return b(e, v(t));
                }),
                (s.matches = function (e) {
                    return w(ze({}, e));
                }),
                (s.mixin = Q),
                (s.negate = function (e) {
                    if ("function" != typeof e) throw new TypeError("Expected a function");
                    return function () {
                        return !e.apply(this, arguments);
                    };
                }),
                (s.once = function (e) {
                    return z(2, e);
                }),
                (s.pick = He),
                (s.slice = function (e, t, i) {
                    var n = e ? e.length : 0;
                    return (i = i === ee ? n : +i), n ? E(e, null == t ? 0 : +t, i) : [];
                }),
                (s.sortBy = function (e, t) {
                    var i = 0;
                    return (
                        (t = v(t)),
                        b(
                            b(e, function (e, n, o) {
                                return { c: e, b: i++, a: t(e, n, o) };
                            }).sort(function (e, t) {
                                var i;
                                e: {
                                    i = e.a;
                                    var n = t.a;
                                    if (i !== n) {
                                        var o = null === i,
                                            r = i === ee,
                                            a = i == i,
                                            s = null === n,
                                            c = n === ee,
                                            l = n == n;
                                        if ((i > n && !s) || !a || (o && !c && l) || (r && l)) {
                                            i = 1;
                                            break e;
                                        }
                                        if ((n > i && !o) || !l || (s && !r && a) || (c && a)) {
                                            i = -1;
                                            break e;
                                        }
                                    }
                                    i = 0;
                                }
                                return i || e.b - t.b;
                            }),
                            S("c")
                        )
                    );
                }),
                (s.tap = function (e, t) {
                    return t(e), e;
                }),
                (s.thru = function (e, t) {
                    return t(e);
                }),
                (s.toArray = function (e) {
                    return H(e) ? (e.length ? x(e) : []) : K(e);
                }),
                (s.values = K),
                (s.extend = Fe),
                Q(s, s),
                (s.clone = function (e) {
                    return B(e) ? (Pe(e) ? x(e) : A(e, X(e))) : e;
                }),
                (s.escape = function (e) {
                    return (e = Z(e)) && ie.test(e) ? e.replace(te, o) : e;
                }),
                (s.every = function (e, t, i) {
                    return (function (e, t) {
                        var i = !0;
                        return (
                            Le(e, function (e, n, o) {
                                return (i = !!t(e, n, o));
                            }),
                            i
                        );
                    })(e, v((t = i ? ee : t)));
                }),
                (s.find = P),
                (s.forEach = j),
                (s.has = function (e, t) {
                    return null != e && me.call(e, t);
                }),
                (s.head = D),
                (s.identity = J),
                (s.indexOf = function (e, t, i) {
                    var n = e ? e.length : 0;
                    i = ((i = "number" == typeof i ? (0 > i ? Ae(n + i, 0) : i) : 0) || 0) - 1;
                    for (var o = t == t; ++i < n; ) {
                        var r = e[i];
                        if (o ? r === t : r != r) return i;
                    }
                    return -1;
                }),
                (s.isArguments = N),
                (s.isArray = Pe),
                (s.isBoolean = function (e) {
                    return !0 === e || !1 === e || (W(e) && "[object Boolean]" == ve.call(e));
                }),
                (s.isDate = function (e) {
                    return W(e) && "[object Date]" == ve.call(e);
                }),
                (s.isEmpty = function (e) {
                    if (H(e) && (Pe(e) || G(e) || U(e.splice) || N(e))) return !e.length;
                    for (var t in e) if (me.call(e, t)) return !1;
                    return !0;
                }),
                (s.isEqual = function (e, t) {
                    return y(e, t);
                }),
                (s.isFinite = function (e) {
                    return "number" == typeof e && xe(e);
                }),
                (s.isFunction = U),
                (s.isNaN = function (e) {
                    return V(e) && e != +e;
                }),
                (s.isNull = function (e) {
                    return null === e;
                }),
                (s.isNumber = V),
                (s.isObject = B),
                (s.isRegExp = function (e) {
                    return B(e) && "[object RegExp]" == ve.call(e);
                }),
                (s.isString = G),
                (s.isUndefined = function (e) {
                    return e === ee;
                }),
                (s.last = function (e) {
                    var t = e ? e.length : 0;
                    return t ? e[t - 1] : ee;
                }),
                (s.max = function (e) {
                    return e && e.length ? t(e, J, O) : ee;
                }),
                (s.min = function (e) {
                    return e && e.length ? t(e, J, $) : ee;
                }),
                (s.noConflict = function () {
                    return he._ === this && (he._ = ge), this;
                }),
                (s.noop = function () {}),
                (s.reduce = M),
                (s.result = function (e, t, i) {
                    return (t = null == e ? ee : e[t]) === ee && (t = i), U(t) ? t.call(e) : t;
                }),
                (s.size = function (e) {
                    return null == e ? 0 : (e = H(e) ? e : X(e)).length;
                }),
                (s.some = function (e, t, i) {
                    return _(e, v((t = i ? ee : t)));
                }),
                (s.uniqueId = function (e) {
                    var t = ++ye;
                    return Z(e) + t;
                }),
                (s.each = j),
                (s.first = D),
                Q(
                    s,
                    (function () {
                        var e = {};
                        return (
                            f(s, function (t, i) {
                                me.call(s.prototype, i) || (e[i] = t);
                            }),
                            e
                        );
                    })(),
                    { chain: !1 }
                ),
                (s.VERSION = "4.5.1"),
                Le("pop join replace reverse split push shift sort splice unshift".split(" "), function (e) {
                    var t = (/^(?:replace|split)$/.test(e) ? String.prototype : pe)[e],
                        i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                        n = /^(?:pop|join|replace|shift)$/.test(e);
                    s.prototype[e] = function () {
                        var e = arguments;
                        return n && !this.__chain__
                            ? t.apply(this.value(), e)
                            : this[i](function (i) {
                                  return t.apply(i, e);
                              });
                    };
                }),
                (s.prototype.toJSON = s.prototype.valueOf = s.prototype.value = function () {
                    return (function (t, i) {
                        return M(
                            i,
                            function (t, i) {
                                return i.func.apply(i.thisArg, e([t], i.args));
                            },
                            t
                        );
                    })(this.__wrapped__, this.__actions__);
                }),
                ((ue || le || {})._ = s),
                "function" == typeof define && "object" == typeof define.amd && define.amd
                    ? define(function () {
                          return s;
                      })
                    : ae && se
                    ? (ce && ((se.exports = s)._ = s), (ae._ = s))
                    : (he._ = s);
        }.call(this));
    })(),
    (function () {
        /*!
         * Flickity PACKAGED v2.3.0
         * Touch, responsive, flickable carousels
         *
         * Licensed GPLv3 for open source use
         * or Flickity Commercial License for commercial use
         *
         * https://flickity.metafizzy.co
         * Copyright 2015-2021 Metafizzy
         */
        var e, t, i, n;
        (e = window),
            (t = function (e, t) {
                "use strict";
                var i = Array.prototype.slice,
                    n = e.console,
                    o =
                        void 0 === n
                            ? function () {}
                            : function (e) {
                                  n.error(e);
                              };
                function r(n, r, s) {
                    function c(e, t, i) {
                        var r,
                            a = "$()." + n + '("' + t + '")';
                        return (
                            e.each(function (e, c) {
                                var l = s.data(c, n);
                                if (l) {
                                    var u = l[t];
                                    if (u && "_" != t.charAt(0)) {
                                        var d = u.apply(l, i);
                                        r = void 0 === r ? d : r;
                                    } else o(a + " is not a valid method");
                                } else o(n + " not initialized. Cannot call methods, i.e. " + a);
                            }),
                            void 0 !== r ? r : e
                        );
                    }
                    function l(e, t) {
                        e.each(function (e, i) {
                            var o = s.data(i, n);
                            o ? (o.option(t), o._init()) : ((o = new r(i, t)), s.data(i, n, o));
                        });
                    }
                    (s = s || t || e.jQuery) &&
                        (r.prototype.option ||
                            (r.prototype.option = function (e) {
                                s.isPlainObject(e) && (this.options = s.extend(!0, this.options, e));
                            }),
                        (s.fn[n] = function (e) {
                            if ("string" == typeof e) {
                                var t = i.call(arguments, 1);
                                return c(this, e, t);
                            }
                            return l(this, e), this;
                        }),
                        a(s));
                }
                function a(e) {
                    !e || (e && e.bridget) || (e.bridget = r);
                }
                return a(t || e.jQuery), r;
            }),
            "function" == typeof define && define.amd
                ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
                      return t(e, i);
                  })
                : "object" == typeof module && module.exports
                ? (module.exports = t(e, require("jquery")))
                : (e.jQueryBridget = t(e, e.jQuery)),
            (function (e, t) {
                "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.EvEmitter = t());
            })("undefined" != typeof window ? window : this, function () {
                function e() {}
                var t = e.prototype;
                return (
                    (t.on = function (e, t) {
                        if (e && t) {
                            var i = (this._events = this._events || {}),
                                n = (i[e] = i[e] || []);
                            return -1 == n.indexOf(t) && n.push(t), this;
                        }
                    }),
                    (t.once = function (e, t) {
                        if (e && t) {
                            this.on(e, t);
                            var i = (this._onceEvents = this._onceEvents || {});
                            return ((i[e] = i[e] || {})[t] = !0), this;
                        }
                    }),
                    (t.off = function (e, t) {
                        var i = this._events && this._events[e];
                        if (i && i.length) {
                            var n = i.indexOf(t);
                            return -1 != n && i.splice(n, 1), this;
                        }
                    }),
                    (t.emitEvent = function (e, t) {
                        var i = this._events && this._events[e];
                        if (i && i.length) {
                            (i = i.slice(0)), (t = t || []);
                            for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
                                var r = i[o];
                                n && n[r] && (this.off(e, r), delete n[r]), r.apply(this, t);
                            }
                            return this;
                        }
                    }),
                    (t.allOff = function () {
                        delete this._events, delete this._onceEvents;
                    }),
                    e
                );
            }),
            /*!
             * getSize v2.0.3
             * measure size of elements
             * MIT license
             */
            (function (e, t) {
                "function" == typeof define && define.amd ? define("get-size/get-size", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.getSize = t());
            })(window, function () {
                "use strict";
                function e(e) {
                    var t = parseFloat(e);
                    return -1 == e.indexOf("%") && !isNaN(t) && t;
                }
                var t =
                        "undefined" == typeof console
                            ? function () {}
                            : function (e) {
                                  console.error(e);
                              },
                    i = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
                    n = i.length;
                function o(e) {
                    var i = getComputedStyle(e);
                    return i || t("Style returned " + i + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), i;
                }
                var r,
                    a = !1;
                function s() {
                    if (!a) {
                        a = !0;
                        var t = document.createElement("div");
                        (t.style.width = "200px"), (t.style.padding = "1px 2px 3px 4px"), (t.style.borderStyle = "solid"), (t.style.borderWidth = "1px 2px 3px 4px"), (t.style.boxSizing = "border-box");
                        var i = document.body || document.documentElement;
                        i.appendChild(t);
                        var n = o(t);
                        (r = 200 == Math.round(e(n.width))), (c.isBoxSizeOuter = r), i.removeChild(t);
                    }
                }
                function c(t) {
                    if ((s(), "string" == typeof t && (t = document.querySelector(t)), t && "object" == typeof t && t.nodeType)) {
                        var a = o(t);
                        if ("none" == a.display)
                            return (function () {
                                for (var e = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, t = 0; t < n; t++) e[i[t]] = 0;
                                return e;
                            })();
                        var c = {};
                        (c.width = t.offsetWidth), (c.height = t.offsetHeight);
                        for (var l = (c.isBorderBox = "border-box" == a.boxSizing), u = 0; u < n; u++) {
                            var d = i[u],
                                h = a[d],
                                p = parseFloat(h);
                            c[d] = isNaN(p) ? 0 : p;
                        }
                        var f = c.paddingLeft + c.paddingRight,
                            m = c.paddingTop + c.paddingBottom,
                            y = c.marginLeft + c.marginRight,
                            v = c.marginTop + c.marginBottom,
                            g = c.borderLeftWidth + c.borderRightWidth,
                            b = c.borderTopWidth + c.borderBottomWidth,
                            w = l && r,
                            S = e(a.width);
                        !1 !== S && (c.width = S + (w ? 0 : f + g));
                        var E = e(a.height);
                        return !1 !== E && (c.height = E + (w ? 0 : m + b)), (c.innerWidth = c.width - (f + g)), (c.innerHeight = c.height - (m + b)), (c.outerWidth = c.width + y), (c.outerHeight = c.height + v), c;
                    }
                }
                return c;
            }),
            (function (e, t) {
                "use strict";
                "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.matchesSelector = t());
            })(window, function () {
                "use strict";
                var e = (function () {
                    var e = window.Element.prototype;
                    if (e.matches) return "matches";
                    if (e.matchesSelector) return "matchesSelector";
                    for (var t = ["webkit", "moz", "ms", "o"], i = 0; i < t.length; i++) {
                        var n = t[i] + "MatchesSelector";
                        if (e[n]) return n;
                    }
                })();
                return function (t, i) {
                    return t[e](i);
                };
            }),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (i) {
                          return t(e, i);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("desandro-matches-selector")))
                    : (e.fizzyUIUtils = t(e, e.matchesSelector));
            })(window, function (e, t) {
                var i = {
                        extend: function (e, t) {
                            for (var i in t) e[i] = t[i];
                            return e;
                        },
                        modulo: function (e, t) {
                            return ((e % t) + t) % t;
                        },
                    },
                    n = Array.prototype.slice;
                (i.makeArray = function (e) {
                    return Array.isArray(e) ? e : null == e ? [] : "object" == typeof e && "number" == typeof e.length ? n.call(e) : [e];
                }),
                    (i.removeFrom = function (e, t) {
                        var i = e.indexOf(t);
                        -1 != i && e.splice(i, 1);
                    }),
                    (i.getParent = function (e, i) {
                        for (; e.parentNode && e != document.body; ) if (((e = e.parentNode), t(e, i))) return e;
                    }),
                    (i.getQueryElement = function (e) {
                        return "string" == typeof e ? document.querySelector(e) : e;
                    }),
                    (i.handleEvent = function (e) {
                        var t = "on" + e.type;
                        this[t] && this[t](e);
                    }),
                    (i.filterFindElements = function (e, n) {
                        e = i.makeArray(e);
                        var o = [];
                        return (
                            e.forEach(function (e) {
                                if (e instanceof HTMLElement)
                                    if (n) {
                                        t(e, n) && o.push(e);
                                        for (var i = e.querySelectorAll(n), r = 0; r < i.length; r++) o.push(i[r]);
                                    } else o.push(e);
                            }),
                            o
                        );
                    }),
                    (i.debounceMethod = function (e, t, i) {
                        i = i || 100;
                        var n = e.prototype[t],
                            o = t + "Timeout";
                        e.prototype[t] = function () {
                            var e = this[o];
                            clearTimeout(e);
                            var t = arguments,
                                r = this;
                            this[o] = setTimeout(function () {
                                n.apply(r, t), delete r[o];
                            }, i);
                        };
                    }),
                    (i.docReady = function (e) {
                        var t = document.readyState;
                        "complete" == t || "interactive" == t ? setTimeout(e) : document.addEventListener("DOMContentLoaded", e);
                    }),
                    (i.toDashed = function (e) {
                        return e
                            .replace(/(.)([A-Z])/g, function (e, t, i) {
                                return t + "-" + i;
                            })
                            .toLowerCase();
                    });
                var o = e.console;
                return (
                    (i.htmlInit = function (t, n) {
                        i.docReady(function () {
                            var r = i.toDashed(n),
                                a = "data-" + r,
                                s = document.querySelectorAll("[" + a + "]"),
                                c = document.querySelectorAll(".js-" + r),
                                l = i.makeArray(s).concat(i.makeArray(c)),
                                u = a + "-options",
                                d = e.jQuery;
                            l.forEach(function (e) {
                                var i,
                                    r = e.getAttribute(a) || e.getAttribute(u);
                                try {
                                    i = r && JSON.parse(r);
                                } catch (r) {
                                    return void (o && o.error("Error parsing " + a + " on " + e.className + ": " + r));
                                }
                                var s = new t(e, i);
                                d && d.data(e, n, s);
                            });
                        });
                    }),
                    i
                );
            }),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("flickity/js/cell", ["get-size/get-size"], function (i) {
                          return t(e, i);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("get-size")))
                    : ((e.Flickity = e.Flickity || {}), (e.Flickity.Cell = t(e, e.getSize)));
            })(window, function (e, t) {
                function i(e, t) {
                    (this.element = e), (this.parent = t), this.create();
                }
                var n = i.prototype;
                return (
                    (n.create = function () {
                        (this.element.style.position = "absolute"), this.element.setAttribute("aria-hidden", "true"), (this.x = 0), (this.shift = 0), (this.element.style[this.parent.originSide] = 0);
                    }),
                    (n.destroy = function () {
                        this.unselect(), (this.element.style.position = "");
                        var e = this.parent.originSide;
                        (this.element.style[e] = ""), (this.element.style.transform = ""), this.element.removeAttribute("aria-hidden");
                    }),
                    (n.getSize = function () {
                        this.size = t(this.element);
                    }),
                    (n.setPosition = function (e) {
                        (this.x = e), this.updateTarget(), this.renderPosition(e);
                    }),
                    (n.updateTarget = n.setDefaultTarget = function () {
                        var e = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
                        this.target = this.x + this.size[e] + this.size.width * this.parent.cellAlign;
                    }),
                    (n.renderPosition = function (e) {
                        var t = "left" === this.parent.originSide ? 1 : -1,
                            i = this.parent.options.percentPosition ? e * t * (this.parent.size.innerWidth / this.size.width) : e * t;
                        this.element.style.transform = "translateX(" + this.parent.getPositionValue(i) + ")";
                    }),
                    (n.select = function () {
                        this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden");
                    }),
                    (n.unselect = function () {
                        this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true");
                    }),
                    (n.wrapShift = function (e) {
                        (this.shift = e), this.renderPosition(this.x + this.parent.slideableWidth * e);
                    }),
                    (n.remove = function () {
                        this.element.parentNode.removeChild(this.element);
                    }),
                    i
                );
            }),
            (function (e, t) {
                "function" == typeof define && define.amd ? define("flickity/js/slide", t) : "object" == typeof module && module.exports ? (module.exports = t()) : ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = t()));
            })(window, function () {
                "use strict";
                function e(e) {
                    (this.parent = e), (this.isOriginLeft = "left" == e.originSide), (this.cells = []), (this.outerWidth = 0), (this.height = 0);
                }
                var t = e.prototype;
                return (
                    (t.addCell = function (e) {
                        if ((this.cells.push(e), (this.outerWidth += e.size.outerWidth), (this.height = Math.max(e.size.outerHeight, this.height)), 1 == this.cells.length)) {
                            this.x = e.x;
                            var t = this.isOriginLeft ? "marginLeft" : "marginRight";
                            this.firstMargin = e.size[t];
                        }
                    }),
                    (t.updateTarget = function () {
                        var e = this.isOriginLeft ? "marginRight" : "marginLeft",
                            t = this.getLastCell(),
                            i = t ? t.size[e] : 0,
                            n = this.outerWidth - (this.firstMargin + i);
                        this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
                    }),
                    (t.getLastCell = function () {
                        return this.cells[this.cells.length - 1];
                    }),
                    (t.select = function () {
                        this.cells.forEach(function (e) {
                            e.select();
                        });
                    }),
                    (t.unselect = function () {
                        this.cells.forEach(function (e) {
                            e.unselect();
                        });
                    }),
                    (t.getCellElements = function () {
                        return this.cells.map(function (e) {
                            return e.element;
                        });
                    }),
                    e
                );
            }),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (i) {
                          return t(e, i);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("fizzy-ui-utils")))
                    : ((e.Flickity = e.Flickity || {}), (e.Flickity.animatePrototype = t(e, e.fizzyUIUtils)));
            })(window, function (e, t) {
                var i = {
                    startAnimation: function () {
                        this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
                    },
                    animate: function () {
                        this.applyDragForce(), this.applySelectedAttraction();
                        var e = this.x;
                        if ((this.integratePhysics(), this.positionSlider(), this.settle(e), this.isAnimating)) {
                            var t = this;
                            requestAnimationFrame(function () {
                                t.animate();
                            });
                        }
                    },
                    positionSlider: function () {
                        var e = this.x;
                        this.options.wrapAround && this.cells.length > 1 && ((e = t.modulo(e, this.slideableWidth)), (e -= this.slideableWidth), this.shiftWrapCells(e)), this.setTranslateX(e, this.isAnimating), this.dispatchScrollEvent();
                    },
                    setTranslateX: function (e, t) {
                        (e += this.cursorPosition), (e = this.options.rightToLeft ? -e : e);
                        var i = this.getPositionValue(e);
                        this.slider.style.transform = t ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")";
                    },
                    dispatchScrollEvent: function () {
                        var e = this.slides[0];
                        if (e) {
                            var t = -this.x - e.target,
                                i = t / this.slidesWidth;
                            this.dispatchEvent("scroll", null, [i, t]);
                        }
                    },
                    positionSliderAtSelected: function () {
                        this.cells.length && ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
                    },
                    getPositionValue: function (e) {
                        return this.options.percentPosition ? 0.01 * Math.round((e / this.size.innerWidth) * 1e4) + "%" : Math.round(e) + "px";
                    },
                    settle: function (e) {
                        !this.isPointerDown && Math.round(100 * this.x) == Math.round(100 * e) && this.restingFrames++,
                            this.restingFrames > 2 && ((this.isAnimating = !1), delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]));
                    },
                    shiftWrapCells: function (e) {
                        var t = this.cursorPosition + e;
                        this._shiftCells(this.beforeShiftCells, t, -1);
                        var i = this.size.innerWidth - (e + this.slideableWidth + this.cursorPosition);
                        this._shiftCells(this.afterShiftCells, i, 1);
                    },
                    _shiftCells: function (e, t, i) {
                        for (var n = 0; n < e.length; n++) {
                            var o = e[n],
                                r = t > 0 ? i : 0;
                            o.wrapShift(r), (t -= o.size.outerWidth);
                        }
                    },
                    _unshiftCells: function (e) {
                        if (e && e.length) for (var t = 0; t < e.length; t++) e[t].wrapShift(0);
                    },
                    integratePhysics: function () {
                        (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
                    },
                    applyForce: function (e) {
                        this.velocity += e;
                    },
                    getFrictionFactor: function () {
                        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
                    },
                    getRestingPosition: function () {
                        return this.x + this.velocity / (1 - this.getFrictionFactor());
                    },
                    applyDragForce: function () {
                        if (this.isDraggable && this.isPointerDown) {
                            var e = this.dragX - this.x - this.velocity;
                            this.applyForce(e);
                        }
                    },
                    applySelectedAttraction: function () {
                        if (!(this.isDraggable && this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                            var e = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                            this.applyForce(e);
                        }
                    },
                };
                return i;
            }),
            (function (e, t) {
                if ("function" == typeof define && define.amd)
                    define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function (i, n, o, r, a, s) {
                        return t(e, i, n, o, r, a, s);
                    });
                else if ("object" == typeof module && module.exports) module.exports = t(e, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
                else {
                    var i = e.Flickity;
                    e.Flickity = t(e, e.EvEmitter, e.getSize, e.fizzyUIUtils, i.Cell, i.Slide, i.animatePrototype);
                }
            })(window, function (e, t, i, n, o, r, a) {
                var s = e.jQuery,
                    c = e.getComputedStyle,
                    l = e.console;
                function u(e, t) {
                    for (e = n.makeArray(e); e.length; ) t.appendChild(e.shift());
                }
                var d = 0,
                    h = {};
                function p(e, t) {
                    var i = n.getQueryElement(e);
                    if (i) {
                        if (((this.element = i), this.element.flickityGUID)) {
                            var o = h[this.element.flickityGUID];
                            return o && o.option(t), o;
                        }
                        s && (this.$element = s(this.element)), (this.options = n.extend({}, this.constructor.defaults)), this.option(t), this._create();
                    } else l && l.error("Bad element for Flickity: " + (i || e));
                }
                (p.defaults = { accessibility: !0, cellAlign: "center", freeScrollFriction: 0.075, friction: 0.28, namespaceJQueryEvents: !0, percentPosition: !0, resize: !0, selectedAttraction: 0.025, setGallerySize: !0 }),
                    (p.createMethods = []);
                var f = p.prototype;
                n.extend(f, t.prototype),
                    (f._create = function () {
                        var t = (this.guid = ++d);
                        for (var i in ((this.element.flickityGUID = t),
                        (h[t] = this),
                        (this.selectedIndex = 0),
                        (this.restingFrames = 0),
                        (this.x = 0),
                        (this.velocity = 0),
                        (this.originSide = this.options.rightToLeft ? "right" : "left"),
                        (this.viewport = document.createElement("div")),
                        (this.viewport.className = "flickity-viewport"),
                        this._createSlider(),
                        (this.options.resize || this.options.watchCSS) && e.addEventListener("resize", this),
                        this.options.on)) {
                            var n = this.options.on[i];
                            this.on(i, n);
                        }
                        p.createMethods.forEach(function (e) {
                            this[e]();
                        }, this),
                            this.options.watchCSS ? this.watchCSS() : this.activate();
                    }),
                    (f.option = function (e) {
                        n.extend(this.options, e);
                    }),
                    (f.activate = function () {
                        this.isActive ||
                            ((this.isActive = !0),
                            this.element.classList.add("flickity-enabled"),
                            this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
                            this.getSize(),
                            u(this._filterFindCellElements(this.element.children), this.slider),
                            this.viewport.appendChild(this.slider),
                            this.element.appendChild(this.viewport),
                            this.reloadCells(),
                            this.options.accessibility && ((this.element.tabIndex = 0), this.element.addEventListener("keydown", this)),
                            this.emitEvent("activate"),
                            this.selectInitialIndex(),
                            (this.isInitActivated = !0),
                            this.dispatchEvent("ready"));
                    }),
                    (f._createSlider = function () {
                        var e = document.createElement("div");
                        (e.className = "flickity-slider"), (e.style[this.originSide] = 0), (this.slider = e);
                    }),
                    (f._filterFindCellElements = function (e) {
                        return n.filterFindElements(e, this.options.cellSelector);
                    }),
                    (f.reloadCells = function () {
                        (this.cells = this._makeCells(this.slider.children)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize();
                    }),
                    (f._makeCells = function (e) {
                        return this._filterFindCellElements(e).map(function (e) {
                            return new o(e, this);
                        }, this);
                    }),
                    (f.getLastCell = function () {
                        return this.cells[this.cells.length - 1];
                    }),
                    (f.getLastSlide = function () {
                        return this.slides[this.slides.length - 1];
                    }),
                    (f.positionCells = function () {
                        this._sizeCells(this.cells), this._positionCells(0);
                    }),
                    (f._positionCells = function (e) {
                        (e = e || 0), (this.maxCellHeight = (e && this.maxCellHeight) || 0);
                        var t = 0;
                        if (e > 0) {
                            var i = this.cells[e - 1];
                            t = i.x + i.size.outerWidth;
                        }
                        for (var n = this.cells.length, o = e; o < n; o++) {
                            var r = this.cells[o];
                            r.setPosition(t), (t += r.size.outerWidth), (this.maxCellHeight = Math.max(r.size.outerHeight, this.maxCellHeight));
                        }
                        (this.slideableWidth = t), this.updateSlides(), this._containSlides(), (this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0);
                    }),
                    (f._sizeCells = function (e) {
                        e.forEach(function (e) {
                            e.getSize();
                        });
                    }),
                    (f.updateSlides = function () {
                        if (((this.slides = []), this.cells.length)) {
                            var e = new r(this);
                            this.slides.push(e);
                            var t = "left" == this.originSide ? "marginRight" : "marginLeft",
                                i = this._getCanCellFit();
                            this.cells.forEach(function (n, o) {
                                if (e.cells.length) {
                                    var a = e.outerWidth - e.firstMargin + (n.size.outerWidth - n.size[t]);
                                    i.call(this, o, a) || (e.updateTarget(), (e = new r(this)), this.slides.push(e)), e.addCell(n);
                                } else e.addCell(n);
                            }, this),
                                e.updateTarget(),
                                this.updateSelectedSlide();
                        }
                    }),
                    (f._getCanCellFit = function () {
                        var e = this.options.groupCells;
                        if (!e)
                            return function () {
                                return !1;
                            };
                        if ("number" == typeof e) {
                            var t = parseInt(e, 10);
                            return function (e) {
                                return e % t != 0;
                            };
                        }
                        var i = "string" == typeof e && e.match(/^(\d+)%$/),
                            n = i ? parseInt(i[1], 10) / 100 : 1;
                        return function (e, t) {
                            return t <= (this.size.innerWidth + 1) * n;
                        };
                    }),
                    (f._init = f.reposition = function () {
                        this.positionCells(), this.positionSliderAtSelected();
                    }),
                    (f.getSize = function () {
                        (this.size = i(this.element)), this.setCellAlign(), (this.cursorPosition = this.size.innerWidth * this.cellAlign);
                    });
                var m = { center: { left: 0.5, right: 0.5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } };
                return (
                    (f.setCellAlign = function () {
                        var e = m[this.options.cellAlign];
                        this.cellAlign = e ? e[this.originSide] : this.options.cellAlign;
                    }),
                    (f.setGallerySize = function () {
                        if (this.options.setGallerySize) {
                            var e = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                            this.viewport.style.height = e + "px";
                        }
                    }),
                    (f._getWrapShiftCells = function () {
                        if (this.options.wrapAround) {
                            this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                            var e = this.cursorPosition,
                                t = this.cells.length - 1;
                            (this.beforeShiftCells = this._getGapCells(e, t, -1)), (e = this.size.innerWidth - this.cursorPosition), (this.afterShiftCells = this._getGapCells(e, 0, 1));
                        }
                    }),
                    (f._getGapCells = function (e, t, i) {
                        for (var n = []; e > 0; ) {
                            var o = this.cells[t];
                            if (!o) break;
                            n.push(o), (t += i), (e -= o.size.outerWidth);
                        }
                        return n;
                    }),
                    (f._containSlides = function () {
                        if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                            var e = this.options.rightToLeft,
                                t = e ? "marginRight" : "marginLeft",
                                i = e ? "marginLeft" : "marginRight",
                                n = this.slideableWidth - this.getLastCell().size[i],
                                o = n < this.size.innerWidth,
                                r = this.cursorPosition + this.cells[0].size[t],
                                a = n - this.size.innerWidth * (1 - this.cellAlign);
                            this.slides.forEach(function (e) {
                                o ? (e.target = n * this.cellAlign) : ((e.target = Math.max(e.target, r)), (e.target = Math.min(e.target, a)));
                            }, this);
                        }
                    }),
                    (f.dispatchEvent = function (e, t, i) {
                        var n = t ? [t].concat(i) : i;
                        if ((this.emitEvent(e, n), s && this.$element)) {
                            var o = (e += this.options.namespaceJQueryEvents ? ".flickity" : "");
                            if (t) {
                                var r = new s.Event(t);
                                (r.type = e), (o = r);
                            }
                            this.$element.trigger(o, i);
                        }
                    }),
                    (f.select = function (e, t, i) {
                        if (this.isActive && ((e = parseInt(e, 10)), this._wrapSelect(e), (this.options.wrapAround || t) && (e = n.modulo(e, this.slides.length)), this.slides[e])) {
                            var o = this.selectedIndex;
                            (this.selectedIndex = e),
                                this.updateSelectedSlide(),
                                i ? this.positionSliderAtSelected() : this.startAnimation(),
                                this.options.adaptiveHeight && this.setGallerySize(),
                                this.dispatchEvent("select", null, [e]),
                                e != o && this.dispatchEvent("change", null, [e]),
                                this.dispatchEvent("cellSelect");
                        }
                    }),
                    (f._wrapSelect = function (e) {
                        var t = this.slides.length;
                        if (!(this.options.wrapAround && t > 1)) return e;
                        var i = n.modulo(e, t),
                            o = Math.abs(i - this.selectedIndex),
                            r = Math.abs(i + t - this.selectedIndex),
                            a = Math.abs(i - t - this.selectedIndex);
                        !this.isDragSelect && r < o ? (e += t) : !this.isDragSelect && a < o && (e -= t), e < 0 ? (this.x -= this.slideableWidth) : e >= t && (this.x += this.slideableWidth);
                    }),
                    (f.previous = function (e, t) {
                        this.select(this.selectedIndex - 1, e, t);
                    }),
                    (f.next = function (e, t) {
                        this.select(this.selectedIndex + 1, e, t);
                    }),
                    (f.updateSelectedSlide = function () {
                        var e = this.slides[this.selectedIndex];
                        e &&
                            (this.unselectSelectedSlide(),
                            (this.selectedSlide = e),
                            e.select(),
                            (this.selectedCells = e.cells),
                            (this.selectedElements = e.getCellElements()),
                            (this.selectedCell = e.cells[0]),
                            (this.selectedElement = this.selectedElements[0]));
                    }),
                    (f.unselectSelectedSlide = function () {
                        this.selectedSlide && this.selectedSlide.unselect();
                    }),
                    (f.selectInitialIndex = function () {
                        var e = this.options.initialIndex;
                        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
                        else {
                            if (e && "string" == typeof e) if (this.queryCell(e)) return void this.selectCell(e, !1, !0);
                            var t = 0;
                            e && this.slides[e] && (t = e), this.select(t, !1, !0);
                        }
                    }),
                    (f.selectCell = function (e, t, i) {
                        var n = this.queryCell(e);
                        if (n) {
                            var o = this.getCellSlideIndex(n);
                            this.select(o, t, i);
                        }
                    }),
                    (f.getCellSlideIndex = function (e) {
                        for (var t = 0; t < this.slides.length; t++) {
                            if (-1 != this.slides[t].cells.indexOf(e)) return t;
                        }
                    }),
                    (f.getCell = function (e) {
                        for (var t = 0; t < this.cells.length; t++) {
                            var i = this.cells[t];
                            if (i.element == e) return i;
                        }
                    }),
                    (f.getCells = function (e) {
                        e = n.makeArray(e);
                        var t = [];
                        return (
                            e.forEach(function (e) {
                                var i = this.getCell(e);
                                i && t.push(i);
                            }, this),
                            t
                        );
                    }),
                    (f.getCellElements = function () {
                        return this.cells.map(function (e) {
                            return e.element;
                        });
                    }),
                    (f.getParentCell = function (e) {
                        var t = this.getCell(e);
                        return t || ((e = n.getParent(e, ".flickity-slider > *")), this.getCell(e));
                    }),
                    (f.getAdjacentCellElements = function (e, t) {
                        if (!e) return this.selectedSlide.getCellElements();
                        t = void 0 === t ? this.selectedIndex : t;
                        var i = this.slides.length;
                        if (1 + 2 * e >= i) return this.getCellElements();
                        for (var o = [], r = t - e; r <= t + e; r++) {
                            var a = this.options.wrapAround ? n.modulo(r, i) : r,
                                s = this.slides[a];
                            s && (o = o.concat(s.getCellElements()));
                        }
                        return o;
                    }),
                    (f.queryCell = function (e) {
                        if ("number" == typeof e) return this.cells[e];
                        if ("string" == typeof e) {
                            if (e.match(/^[#.]?[\d/]/)) return;
                            e = this.element.querySelector(e);
                        }
                        return this.getCell(e);
                    }),
                    (f.uiChange = function () {
                        this.emitEvent("uiChange");
                    }),
                    (f.childUIPointerDown = function (e) {
                        "touchstart" != e.type && e.preventDefault(), this.focus();
                    }),
                    (f.onresize = function () {
                        this.watchCSS(), this.resize();
                    }),
                    n.debounceMethod(p, "onresize", 150),
                    (f.resize = function () {
                        if (this.isActive && !this.isAnimating && !this.isDragging) {
                            this.getSize(), this.options.wrapAround && (this.x = n.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                            var e = this.selectedElements && this.selectedElements[0];
                            this.selectCell(e, !1, !0);
                        }
                    }),
                    (f.watchCSS = function () {
                        this.options.watchCSS && (-1 != c(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate());
                    }),
                    (f.onkeydown = function (e) {
                        var t = document.activeElement && document.activeElement != this.element;
                        if (this.options.accessibility && !t) {
                            var i = p.keyboardHandlers[e.keyCode];
                            i && i.call(this);
                        }
                    }),
                    (p.keyboardHandlers = {
                        37: function () {
                            var e = this.options.rightToLeft ? "next" : "previous";
                            this.uiChange(), this[e]();
                        },
                        39: function () {
                            var e = this.options.rightToLeft ? "previous" : "next";
                            this.uiChange(), this[e]();
                        },
                    }),
                    (f.focus = function () {
                        var t = e.pageYOffset;
                        this.element.focus({ preventScroll: !0 }), e.pageYOffset != t && e.scrollTo(e.pageXOffset, t);
                    }),
                    (f.deactivate = function () {
                        this.isActive &&
                            (this.element.classList.remove("flickity-enabled"),
                            this.element.classList.remove("flickity-rtl"),
                            this.unselectSelectedSlide(),
                            this.cells.forEach(function (e) {
                                e.destroy();
                            }),
                            this.element.removeChild(this.viewport),
                            u(this.slider.children, this.element),
                            this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)),
                            (this.isActive = !1),
                            this.emitEvent("deactivate"));
                    }),
                    (f.destroy = function () {
                        this.deactivate(), e.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), s && this.$element && s.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete h[this.guid];
                    }),
                    n.extend(f, a),
                    (p.data = function (e) {
                        var t = (e = n.getQueryElement(e)) && e.flickityGUID;
                        return t && h[t];
                    }),
                    n.htmlInit(p, "flickity"),
                    s && s.bridget && s.bridget("flickity", p),
                    (p.setJQuery = function (e) {
                        s = e;
                    }),
                    (p.Cell = o),
                    (p.Slide = r),
                    p
                );
            }),
            /*!
             * Unipointer v2.4.0
             * base class for doing one thing with pointer event
             * MIT license
             */
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function (i) {
                          return t(e, i);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("ev-emitter")))
                    : (e.Unipointer = t(e, e.EvEmitter));
            })(window, function (e, t) {
                function i() {}
                var n = (i.prototype = Object.create(t.prototype));
                (n.bindStartEvent = function (e) {
                    this._bindStartEvent(e, !0);
                }),
                    (n.unbindStartEvent = function (e) {
                        this._bindStartEvent(e, !1);
                    }),
                    (n._bindStartEvent = function (t, i) {
                        var n = (i = void 0 === i || i) ? "addEventListener" : "removeEventListener",
                            o = "mousedown";
                        "ontouchstart" in e ? (o = "touchstart") : e.PointerEvent && (o = "pointerdown"), t[n](o, this);
                    }),
                    (n.handleEvent = function (e) {
                        var t = "on" + e.type;
                        this[t] && this[t](e);
                    }),
                    (n.getTouch = function (e) {
                        for (var t = 0; t < e.length; t++) {
                            var i = e[t];
                            if (i.identifier == this.pointerIdentifier) return i;
                        }
                    }),
                    (n.onmousedown = function (e) {
                        var t = e.button;
                        (t && 0 !== t && 1 !== t) || this._pointerDown(e, e);
                    }),
                    (n.ontouchstart = function (e) {
                        this._pointerDown(e, e.changedTouches[0]);
                    }),
                    (n.onpointerdown = function (e) {
                        this._pointerDown(e, e);
                    }),
                    (n._pointerDown = function (e, t) {
                        e.button || this.isPointerDown || ((this.isPointerDown = !0), (this.pointerIdentifier = void 0 !== t.pointerId ? t.pointerId : t.identifier), this.pointerDown(e, t));
                    }),
                    (n.pointerDown = function (e, t) {
                        this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t]);
                    });
                var o = { mousedown: ["mousemove", "mouseup"], touchstart: ["touchmove", "touchend", "touchcancel"], pointerdown: ["pointermove", "pointerup", "pointercancel"] };
                return (
                    (n._bindPostStartEvents = function (t) {
                        if (t) {
                            var i = o[t.type];
                            i.forEach(function (t) {
                                e.addEventListener(t, this);
                            }, this),
                                (this._boundPointerEvents = i);
                        }
                    }),
                    (n._unbindPostStartEvents = function () {
                        this._boundPointerEvents &&
                            (this._boundPointerEvents.forEach(function (t) {
                                e.removeEventListener(t, this);
                            }, this),
                            delete this._boundPointerEvents);
                    }),
                    (n.onmousemove = function (e) {
                        this._pointerMove(e, e);
                    }),
                    (n.onpointermove = function (e) {
                        e.pointerId == this.pointerIdentifier && this._pointerMove(e, e);
                    }),
                    (n.ontouchmove = function (e) {
                        var t = this.getTouch(e.changedTouches);
                        t && this._pointerMove(e, t);
                    }),
                    (n._pointerMove = function (e, t) {
                        this.pointerMove(e, t);
                    }),
                    (n.pointerMove = function (e, t) {
                        this.emitEvent("pointerMove", [e, t]);
                    }),
                    (n.onmouseup = function (e) {
                        this._pointerUp(e, e);
                    }),
                    (n.onpointerup = function (e) {
                        e.pointerId == this.pointerIdentifier && this._pointerUp(e, e);
                    }),
                    (n.ontouchend = function (e) {
                        var t = this.getTouch(e.changedTouches);
                        t && this._pointerUp(e, t);
                    }),
                    (n._pointerUp = function (e, t) {
                        this._pointerDone(), this.pointerUp(e, t);
                    }),
                    (n.pointerUp = function (e, t) {
                        this.emitEvent("pointerUp", [e, t]);
                    }),
                    (n._pointerDone = function () {
                        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
                    }),
                    (n._pointerReset = function () {
                        (this.isPointerDown = !1), delete this.pointerIdentifier;
                    }),
                    (n.pointerDone = function () {}),
                    (n.onpointercancel = function (e) {
                        e.pointerId == this.pointerIdentifier && this._pointerCancel(e, e);
                    }),
                    (n.ontouchcancel = function (e) {
                        var t = this.getTouch(e.changedTouches);
                        t && this._pointerCancel(e, t);
                    }),
                    (n._pointerCancel = function (e, t) {
                        this._pointerDone(), this.pointerCancel(e, t);
                    }),
                    (n.pointerCancel = function (e, t) {
                        this.emitEvent("pointerCancel", [e, t]);
                    }),
                    (i.getPointerPoint = function (e) {
                        return { x: e.pageX, y: e.pageY };
                    }),
                    i
                );
            }),
            /*!
             * Unidragger v2.4.0
             * Draggable base class
             * MIT license
             */
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("unidragger/unidragger", ["unipointer/unipointer"], function (i) {
                          return t(e, i);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("unipointer")))
                    : (e.Unidragger = t(e, e.Unipointer));
            })(window, function (e, t) {
                function i() {}
                var n = (i.prototype = Object.create(t.prototype));
                (n.bindHandles = function () {
                    this._bindHandles(!0);
                }),
                    (n.unbindHandles = function () {
                        this._bindHandles(!1);
                    }),
                    (n._bindHandles = function (t) {
                        for (var i = (t = void 0 === t || t) ? "addEventListener" : "removeEventListener", n = t ? this._touchActionValue : "", o = 0; o < this.handles.length; o++) {
                            var r = this.handles[o];
                            this._bindStartEvent(r, t), r[i]("click", this), e.PointerEvent && (r.style.touchAction = n);
                        }
                    }),
                    (n._touchActionValue = "none"),
                    (n.pointerDown = function (e, t) {
                        this.okayPointerDown(e) && ((this.pointerDownPointer = { pageX: t.pageX, pageY: t.pageY }), e.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t]));
                    });
                var o = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
                    r = { radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0 };
                return (
                    (n.okayPointerDown = function (e) {
                        var t = o[e.target.nodeName],
                            i = r[e.target.type],
                            n = !t || i;
                        return n || this._pointerReset(), n;
                    }),
                    (n.pointerDownBlur = function () {
                        var e = document.activeElement;
                        e && e.blur && e != document.body && e.blur();
                    }),
                    (n.pointerMove = function (e, t) {
                        var i = this._dragPointerMove(e, t);
                        this.emitEvent("pointerMove", [e, t, i]), this._dragMove(e, t, i);
                    }),
                    (n._dragPointerMove = function (e, t) {
                        var i = { x: t.pageX - this.pointerDownPointer.pageX, y: t.pageY - this.pointerDownPointer.pageY };
                        return !this.isDragging && this.hasDragStarted(i) && this._dragStart(e, t), i;
                    }),
                    (n.hasDragStarted = function (e) {
                        return Math.abs(e.x) > 3 || Math.abs(e.y) > 3;
                    }),
                    (n.pointerUp = function (e, t) {
                        this.emitEvent("pointerUp", [e, t]), this._dragPointerUp(e, t);
                    }),
                    (n._dragPointerUp = function (e, t) {
                        this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t);
                    }),
                    (n._dragStart = function (e, t) {
                        (this.isDragging = !0), (this.isPreventingClicks = !0), this.dragStart(e, t);
                    }),
                    (n.dragStart = function (e, t) {
                        this.emitEvent("dragStart", [e, t]);
                    }),
                    (n._dragMove = function (e, t, i) {
                        this.isDragging && this.dragMove(e, t, i);
                    }),
                    (n.dragMove = function (e, t, i) {
                        e.preventDefault(), this.emitEvent("dragMove", [e, t, i]);
                    }),
                    (n._dragEnd = function (e, t) {
                        (this.isDragging = !1),
                            setTimeout(
                                function () {
                                    delete this.isPreventingClicks;
                                }.bind(this)
                            ),
                            this.dragEnd(e, t);
                    }),
                    (n.dragEnd = function (e, t) {
                        this.emitEvent("dragEnd", [e, t]);
                    }),
                    (n.onclick = function (e) {
                        this.isPreventingClicks && e.preventDefault();
                    }),
                    (n._staticClick = function (e, t) {
                        (this.isIgnoringMouseUp && "mouseup" == e.type) ||
                            (this.staticClick(e, t),
                            "mouseup" != e.type &&
                                ((this.isIgnoringMouseUp = !0),
                                setTimeout(
                                    function () {
                                        delete this.isIgnoringMouseUp;
                                    }.bind(this),
                                    400
                                )));
                    }),
                    (n.staticClick = function (e, t) {
                        this.emitEvent("staticClick", [e, t]);
                    }),
                    (i.getPointerPoint = t.getPointerPoint),
                    i
                );
            }),
            (i = window),
            (n = function (e, t, i, n) {
                n.extend(t.defaults, { draggable: ">1", dragThreshold: 3 }), t.createMethods.push("_createDrag");
                var o = t.prototype;
                n.extend(o, i.prototype),
                    (o._touchActionValue = "pan-y"),
                    (o._createDrag = function () {
                        this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable);
                    }),
                    (o.onActivateDrag = function () {
                        (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
                    }),
                    (o.onDeactivateDrag = function () {
                        this.unbindHandles(), this.element.classList.remove("is-draggable");
                    }),
                    (o.updateDraggable = function () {
                        ">1" == this.options.draggable ? (this.isDraggable = this.slides.length > 1) : (this.isDraggable = this.options.draggable),
                            this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable");
                    }),
                    (o.bindDrag = function () {
                        (this.options.draggable = !0), this.updateDraggable();
                    }),
                    (o.unbindDrag = function () {
                        (this.options.draggable = !1), this.updateDraggable();
                    }),
                    (o._uiChangeDrag = function () {
                        delete this.isFreeScrolling;
                    }),
                    (o.pointerDown = function (t, i) {
                        this.isDraggable
                            ? this.okayPointerDown(t) &&
                              (this._pointerDownPreventDefault(t),
                              this.pointerDownFocus(t),
                              document.activeElement != this.element && this.pointerDownBlur(),
                              (this.dragX = this.x),
                              this.viewport.classList.add("is-pointer-down"),
                              (this.pointerDownScroll = a()),
                              e.addEventListener("scroll", this),
                              this._pointerDownDefault(t, i))
                            : this._pointerDownDefault(t, i);
                    }),
                    (o._pointerDownDefault = function (e, t) {
                        (this.pointerDownPointer = { pageX: t.pageX, pageY: t.pageY }), this._bindPostStartEvents(e), this.dispatchEvent("pointerDown", e, [t]);
                    });
                var r = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
                function a() {
                    return { x: e.pageXOffset, y: e.pageYOffset };
                }
                return (
                    (o.pointerDownFocus = function (e) {
                        r[e.target.nodeName] || this.focus();
                    }),
                    (o._pointerDownPreventDefault = function (e) {
                        var t = "touchstart" == e.type,
                            i = "touch" == e.pointerType,
                            n = r[e.target.nodeName];
                        t || i || n || e.preventDefault();
                    }),
                    (o.hasDragStarted = function (e) {
                        return Math.abs(e.x) > this.options.dragThreshold;
                    }),
                    (o.pointerUp = function (e, t) {
                        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", e, [t]), this._dragPointerUp(e, t);
                    }),
                    (o.pointerDone = function () {
                        e.removeEventListener("scroll", this), delete this.pointerDownScroll;
                    }),
                    (o.dragStart = function (t, i) {
                        this.isDraggable && ((this.dragStartPosition = this.x), this.startAnimation(), e.removeEventListener("scroll", this), this.dispatchEvent("dragStart", t, [i]));
                    }),
                    (o.pointerMove = function (e, t) {
                        var i = this._dragPointerMove(e, t);
                        this.dispatchEvent("pointerMove", e, [t, i]), this._dragMove(e, t, i);
                    }),
                    (o.dragMove = function (e, t, i) {
                        if (this.isDraggable) {
                            e.preventDefault(), (this.previousDragX = this.dragX);
                            var n = this.options.rightToLeft ? -1 : 1;
                            this.options.wrapAround && (i.x %= this.slideableWidth);
                            var o = this.dragStartPosition + i.x * n;
                            if (!this.options.wrapAround && this.slides.length) {
                                var r = Math.max(-this.slides[0].target, this.dragStartPosition);
                                o = o > r ? 0.5 * (o + r) : o;
                                var a = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                                o = o < a ? 0.5 * (o + a) : o;
                            }
                            (this.dragX = o), (this.dragMoveTime = new Date()), this.dispatchEvent("dragMove", e, [t, i]);
                        }
                    }),
                    (o.dragEnd = function (e, t) {
                        if (this.isDraggable) {
                            this.options.freeScroll && (this.isFreeScrolling = !0);
                            var i = this.dragEndRestingSelect();
                            if (this.options.freeScroll && !this.options.wrapAround) {
                                var n = this.getRestingPosition();
                                this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target;
                            } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
                            delete this.previousDragX, (this.isDragSelect = this.options.wrapAround), this.select(i), delete this.isDragSelect, this.dispatchEvent("dragEnd", e, [t]);
                        }
                    }),
                    (o.dragEndRestingSelect = function () {
                        var e = this.getRestingPosition(),
                            t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
                            i = this._getClosestResting(e, t, 1),
                            n = this._getClosestResting(e, t, -1);
                        return i.distance < n.distance ? i.index : n.index;
                    }),
                    (o._getClosestResting = function (e, t, i) {
                        for (
                            var n = this.selectedIndex,
                                o = 1 / 0,
                                r =
                                    this.options.contain && !this.options.wrapAround
                                        ? function (e, t) {
                                              return e <= t;
                                          }
                                        : function (e, t) {
                                              return e < t;
                                          };
                            r(t, o) && ((n += i), (o = t), null !== (t = this.getSlideDistance(-e, n)));

                        )
                            t = Math.abs(t);
                        return { distance: o, index: n - i };
                    }),
                    (o.getSlideDistance = function (e, t) {
                        var i = this.slides.length,
                            o = this.options.wrapAround && i > 1,
                            r = o ? n.modulo(t, i) : t,
                            a = this.slides[r];
                        if (!a) return null;
                        var s = o ? this.slideableWidth * Math.floor(t / i) : 0;
                        return e - (a.target + s);
                    }),
                    (o.dragEndBoostSelect = function () {
                        if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
                        var e = this.getSlideDistance(-this.dragX, this.selectedIndex),
                            t = this.previousDragX - this.dragX;
                        return e > 0 && t > 0 ? 1 : e < 0 && t < 0 ? -1 : 0;
                    }),
                    (o.staticClick = function (e, t) {
                        var i = this.getParentCell(e.target),
                            n = i && i.element,
                            o = i && this.cells.indexOf(i);
                        this.dispatchEvent("staticClick", e, [t, n, o]);
                    }),
                    (o.onscroll = function () {
                        var e = a(),
                            t = this.pointerDownScroll.x - e.x,
                            i = this.pointerDownScroll.y - e.y;
                        (Math.abs(t) > 3 || Math.abs(i) > 3) && this._pointerDone();
                    }),
                    t
                );
            }),
            "function" == typeof define && define.amd
                ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function (e, t, o) {
                      return n(i, e, t, o);
                  })
                : "object" == typeof module && module.exports
                ? (module.exports = n(i, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")))
                : (i.Flickity = n(i, i.Flickity, i.Unidragger, i.fizzyUIUtils)),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("flickity/js/prev-next-button", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (i, n, o) {
                          return t(e, i, n, o);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")))
                    : t(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
            })(window, function (e, t, i, n) {
                "use strict";
                var o = "http://www.w3.org/2000/svg";
                function r(e, t) {
                    (this.direction = e), (this.parent = t), this._create();
                }
                (r.prototype = Object.create(i.prototype)),
                    (r.prototype._create = function () {
                        (this.isEnabled = !0), (this.isPrevious = -1 == this.direction);
                        var e = this.parent.options.rightToLeft ? 1 : -1;
                        this.isLeft = this.direction == e;
                        var t = (this.element = document.createElement("button"));
                        (t.className = "flickity-button flickity-prev-next-button"),
                            (t.className += this.isPrevious ? " previous" : " next"),
                            t.setAttribute("type", "button"),
                            this.disable(),
                            t.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                        var i = this.createSVG();
                        t.appendChild(i), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
                    }),
                    (r.prototype.activate = function () {
                        this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element);
                    }),
                    (r.prototype.deactivate = function () {
                        this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this);
                    }),
                    (r.prototype.createSVG = function () {
                        var e = document.createElementNS(o, "svg");
                        e.setAttribute("class", "flickity-button-icon"), e.setAttribute("viewBox", "0 0 100 100");
                        var t = document.createElementNS(o, "path"),
                            i = (function (e) {
                                if ("string" == typeof e) return e;
                                return "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z";
                            })(this.parent.options.arrowShape);
                        return t.setAttribute("d", i), t.setAttribute("class", "arrow"), this.isLeft || t.setAttribute("transform", "translate(100, 100) rotate(180) "), e.appendChild(t), e;
                    }),
                    (r.prototype.handleEvent = n.handleEvent),
                    (r.prototype.onclick = function () {
                        if (this.isEnabled) {
                            this.parent.uiChange();
                            var e = this.isPrevious ? "previous" : "next";
                            this.parent[e]();
                        }
                    }),
                    (r.prototype.enable = function () {
                        this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
                    }),
                    (r.prototype.disable = function () {
                        this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
                    }),
                    (r.prototype.update = function () {
                        var e = this.parent.slides;
                        if (this.parent.options.wrapAround && e.length > 1) this.enable();
                        else {
                            var t = e.length ? e.length - 1 : 0,
                                i = this.isPrevious ? 0 : t;
                            this[this.parent.selectedIndex == i ? "disable" : "enable"]();
                        }
                    }),
                    (r.prototype.destroy = function () {
                        this.deactivate(), this.allOff();
                    }),
                    n.extend(t.defaults, { prevNextButtons: !0, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 } }),
                    t.createMethods.push("_createPrevNextButtons");
                var a = t.prototype;
                return (
                    (a._createPrevNextButtons = function () {
                        this.options.prevNextButtons && ((this.prevButton = new r(-1, this)), (this.nextButton = new r(1, this)), this.on("activate", this.activatePrevNextButtons));
                    }),
                    (a.activatePrevNextButtons = function () {
                        this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons);
                    }),
                    (a.deactivatePrevNextButtons = function () {
                        this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons);
                    }),
                    (t.PrevNextButton = r),
                    t
                );
            }),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("flickity/js/page-dots", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (i, n, o) {
                          return t(e, i, n, o);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")))
                    : t(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
            })(window, function (e, t, i, n) {
                function o(e) {
                    (this.parent = e), this._create();
                }
                (o.prototype = Object.create(i.prototype)),
                    (o.prototype._create = function () {
                        (this.holder = document.createElement("ol")),
                            (this.holder.className = "flickity-page-dots"),
                            (this.dots = []),
                            (this.handleClick = this.onClick.bind(this)),
                            this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
                    }),
                    (o.prototype.activate = function () {
                        this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder);
                    }),
                    (o.prototype.deactivate = function () {
                        this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder);
                    }),
                    (o.prototype.setDots = function () {
                        var e = this.parent.slides.length - this.dots.length;
                        e > 0 ? this.addDots(e) : e < 0 && this.removeDots(-e);
                    }),
                    (o.prototype.addDots = function (e) {
                        for (var t = document.createDocumentFragment(), i = [], n = this.dots.length, o = n + e, r = n; r < o; r++) {
                            var a = document.createElement("li");
                            (a.className = "dot"), a.setAttribute("aria-label", "Page dot " + (r + 1)), t.appendChild(a), i.push(a);
                        }
                        this.holder.appendChild(t), (this.dots = this.dots.concat(i));
                    }),
                    (o.prototype.removeDots = function (e) {
                        this.dots.splice(this.dots.length - e, e).forEach(function (e) {
                            this.holder.removeChild(e);
                        }, this);
                    }),
                    (o.prototype.updateSelected = function () {
                        this.selectedDot && ((this.selectedDot.className = "dot"), this.selectedDot.removeAttribute("aria-current")),
                            this.dots.length && ((this.selectedDot = this.dots[this.parent.selectedIndex]), (this.selectedDot.className = "dot is-selected"), this.selectedDot.setAttribute("aria-current", "step"));
                    }),
                    (o.prototype.onTap = o.prototype.onClick = function (e) {
                        var t = e.target;
                        if ("LI" == t.nodeName) {
                            this.parent.uiChange();
                            var i = this.dots.indexOf(t);
                            this.parent.select(i);
                        }
                    }),
                    (o.prototype.destroy = function () {
                        this.deactivate(), this.allOff();
                    }),
                    (t.PageDots = o),
                    n.extend(t.defaults, { pageDots: !0 }),
                    t.createMethods.push("_createPageDots");
                var r = t.prototype;
                return (
                    (r._createPageDots = function () {
                        this.options.pageDots &&
                            ((this.pageDots = new o(this)),
                            this.on("activate", this.activatePageDots),
                            this.on("select", this.updateSelectedPageDots),
                            this.on("cellChange", this.updatePageDots),
                            this.on("resize", this.updatePageDots),
                            this.on("deactivate", this.deactivatePageDots));
                    }),
                    (r.activatePageDots = function () {
                        this.pageDots.activate();
                    }),
                    (r.updateSelectedPageDots = function () {
                        this.pageDots.updateSelected();
                    }),
                    (r.updatePageDots = function () {
                        this.pageDots.setDots();
                    }),
                    (r.deactivatePageDots = function () {
                        this.pageDots.deactivate();
                    }),
                    (t.PageDots = o),
                    t
                );
            }),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function (e, i, n) {
                          return t(e, i, n);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")))
                    : t(e.EvEmitter, e.fizzyUIUtils, e.Flickity);
            })(window, function (e, t, i) {
                function n(e) {
                    (this.parent = e), (this.state = "stopped"), (this.onVisibilityChange = this.visibilityChange.bind(this)), (this.onVisibilityPlay = this.visibilityPlay.bind(this));
                }
                (n.prototype = Object.create(e.prototype)),
                    (n.prototype.play = function () {
                        "playing" != this.state &&
                            (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : ((this.state = "playing"), document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()));
                    }),
                    (n.prototype.tick = function () {
                        if ("playing" == this.state) {
                            var e = this.parent.options.autoPlay;
                            e = "number" == typeof e ? e : 3e3;
                            var t = this;
                            this.clear(),
                                (this.timeout = setTimeout(function () {
                                    t.parent.next(!0), t.tick();
                                }, e));
                        }
                    }),
                    (n.prototype.stop = function () {
                        (this.state = "stopped"), this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange);
                    }),
                    (n.prototype.clear = function () {
                        clearTimeout(this.timeout);
                    }),
                    (n.prototype.pause = function () {
                        "playing" == this.state && ((this.state = "paused"), this.clear());
                    }),
                    (n.prototype.unpause = function () {
                        "paused" == this.state && this.play();
                    }),
                    (n.prototype.visibilityChange = function () {
                        this[document.hidden ? "pause" : "unpause"]();
                    }),
                    (n.prototype.visibilityPlay = function () {
                        this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
                    }),
                    t.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
                    i.createMethods.push("_createPlayer");
                var o = i.prototype;
                return (
                    (o._createPlayer = function () {
                        (this.player = new n(this)), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer);
                    }),
                    (o.activatePlayer = function () {
                        this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
                    }),
                    (o.playPlayer = function () {
                        this.player.play();
                    }),
                    (o.stopPlayer = function () {
                        this.player.stop();
                    }),
                    (o.pausePlayer = function () {
                        this.player.pause();
                    }),
                    (o.unpausePlayer = function () {
                        this.player.unpause();
                    }),
                    (o.deactivatePlayer = function () {
                        this.player.stop(), this.element.removeEventListener("mouseenter", this);
                    }),
                    (o.onmouseenter = function () {
                        this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this));
                    }),
                    (o.onmouseleave = function () {
                        this.player.unpause(), this.element.removeEventListener("mouseleave", this);
                    }),
                    (i.Player = n),
                    i
                );
            }),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function (i, n) {
                          return t(e, i, n);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("./flickity"), require("fizzy-ui-utils")))
                    : t(e, e.Flickity, e.fizzyUIUtils);
            })(window, function (e, t, i) {
                var n = t.prototype;
                return (
                    (n.insert = function (e, t) {
                        var i = this._makeCells(e);
                        if (i && i.length) {
                            var n = this.cells.length;
                            t = void 0 === t ? n : t;
                            var o = (function (e) {
                                    var t = document.createDocumentFragment();
                                    return (
                                        e.forEach(function (e) {
                                            t.appendChild(e.element);
                                        }),
                                        t
                                    );
                                })(i),
                                r = t == n;
                            if (r) this.slider.appendChild(o);
                            else {
                                var a = this.cells[t].element;
                                this.slider.insertBefore(o, a);
                            }
                            if (0 === t) this.cells = i.concat(this.cells);
                            else if (r) this.cells = this.cells.concat(i);
                            else {
                                var s = this.cells.splice(t, n - t);
                                this.cells = this.cells.concat(i).concat(s);
                            }
                            this._sizeCells(i), this.cellChange(t, !0);
                        }
                    }),
                    (n.append = function (e) {
                        this.insert(e, this.cells.length);
                    }),
                    (n.prepend = function (e) {
                        this.insert(e, 0);
                    }),
                    (n.remove = function (e) {
                        var t = this.getCells(e);
                        if (t && t.length) {
                            var n = this.cells.length - 1;
                            t.forEach(function (e) {
                                e.remove();
                                var t = this.cells.indexOf(e);
                                (n = Math.min(t, n)), i.removeFrom(this.cells, e);
                            }, this),
                                this.cellChange(n, !0);
                        }
                    }),
                    (n.cellSizeChange = function (e) {
                        var t = this.getCell(e);
                        if (t) {
                            t.getSize();
                            var i = this.cells.indexOf(t);
                            this.cellChange(i);
                        }
                    }),
                    (n.cellChange = function (e, t) {
                        var i = this.selectedElement;
                        this._positionCells(e), this._getWrapShiftCells(), this.setGallerySize();
                        var n = this.getCell(i);
                        n && (this.selectedIndex = this.getCellSlideIndex(n)),
                            (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                            this.emitEvent("cellChange", [e]),
                            this.select(this.selectedIndex),
                            t && this.positionSliderAtSelected();
                    }),
                    t
                );
            }),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function (i, n) {
                          return t(e, i, n);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("./flickity"), require("fizzy-ui-utils")))
                    : t(e, e.Flickity, e.fizzyUIUtils);
            })(window, function (e, t, i) {
                "use strict";
                t.createMethods.push("_createLazyload");
                var n = t.prototype;
                function o(e, t) {
                    (this.img = e), (this.flickity = t), this.load();
                }
                return (
                    (n._createLazyload = function () {
                        this.on("select", this.lazyLoad);
                    }),
                    (n.lazyLoad = function () {
                        var e = this.options.lazyLoad;
                        if (e) {
                            var t = "number" == typeof e ? e : 0,
                                n = this.getAdjacentCellElements(t),
                                r = [];
                            n.forEach(function (e) {
                                var t = (function (e) {
                                    if ("IMG" == e.nodeName) {
                                        var t = e.getAttribute("data-flickity-lazyload"),
                                            n = e.getAttribute("data-flickity-lazyload-src"),
                                            o = e.getAttribute("data-flickity-lazyload-srcset");
                                        if (t || n || o) return [e];
                                    }
                                    var r = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                                        a = e.querySelectorAll(r);
                                    return i.makeArray(a);
                                })(e);
                                r = r.concat(t);
                            }),
                                r.forEach(function (e) {
                                    new o(e, this);
                                }, this);
                        }
                    }),
                    (o.prototype.handleEvent = i.handleEvent),
                    (o.prototype.load = function () {
                        this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                        var e = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                            t = this.img.getAttribute("data-flickity-lazyload-srcset");
                        (this.img.src = e),
                            t && this.img.setAttribute("srcset", t),
                            this.img.removeAttribute("data-flickity-lazyload"),
                            this.img.removeAttribute("data-flickity-lazyload-src"),
                            this.img.removeAttribute("data-flickity-lazyload-srcset");
                    }),
                    (o.prototype.onload = function (e) {
                        this.complete(e, "flickity-lazyloaded");
                    }),
                    (o.prototype.onerror = function (e) {
                        this.complete(e, "flickity-lazyerror");
                    }),
                    (o.prototype.complete = function (e, t) {
                        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                        var i = this.flickity.getParentCell(this.img),
                            n = i && i.element;
                        this.flickity.cellSizeChange(n), this.img.classList.add(t), this.flickity.dispatchEvent("lazyLoad", e, n);
                    }),
                    (t.LazyLoader = o),
                    t
                );
            }),
            /*!
             * Flickity v2.3.0
             * Touch, responsive, flickable carousels
             *
             * Licensed GPLv3 for open source use
             * or Flickity Commercial License for commercial use
             *
             * https://flickity.metafizzy.co
             * Copyright 2015-2021 Metafizzy
             */
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], t)
                    : "object" == typeof module &&
                      module.exports &&
                      (module.exports = t(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")));
            })(window, function (e) {
                return e;
            }),
            /*!
             * Flickity asNavFor v2.0.2
             * enable asNavFor for Flickity
             */
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], t)
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(require("flickity"), require("fizzy-ui-utils")))
                    : (e.Flickity = t(e.Flickity, e.fizzyUIUtils));
            })(window, function (e, t) {
                e.createMethods.push("_createAsNavFor");
                var i = e.prototype;
                return (
                    (i._createAsNavFor = function () {
                        this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
                        var e = this.options.asNavFor;
                        if (e) {
                            var t = this;
                            setTimeout(function () {
                                t.setNavCompanion(e);
                            });
                        }
                    }),
                    (i.setNavCompanion = function (i) {
                        i = t.getQueryElement(i);
                        var n = e.data(i);
                        if (n && n != this) {
                            this.navCompanion = n;
                            var o = this;
                            (this.onNavCompanionSelect = function () {
                                o.navCompanionSelect();
                            }),
                                n.on("select", this.onNavCompanionSelect),
                                this.on("staticClick", this.onNavStaticClick),
                                this.navCompanionSelect(!0);
                        }
                    }),
                    (i.navCompanionSelect = function (e) {
                        var t = this.navCompanion && this.navCompanion.selectedCells;
                        if (t) {
                            var i = t[0],
                                n = this.navCompanion.cells.indexOf(i),
                                o = n + t.length - 1,
                                r = Math.floor(
                                    (function (e, t, i) {
                                        return (t - e) * i + e;
                                    })(n, o, this.navCompanion.cellAlign)
                                );
                            if ((this.selectCell(r, !1, e), this.removeNavSelectedElements(), !(r >= this.cells.length))) {
                                var a = this.cells.slice(n, o + 1);
                                (this.navSelectedElements = a.map(function (e) {
                                    return e.element;
                                })),
                                    this.changeNavSelectedClass("add");
                            }
                        }
                    }),
                    (i.changeNavSelectedClass = function (e) {
                        this.navSelectedElements.forEach(function (t) {
                            t.classList[e]("is-nav-selected");
                        });
                    }),
                    (i.activateAsNavFor = function () {
                        this.navCompanionSelect(!0);
                    }),
                    (i.removeNavSelectedElements = function () {
                        this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements);
                    }),
                    (i.onNavStaticClick = function (e, t, i, n) {
                        "number" == typeof n && this.navCompanion.selectCell(n);
                    }),
                    (i.deactivateAsNavFor = function () {
                        this.removeNavSelectedElements();
                    }),
                    (i.destroyAsNavFor = function () {
                        this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion);
                    }),
                    e
                );
            }),
            /*!
             * imagesLoaded v4.1.4
             * JavaScript is all like "You images are done yet or what?"
             * MIT License
             */
            (function (e, t) {
                "use strict";
                "function" == typeof define && define.amd
                    ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function (i) {
                          return t(e, i);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("ev-emitter")))
                    : (e.imagesLoaded = t(e, e.EvEmitter));
            })("undefined" != typeof window ? window : this, function (e, t) {
                var i = e.jQuery,
                    n = e.console;
                function o(e, t) {
                    for (var i in t) e[i] = t[i];
                    return e;
                }
                var r = Array.prototype.slice;
                function a(e) {
                    return Array.isArray(e) ? e : "object" == typeof e && "number" == typeof e.length ? r.call(e) : [e];
                }
                function s(e, t, r) {
                    if (!(this instanceof s)) return new s(e, t, r);
                    var c = e;
                    "string" == typeof e && (c = document.querySelectorAll(e)),
                        c
                            ? ((this.elements = a(c)),
                              (this.options = o({}, this.options)),
                              "function" == typeof t ? (r = t) : o(this.options, t),
                              r && this.on("always", r),
                              this.getImages(),
                              i && (this.jqDeferred = new i.Deferred()),
                              setTimeout(this.check.bind(this)))
                            : n.error("Bad element for imagesLoaded " + (c || e));
                }
                (s.prototype = Object.create(t.prototype)),
                    (s.prototype.options = {}),
                    (s.prototype.getImages = function () {
                        (this.images = []), this.elements.forEach(this.addElementImages, this);
                    }),
                    (s.prototype.addElementImages = function (e) {
                        "IMG" == e.nodeName && this.addImage(e), !0 === this.options.background && this.addElementBackgroundImages(e);
                        var t = e.nodeType;
                        if (t && c[t]) {
                            for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
                                var o = i[n];
                                this.addImage(o);
                            }
                            if ("string" == typeof this.options.background) {
                                var r = e.querySelectorAll(this.options.background);
                                for (n = 0; n < r.length; n++) {
                                    var a = r[n];
                                    this.addElementBackgroundImages(a);
                                }
                            }
                        }
                    });
                var c = { 1: !0, 9: !0, 11: !0 };
                function l(e) {
                    this.img = e;
                }
                function u(e, t) {
                    (this.url = e), (this.element = t), (this.img = new Image());
                }
                return (
                    (s.prototype.addElementBackgroundImages = function (e) {
                        var t = getComputedStyle(e);
                        if (t)
                            for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n; ) {
                                var o = n && n[2];
                                o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
                            }
                    }),
                    (s.prototype.addImage = function (e) {
                        var t = new l(e);
                        this.images.push(t);
                    }),
                    (s.prototype.addBackground = function (e, t) {
                        var i = new u(e, t);
                        this.images.push(i);
                    }),
                    (s.prototype.check = function () {
                        var e = this;
                        function t(t, i, n) {
                            setTimeout(function () {
                                e.progress(t, i, n);
                            });
                        }
                        (this.progressedCount = 0),
                            (this.hasAnyBroken = !1),
                            this.images.length
                                ? this.images.forEach(function (e) {
                                      e.once("progress", t), e.check();
                                  })
                                : this.complete();
                    }),
                    (s.prototype.progress = function (e, t, i) {
                        this.progressedCount++,
                            (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
                            this.emitEvent("progress", [this, e, t]),
                            this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
                            this.progressedCount == this.images.length && this.complete(),
                            this.options.debug && n && n.log("progress: " + i, e, t);
                    }),
                    (s.prototype.complete = function () {
                        var e = this.hasAnyBroken ? "fail" : "done";
                        if (((this.isComplete = !0), this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
                            var t = this.hasAnyBroken ? "reject" : "resolve";
                            this.jqDeferred[t](this);
                        }
                    }),
                    (l.prototype = Object.create(t.prototype)),
                    (l.prototype.check = function () {
                        this.getIsImageComplete()
                            ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                            : ((this.proxyImage = new Image()),
                              this.proxyImage.addEventListener("load", this),
                              this.proxyImage.addEventListener("error", this),
                              this.img.addEventListener("load", this),
                              this.img.addEventListener("error", this),
                              (this.proxyImage.src = this.img.src));
                    }),
                    (l.prototype.getIsImageComplete = function () {
                        return this.img.complete && this.img.naturalWidth;
                    }),
                    (l.prototype.confirm = function (e, t) {
                        (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
                    }),
                    (l.prototype.handleEvent = function (e) {
                        var t = "on" + e.type;
                        this[t] && this[t](e);
                    }),
                    (l.prototype.onload = function () {
                        this.confirm(!0, "onload"), this.unbindEvents();
                    }),
                    (l.prototype.onerror = function () {
                        this.confirm(!1, "onerror"), this.unbindEvents();
                    }),
                    (l.prototype.unbindEvents = function () {
                        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                    }),
                    (u.prototype = Object.create(l.prototype)),
                    (u.prototype.check = function () {
                        this.img.addEventListener("load", this),
                            this.img.addEventListener("error", this),
                            (this.img.src = this.url),
                            this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
                    }),
                    (u.prototype.unbindEvents = function () {
                        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                    }),
                    (u.prototype.confirm = function (e, t) {
                        (this.isLoaded = e), this.emitEvent("progress", [this, this.element, t]);
                    }),
                    (s.makeJQueryPlugin = function (t) {
                        (t = t || e.jQuery) &&
                            ((i = t).fn.imagesLoaded = function (e, t) {
                                return new s(this, e, t).jqDeferred.promise(i(this));
                            });
                    }),
                    s.makeJQueryPlugin(),
                    s
                );
            }),
            /*!
             * Flickity imagesLoaded v2.0.0
             * enables imagesLoaded option for Flickity
             */
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function (i, n) {
                          return t(e, i, n);
                      })
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(e, require("flickity"), require("imagesloaded")))
                    : (e.Flickity = t(e, e.Flickity, e.imagesLoaded));
            })(window, function (e, t, i) {
                "use strict";
                t.createMethods.push("_createImagesLoaded");
                var n = t.prototype;
                return (
                    (n._createImagesLoaded = function () {
                        this.on("activate", this.imagesLoaded);
                    }),
                    (n.imagesLoaded = function () {
                        if (this.options.imagesLoaded) {
                            var e = this;
                            i(this.slider).on("progress", function (t, i) {
                                var n = e.getParentCell(i.img);
                                e.cellSizeChange(n && n.element), e.options.freeScroll || e.positionSliderAtSelected();
                            });
                        }
                    }),
                    t
                );
            }),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define(["flickity/js/index", "fizzy-ui-utils/utils"], t)
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(require("flickity"), require("fizzy-ui-utils")))
                    : t(e.Flickity, e.fizzyUIUtils);
            })(this, function (e, t) {
                var i = e.Slide,
                    n = i.prototype.updateTarget;
                (i.prototype.updateTarget = function () {
                    if ((n.apply(this, arguments), this.parent.options.fade)) {
                        var e = this.target - this.x,
                            t = this.cells[0].x;
                        this.cells.forEach(function (i) {
                            var n = i.x - t - e;
                            i.renderPosition(n);
                        });
                    }
                }),
                    (i.prototype.setOpacity = function (e) {
                        this.cells.forEach(function (t) {
                            t.element.style.opacity = e;
                        });
                    });
                var o = e.prototype;
                e.createMethods.push("_createFade"),
                    (o._createFade = function () {
                        (this.fadeIndex = this.selectedIndex),
                            (this.prevSelectedIndex = this.selectedIndex),
                            this.on("select", this.onSelectFade),
                            this.on("dragEnd", this.onDragEndFade),
                            this.on("settle", this.onSettleFade),
                            this.on("activate", this.onActivateFade),
                            this.on("deactivate", this.onDeactivateFade);
                    });
                var r = o.updateSlides;
                (o.updateSlides = function () {
                    r.apply(this, arguments),
                        this.options.fade &&
                            this.slides.forEach(function (e, t) {
                                var i = t == this.selectedIndex ? 1 : 0;
                                e.setOpacity(i);
                            }, this);
                }),
                    (o.onSelectFade = function () {
                        (this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1)), (this.prevSelectedIndex = this.selectedIndex);
                    }),
                    (o.onSettleFade = function () {
                        delete this.didDragEnd, this.options.fade && (this.selectedSlide.setOpacity(1), this.slides[this.fadeIndex] && this.fadeIndex != this.selectedIndex && this.slides[this.fadeIndex].setOpacity(0));
                    }),
                    (o.onDragEndFade = function () {
                        this.didDragEnd = !0;
                    }),
                    (o.onActivateFade = function () {
                        this.options.fade && this.element.classList.add("is-fade");
                    }),
                    (o.onDeactivateFade = function () {
                        this.options.fade &&
                            (this.element.classList.remove("is-fade"),
                            this.slides.forEach(function (e) {
                                e.setOpacity("");
                            }));
                    });
                var a = o.positionSlider;
                o.positionSlider = function () {
                    this.options.fade ? (this.fadeSlides(), this.dispatchScrollEvent()) : a.apply(this, arguments);
                };
                var s = o.positionSliderAtSelected;
                (o.positionSliderAtSelected = function () {
                    this.options.fade && this.setTranslateX(0), s.apply(this, arguments);
                }),
                    (o.fadeSlides = function () {
                        if (!(this.slides.length < 2)) {
                            var e = this.getFadeIndexes(),
                                t = this.slides[e.a],
                                i = this.slides[e.b],
                                n = this.wrapDifference(t.target, i.target),
                                o = this.wrapDifference(t.target, -this.x);
                            (o = Math.abs(o / n)), t.setOpacity(1 - o), i.setOpacity(o);
                            var r = e.a;
                            this.isDragging && (r = o > 0.5 ? e.a : e.b),
                                null != this.fadeHideIndex && this.fadeHideIndex != r && this.fadeHideIndex != e.a && this.fadeHideIndex != e.b && this.slides[this.fadeHideIndex].setOpacity(0),
                                (this.fadeHideIndex = r);
                        }
                    }),
                    (o.getFadeIndexes = function () {
                        return this.isDragging || this.didDragEnd ? (this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes()) : { a: this.fadeIndex, b: this.selectedIndex };
                    }),
                    (o.getFadeDragWrapIndexes = function () {
                        var e = this.slides.map(function (e, t) {
                                return this.getSlideDistance(-this.x, t);
                            }, this),
                            i = e.map(function (e) {
                                return Math.abs(e);
                            }),
                            n = Math.min.apply(Math, i),
                            o = i.indexOf(n),
                            r = e[o],
                            a = this.slides.length,
                            s = r >= 0 ? 1 : -1;
                        return { a: o, b: t.modulo(o + s, a) };
                    }),
                    (o.getFadeDragLimitIndexes = function () {
                        for (var e = 0, t = 0; t < this.slides.length - 1; t++) {
                            var i = this.slides[t];
                            if (-this.x < i.target) break;
                            e = t;
                        }
                        return { a: e, b: e + 1 };
                    }),
                    (o.wrapDifference = function (e, t) {
                        var i = t - e;
                        if (!this.options.wrapAround) return i;
                        var n = i + this.slideableWidth,
                            o = i - this.slideableWidth;
                        return Math.abs(n) < Math.abs(i) && (i = n), Math.abs(o) < Math.abs(i) && (i = o), i;
                    });
                var c = o._getWrapShiftCells;
                o._getWrapShiftCells = function () {
                    this.options.fade || c.apply(this, arguments);
                };
                var l = o.shiftWrapCells;
                return (
                    (o.shiftWrapCells = function () {
                        this.options.fade || l.apply(this, arguments);
                    }),
                    e
                );
            }),
            (function (e, t) {
                "function" == typeof define && define.amd
                    ? define(["flickity/js/index", "fizzy-ui-utils/utils"], t)
                    : "object" == typeof module && module.exports
                    ? (module.exports = t(require("flickity"), require("fizzy-ui-utils")))
                    : (e.Flickity = t(e.Flickity, e.fizzyUIUtils));
            })(window, function (e, t) {
                "use strict";
                return (
                    e.createMethods.push("_createSync"),
                    (e.prototype._createSync = function () {
                        this.syncers = {};
                        var e = this.options.sync;
                        if ((this.on("destroy", this.unsyncAll), e)) {
                            var t = this;
                            setTimeout(function () {
                                t.sync(e);
                            });
                        }
                    }),
                    (e.prototype.sync = function (i) {
                        i = t.getQueryElement(i);
                        var n = e.data(i);
                        n && (this._syncCompanion(n), n._syncCompanion(this));
                    }),
                    (e.prototype._syncCompanion = function (e) {
                        var t = this;
                        function i() {
                            var i = t.selectedIndex;
                            e.selectedIndex != i && e.select(i);
                        }
                        this.on("select", i), (this.syncers[e.guid] = { flickity: e, listener: i });
                    }),
                    (e.prototype.unsync = function (i) {
                        i = t.getQueryElement(i);
                        var n = e.data(i);
                        this._unsync(n);
                    }),
                    (e.prototype._unsync = function (e) {
                        e && (this._unsyncCompanion(e), e._unsyncCompanion(this));
                    }),
                    (e.prototype._unsyncCompanion = function (e) {
                        var t = e.guid,
                            i = this.syncers[t];
                        this.off("select", i.listener), delete this.syncers[t];
                    }),
                    (e.prototype.unsyncAll = function () {
                        for (var e in this.syncers) {
                            var t = this.syncers[e];
                            this._unsync(t.flickity);
                        }
                    }),
                    e
                );
            });
    })(),
    (function () {
        var e, t;
        (e = this),
            (t = function () {
                "use strict";
                return function (e, t, i, n) {
                    var o = {
                        features: null,
                        bind: function (e, t, i, n) {
                            var o = (n ? "remove" : "add") + "EventListener";
                            t = t.split(" ");
                            for (var r = 0; r < t.length; r++) t[r] && e[o](t[r], i, !1);
                        },
                        isArray: function (e) {
                            return e instanceof Array;
                        },
                        createEl: function (e, t) {
                            var i = document.createElement(t || "div");
                            return e && (i.className = e), i;
                        },
                        getScrollY: function () {
                            var e = window.pageYOffset;
                            return void 0 !== e ? e : document.documentElement.scrollTop;
                        },
                        unbind: function (e, t, i) {
                            o.bind(e, t, i, !0);
                        },
                        removeClass: function (e, t) {
                            var i = new RegExp("(\\s|^)" + t + "(\\s|$)");
                            e.className = e.className
                                .replace(i, " ")
                                .replace(/^\s\s*/, "")
                                .replace(/\s\s*$/, "");
                        },
                        addClass: function (e, t) {
                            o.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
                        },
                        hasClass: function (e, t) {
                            return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className);
                        },
                        getChildByClass: function (e, t) {
                            for (var i = e.firstChild; i; ) {
                                if (o.hasClass(i, t)) return i;
                                i = i.nextSibling;
                            }
                        },
                        arraySearch: function (e, t, i) {
                            for (var n = e.length; n--; ) if (e[n][i] === t) return n;
                            return -1;
                        },
                        extend: function (e, t, i) {
                            for (var n in t)
                                if (t.hasOwnProperty(n)) {
                                    if (i && e.hasOwnProperty(n)) continue;
                                    e[n] = t[n];
                                }
                        },
                        easing: {
                            sine: {
                                out: function (e) {
                                    return Math.sin(e * (Math.PI / 2));
                                },
                                inOut: function (e) {
                                    return -(Math.cos(Math.PI * e) - 1) / 2;
                                },
                            },
                            cubic: {
                                out: function (e) {
                                    return --e * e * e + 1;
                                },
                            },
                        },
                        detectFeatures: function () {
                            if (o.features) return o.features;
                            var e = o.createEl().style,
                                t = "",
                                i = {};
                            if (
                                ((i.oldIE = document.all && !document.addEventListener),
                                (i.touch = "ontouchstart" in window),
                                window.requestAnimationFrame && ((i.raf = window.requestAnimationFrame), (i.caf = window.cancelAnimationFrame)),
                                (i.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled),
                                !i.pointerEvent)
                            ) {
                                var n = navigator.userAgent;
                                if (/iP(hone|od)/.test(navigator.platform)) {
                                    var r = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                                    r && r.length > 0 && (r = parseInt(r[1], 10)) >= 1 && r < 8 && (i.isOldIOSPhone = !0);
                                }
                                var a = n.match(/Android\s([0-9\.]*)/),
                                    s = a ? a[1] : 0;
                                (s = parseFloat(s)) >= 1 && (s < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = s)), (i.isMobileOpera = /opera mini|opera mobi/i.test(n));
                            }
                            for (var c, l, u = ["transform", "perspective", "animationName"], d = ["", "webkit", "Moz", "ms", "O"], h = 0; h < 4; h++) {
                                t = d[h];
                                for (var p = 0; p < 3; p++) (c = u[p]), (l = t + (t ? c.charAt(0).toUpperCase() + c.slice(1) : c)), !i[c] && l in e && (i[c] = l);
                                t && !i.raf && ((t = t.toLowerCase()), (i.raf = window[t + "RequestAnimationFrame"]), i.raf && (i.caf = window[t + "CancelAnimationFrame"] || window[t + "CancelRequestAnimationFrame"]));
                            }
                            if (!i.raf) {
                                var f = 0;
                                (i.raf = function (e) {
                                    var t = new Date().getTime(),
                                        i = Math.max(0, 16 - (t - f)),
                                        n = window.setTimeout(function () {
                                            e(t + i);
                                        }, i);
                                    return (f = t + i), n;
                                }),
                                    (i.caf = function (e) {
                                        clearTimeout(e);
                                    });
                            }
                            return (i.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect), (o.features = i), i;
                        },
                    };
                    o.detectFeatures(),
                        o.features.oldIE &&
                            (o.bind = function (e, t, i, n) {
                                t = t.split(" ");
                                for (
                                    var o,
                                        r = (n ? "detach" : "attach") + "Event",
                                        a = function () {
                                            i.handleEvent.call(i);
                                        },
                                        s = 0;
                                    s < t.length;
                                    s++
                                )
                                    if ((o = t[s]))
                                        if ("object" == typeof i && i.handleEvent) {
                                            if (n) {
                                                if (!i["oldIE" + o]) return !1;
                                            } else i["oldIE" + o] = a;
                                            e[r]("on" + o, i["oldIE" + o]);
                                        } else e[r]("on" + o, i);
                            });
                    var r = this,
                        a = {
                            allowPanToNext: !0,
                            spacing: 0.12,
                            bgOpacity: 1,
                            mouseUsed: !1,
                            loop: !0,
                            pinchToClose: !0,
                            closeOnScroll: !0,
                            closeOnVerticalDrag: !0,
                            verticalDragRange: 0.75,
                            hideAnimationDuration: 333,
                            showAnimationDuration: 333,
                            showHideOpacity: !1,
                            focus: !0,
                            escKey: !0,
                            arrowKeys: !0,
                            mainScrollEndFriction: 0.35,
                            panEndFriction: 0.35,
                            isClickableElement: function (e) {
                                return "A" === e.tagName;
                            },
                            getDoubleTapZoom: function (e, t) {
                                return e || t.initialZoomLevel < 0.7 ? 1 : 1.33;
                            },
                            maxSpreadZoom: 1.33,
                            modal: !0,
                            scaleMode: "fit",
                        };
                    o.extend(a, n);
                    var s,
                        c,
                        l,
                        u,
                        d,
                        h,
                        p,
                        f,
                        m,
                        y,
                        v,
                        g,
                        b,
                        w,
                        S,
                        E,
                        x,
                        _,
                        A,
                        L,
                        C,
                        k,
                        q,
                        I,
                        T,
                        D,
                        P,
                        j,
                        M,
                        z,
                        F,
                        O,
                        N,
                        H,
                        U,
                        R,
                        B,
                        W,
                        V,
                        G,
                        $,
                        Z,
                        X,
                        Y,
                        K,
                        J,
                        Q,
                        ee,
                        te,
                        ie,
                        ne,
                        oe,
                        re,
                        ae,
                        se,
                        ce,
                        le = { x: 0, y: 0 },
                        ue = { x: 0, y: 0 },
                        de = { x: 0, y: 0 },
                        he = {},
                        pe = 0,
                        fe = {},
                        me = { x: 0, y: 0 },
                        ye = 0,
                        ve = !0,
                        ge = [],
                        be = {},
                        we = !1,
                        Se = function (e, t) {
                            o.extend(r, t.publicMethods), ge.push(e);
                        },
                        Ee = function (e) {
                            var t = Ut();
                            return e > t - 1 ? e - t : e < 0 ? t + e : e;
                        },
                        xe = {},
                        _e = function (e, t) {
                            return xe[e] || (xe[e] = []), xe[e].push(t);
                        },
                        Ae = function (e) {
                            var t = xe[e];
                            if (t) {
                                var i = Array.prototype.slice.call(arguments);
                                i.shift();
                                for (var n = 0; n < t.length; n++) t[n].apply(r, i);
                            }
                        },
                        Le = function () {
                            return new Date().getTime();
                        },
                        Ce = function (e) {
                            (ae = e), (r.bg.style.opacity = e * a.bgOpacity);
                        },
                        ke = function (e, t, i, n, o) {
                            (!we || (o && o !== r.currItem)) && (n /= o ? o.fitRatio : r.currItem.fitRatio), (e[k] = g + t + "px, " + i + "px" + b + " scale(" + n + ")");
                        },
                        qe = function (e) {
                            te && (e && (y > r.currItem.fitRatio ? we || (Yt(r.currItem, !1, !0), (we = !0)) : we && (Yt(r.currItem), (we = !1))), ke(te, de.x, de.y, y));
                        },
                        Ie = function (e) {
                            e.container && ke(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e);
                        },
                        Te = function (e, t) {
                            t[k] = g + e + "px, 0px" + b;
                        },
                        De = function (e, t) {
                            if (!a.loop && t) {
                                var i = u + (me.x * pe - e) / me.x,
                                    n = Math.round(e - ut.x);
                                ((i < 0 && n > 0) || (i >= Ut() - 1 && n < 0)) && (e = ut.x + n * a.mainScrollEndFriction);
                            }
                            (ut.x = e), Te(e, d);
                        },
                        Pe = function (e, t) {
                            var i = dt[e] - fe[e];
                            return ue[e] + le[e] + i - i * (t / v);
                        },
                        je = function (e, t) {
                            (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
                        },
                        Me = function (e) {
                            (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
                        },
                        ze = null,
                        Fe = function () {
                            ze && (o.unbind(document, "mousemove", Fe), o.addClass(e, "pswp--has_mouse"), (a.mouseUsed = !0), Ae("mouseUsed")),
                                (ze = setTimeout(function () {
                                    ze = null;
                                }, 100));
                        },
                        Oe = function (e, t) {
                            var i = Gt(r.currItem, he, e);
                            return t && (ee = i), i;
                        },
                        Ne = function (e) {
                            return e || (e = r.currItem), e.initialZoomLevel;
                        },
                        He = function (e) {
                            return e || (e = r.currItem), e.w > 0 ? a.maxSpreadZoom : 1;
                        },
                        Ue = function (e, t, i, n) {
                            return n === r.currItem.initialZoomLevel ? ((i[e] = r.currItem.initialPosition[e]), !0) : ((i[e] = Pe(e, n)), i[e] > t.min[e] ? ((i[e] = t.min[e]), !0) : i[e] < t.max[e] && ((i[e] = t.max[e]), !0));
                        },
                        Re = function (e) {
                            var t = "";
                            a.escKey && 27 === e.keyCode ? (t = "close") : a.arrowKeys && (37 === e.keyCode ? (t = "prev") : 39 === e.keyCode && (t = "next")),
                                t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), r[t]()));
                        },
                        Be = function (e) {
                            e && (Z || $ || ie || B) && (e.preventDefault(), e.stopPropagation());
                        },
                        We = function () {
                            r.setScrollOffset(0, o.getScrollY());
                        },
                        Ve = {},
                        Ge = 0,
                        $e = function (e) {
                            Ve[e] && (Ve[e].raf && D(Ve[e].raf), Ge--, delete Ve[e]);
                        },
                        Ze = function (e) {
                            Ve[e] && $e(e), Ve[e] || (Ge++, (Ve[e] = {}));
                        },
                        Xe = function () {
                            for (var e in Ve) Ve.hasOwnProperty(e) && $e(e);
                        },
                        Ye = function (e, t, i, n, o, r, a) {
                            var s,
                                c = Le();
                            Ze(e);
                            var l = function () {
                                if (Ve[e]) {
                                    if ((s = Le() - c) >= n) return $e(e), r(i), void (a && a());
                                    r((i - t) * o(s / n) + t), (Ve[e].raf = T(l));
                                }
                            };
                            l();
                        },
                        Ke = {
                            shout: Ae,
                            listen: _e,
                            viewportSize: he,
                            options: a,
                            isMainScrollAnimating: function () {
                                return ie;
                            },
                            getZoomLevel: function () {
                                return y;
                            },
                            getCurrentIndex: function () {
                                return u;
                            },
                            isDragging: function () {
                                return V;
                            },
                            isZooming: function () {
                                return J;
                            },
                            setScrollOffset: function (e, t) {
                                (fe.x = e), (z = fe.y = t), Ae("updateScrollOffset", fe);
                            },
                            applyZoomPan: function (e, t, i, n) {
                                (de.x = t), (de.y = i), (y = e), qe(n);
                            },
                            init: function () {
                                if (!s && !c) {
                                    var i;
                                    (r.framework = o),
                                        (r.template = e),
                                        (r.bg = o.getChildByClass(e, "pswp__bg")),
                                        (P = e.className),
                                        (s = !0),
                                        (F = o.detectFeatures()),
                                        (T = F.raf),
                                        (D = F.caf),
                                        (k = F.transform),
                                        (M = F.oldIE),
                                        (r.scrollWrap = o.getChildByClass(e, "pswp__scroll-wrap")),
                                        (r.container = o.getChildByClass(r.scrollWrap, "pswp__container")),
                                        (d = r.container.style),
                                        (r.itemHolders = E = [
                                            { el: r.container.children[0], wrap: 0, index: -1 },
                                            { el: r.container.children[1], wrap: 0, index: -1 },
                                            { el: r.container.children[2], wrap: 0, index: -1 },
                                        ]),
                                        (E[0].el.style.display = E[2].el.style.display = "none"),
                                        (function () {
                                            if (k) {
                                                var t = F.perspective && !I;
                                                return (g = "translate" + (t ? "3d(" : "(")), void (b = F.perspective ? ", 0px)" : ")");
                                            }
                                            (k = "left"),
                                                o.addClass(e, "pswp--ie"),
                                                (Te = function (e, t) {
                                                    t.left = e + "px";
                                                }),
                                                (Ie = function (e) {
                                                    var t = e.fitRatio > 1 ? 1 : e.fitRatio,
                                                        i = e.container.style,
                                                        n = t * e.w,
                                                        o = t * e.h;
                                                    (i.width = n + "px"), (i.height = o + "px"), (i.left = e.initialPosition.x + "px"), (i.top = e.initialPosition.y + "px");
                                                }),
                                                (qe = function () {
                                                    if (te) {
                                                        var e = te,
                                                            t = r.currItem,
                                                            i = t.fitRatio > 1 ? 1 : t.fitRatio,
                                                            n = i * t.w,
                                                            o = i * t.h;
                                                        (e.width = n + "px"), (e.height = o + "px"), (e.left = de.x + "px"), (e.top = de.y + "px");
                                                    }
                                                });
                                        })(),
                                        (m = {
                                            resize: r.updateSize,
                                            orientationchange: function () {
                                                clearTimeout(O),
                                                    (O = setTimeout(function () {
                                                        he.x !== r.scrollWrap.clientWidth && r.updateSize();
                                                    }, 500));
                                            },
                                            scroll: We,
                                            keydown: Re,
                                            click: Be,
                                        });
                                    var n = F.isOldIOSPhone || F.isOldAndroid || F.isMobileOpera;
                                    for ((F.animationName && F.transform && !n) || (a.showAnimationDuration = a.hideAnimationDuration = 0), i = 0; i < ge.length; i++) r["init" + ge[i]]();
                                    t && (r.ui = new t(r, o)).init(),
                                        Ae("firstUpdate"),
                                        (u = u || a.index || 0),
                                        (isNaN(u) || u < 0 || u >= Ut()) && (u = 0),
                                        (r.currItem = Ht(u)),
                                        (F.isOldIOSPhone || F.isOldAndroid) && (ve = !1),
                                        e.setAttribute("aria-hidden", "false"),
                                        a.modal && (ve ? (e.style.position = "fixed") : ((e.style.position = "absolute"), (e.style.top = o.getScrollY() + "px"))),
                                        void 0 === z && (Ae("initialLayout"), (z = j = o.getScrollY()));
                                    var l = "pswp--open ";
                                    for (
                                        a.mainClass && (l += a.mainClass + " "),
                                            a.showHideOpacity && (l += "pswp--animate_opacity "),
                                            l += I ? "pswp--touch" : "pswp--notouch",
                                            l += F.animationName ? " pswp--css_animation" : "",
                                            l += F.svg ? " pswp--svg" : "",
                                            o.addClass(e, l),
                                            r.updateSize(),
                                            h = -1,
                                            ye = null,
                                            i = 0;
                                        i < 3;
                                        i++
                                    )
                                        Te((i + h) * me.x, E[i].el.style);
                                    M || o.bind(r.scrollWrap, f, r),
                                        _e("initialZoomInEnd", function () {
                                            r.setContent(E[0], u - 1),
                                                r.setContent(E[2], u + 1),
                                                (E[0].el.style.display = E[2].el.style.display = "block"),
                                                a.focus && e.focus(),
                                                o.bind(document, "keydown", r),
                                                F.transform && o.bind(r.scrollWrap, "click", r),
                                                a.mouseUsed || o.bind(document, "mousemove", Fe),
                                                o.bind(window, "resize scroll orientationchange", r),
                                                Ae("bindEvents");
                                        }),
                                        r.setContent(E[1], u),
                                        r.updateCurrItem(),
                                        Ae("afterInit"),
                                        ve ||
                                            (w = setInterval(function () {
                                                Ge || V || J || y !== r.currItem.initialZoomLevel || r.updateSize();
                                            }, 1e3)),
                                        o.addClass(e, "pswp--visible");
                                }
                            },
                            close: function () {
                                s &&
                                    ((s = !1),
                                    (c = !0),
                                    Ae("close"),
                                    o.unbind(window, "resize scroll orientationchange", r),
                                    o.unbind(window, "scroll", m.scroll),
                                    o.unbind(document, "keydown", r),
                                    o.unbind(document, "mousemove", Fe),
                                    F.transform && o.unbind(r.scrollWrap, "click", r),
                                    V && o.unbind(window, p, r),
                                    clearTimeout(O),
                                    Ae("unbindEvents"),
                                    Rt(r.currItem, null, !0, r.destroy));
                            },
                            destroy: function () {
                                Ae("destroy"), zt && clearTimeout(zt), e.setAttribute("aria-hidden", "true"), (e.className = P), w && clearInterval(w), o.unbind(r.scrollWrap, f, r), o.unbind(window, "scroll", r), ft(), Xe(), (xe = null);
                            },
                            panTo: function (e, t, i) {
                                i || (e > ee.min.x ? (e = ee.min.x) : e < ee.max.x && (e = ee.max.x), t > ee.min.y ? (t = ee.min.y) : t < ee.max.y && (t = ee.max.y)), (de.x = e), (de.y = t), qe();
                            },
                            handleEvent: function (e) {
                                (e = e || window.event), m[e.type] && m[e.type](e);
                            },
                            goTo: function (e) {
                                var t = (e = Ee(e)) - u;
                                (ye = t), (u = e), (r.currItem = Ht(u)), (pe -= t), De(me.x * pe), Xe(), (ie = !1), r.updateCurrItem();
                            },
                            next: function () {
                                r.goTo(u + 1);
                            },
                            prev: function () {
                                r.goTo(u - 1);
                            },
                            updateCurrZoomItem: function (e) {
                                if ((e && Ae("beforeChange", 0), E[1].el.children.length)) {
                                    var t = E[1].el.children[0];
                                    te = o.hasClass(t, "pswp__zoom-wrap") ? t.style : null;
                                } else te = null;
                                (ee = r.currItem.bounds), (v = y = r.currItem.initialZoomLevel), (de.x = ee.center.x), (de.y = ee.center.y), e && Ae("afterChange");
                            },
                            invalidateCurrItems: function () {
                                S = !0;
                                for (var e = 0; e < 3; e++) E[e].item && (E[e].item.needsUpdate = !0);
                            },
                            updateCurrItem: function (e) {
                                if (0 !== ye) {
                                    var t,
                                        i = Math.abs(ye);
                                    if (!(e && i < 2)) {
                                        (r.currItem = Ht(u)), (we = !1), Ae("beforeChange", ye), i >= 3 && ((h += ye + (ye > 0 ? -3 : 3)), (i = 3));
                                        for (var n = 0; n < i; n++)
                                            ye > 0
                                                ? ((t = E.shift()), (E[2] = t), h++, Te((h + 2) * me.x, t.el.style), r.setContent(t, u - i + n + 1 + 1))
                                                : ((t = E.pop()), E.unshift(t), h--, Te(h * me.x, t.el.style), r.setContent(t, u + i - n - 1 - 1));
                                        if (te && 1 === Math.abs(ye)) {
                                            var o = Ht(x);
                                            o.initialZoomLevel !== y && (Gt(o, he), Yt(o), Ie(o));
                                        }
                                        (ye = 0), r.updateCurrZoomItem(), (x = u), Ae("afterChange");
                                    }
                                }
                            },
                            updateSize: function (t) {
                                if (!ve && a.modal) {
                                    var i = o.getScrollY();
                                    if ((z !== i && ((e.style.top = i + "px"), (z = i)), !t && be.x === window.innerWidth && be.y === window.innerHeight)) return;
                                    (be.x = window.innerWidth), (be.y = window.innerHeight), (e.style.height = be.y + "px");
                                }
                                if (((he.x = r.scrollWrap.clientWidth), (he.y = r.scrollWrap.clientHeight), We(), (me.x = he.x + Math.round(he.x * a.spacing)), (me.y = he.y), De(me.x * pe), Ae("beforeResize"), void 0 !== h)) {
                                    for (var n, s, c, l = 0; l < 3; l++)
                                        (n = E[l]),
                                            Te((l + h) * me.x, n.el.style),
                                            (c = u + l - 1),
                                            a.loop && Ut() > 2 && (c = Ee(c)),
                                            (s = Ht(c)) && (S || s.needsUpdate || !s.bounds)
                                                ? (r.cleanSlide(s), r.setContent(n, c), 1 === l && ((r.currItem = s), r.updateCurrZoomItem(!0)), (s.needsUpdate = !1))
                                                : -1 === n.index && c >= 0 && r.setContent(n, c),
                                            s && s.container && (Gt(s, he), Yt(s), Ie(s));
                                    S = !1;
                                }
                                (v = y = r.currItem.initialZoomLevel), (ee = r.currItem.bounds) && ((de.x = ee.center.x), (de.y = ee.center.y), qe(!0)), Ae("resize");
                            },
                            zoomTo: function (e, t, i, n, r) {
                                t && ((v = y), (dt.x = Math.abs(t.x) - de.x), (dt.y = Math.abs(t.y) - de.y), je(ue, de));
                                var a = Oe(e, !1),
                                    s = {};
                                Ue("x", a, s, e), Ue("y", a, s, e);
                                var c = y,
                                    l = de.x,
                                    u = de.y;
                                Me(s);
                                var d = function (t) {
                                    1 === t ? ((y = e), (de.x = s.x), (de.y = s.y)) : ((y = (e - c) * t + c), (de.x = (s.x - l) * t + l), (de.y = (s.y - u) * t + u)), r && r(t), qe(1 === t);
                                };
                                i ? Ye("customZoomTo", 0, 1, i, n || o.easing.sine.inOut, d) : d(1);
                            },
                        },
                        Je = {},
                        Qe = {},
                        et = {},
                        tt = {},
                        it = {},
                        nt = [],
                        ot = {},
                        rt = [],
                        at = {},
                        st = 0,
                        ct = { x: 0, y: 0 },
                        lt = 0,
                        ut = { x: 0, y: 0 },
                        dt = { x: 0, y: 0 },
                        ht = { x: 0, y: 0 },
                        pt = function (e, t) {
                            return (at.x = Math.abs(e.x - t.x)), (at.y = Math.abs(e.y - t.y)), Math.sqrt(at.x * at.x + at.y * at.y);
                        },
                        ft = function () {
                            X && (D(X), (X = null));
                        },
                        mt = function () {
                            V && ((X = T(mt)), qt());
                        },
                        yt = function (e, t) {
                            return !(!e || e === document) && !(e.getAttribute("class") && e.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (t(e) ? e : yt(e.parentNode, t));
                        },
                        vt = {},
                        gt = function (e, t) {
                            return (vt.prevent = !yt(e.target, a.isClickableElement)), Ae("preventDragEvent", e, t, vt), vt.prevent;
                        },
                        bt = function (e, t) {
                            return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
                        },
                        wt = function (e, t, i) {
                            (i.x = 0.5 * (e.x + t.x)), (i.y = 0.5 * (e.y + t.y));
                        },
                        St = function () {
                            var e = de.y - r.currItem.initialPosition.y;
                            return 1 - Math.abs(e / (he.y / 2));
                        },
                        Et = {},
                        xt = {},
                        _t = [],
                        At = function (e) {
                            for (; _t.length > 0; ) _t.pop();
                            return (
                                q
                                    ? ((ce = 0),
                                      nt.forEach(function (e) {
                                          0 === ce ? (_t[0] = e) : 1 === ce && (_t[1] = e), ce++;
                                      }))
                                    : e.type.indexOf("touch") > -1
                                    ? e.touches && e.touches.length > 0 && ((_t[0] = bt(e.touches[0], Et)), e.touches.length > 1 && (_t[1] = bt(e.touches[1], xt)))
                                    : ((Et.x = e.pageX), (Et.y = e.pageY), (Et.id = ""), (_t[0] = Et)),
                                _t
                            );
                        },
                        Lt = function (e, t) {
                            var i,
                                n,
                                o,
                                s,
                                c = de[e] + t[e],
                                l = t[e] > 0,
                                u = ut.x + t.x,
                                d = ut.x - ot.x;
                            return (
                                (i = c > ee.min[e] || c < ee.max[e] ? a.panEndFriction : 1),
                                (c = de[e] + t[e] * i),
                                (!a.allowPanToNext && y !== r.currItem.initialZoomLevel) ||
                                (te
                                    ? "h" !== ne ||
                                      "x" !== e ||
                                      $ ||
                                      (l
                                          ? (c > ee.min[e] && ((i = a.panEndFriction), ee.min[e], (n = ee.min[e] - ue[e])), (n <= 0 || d < 0) && Ut() > 1 ? ((s = u), d < 0 && u > ot.x && (s = ot.x)) : ee.min.x !== ee.max.x && (o = c))
                                          : (c < ee.max[e] && ((i = a.panEndFriction), ee.max[e], (n = ue[e] - ee.max[e])), (n <= 0 || d > 0) && Ut() > 1 ? ((s = u), d > 0 && u < ot.x && (s = ot.x)) : ee.min.x !== ee.max.x && (o = c)))
                                    : (s = u),
                                "x" !== e)
                                    ? void (ie || Y || (y > r.currItem.fitRatio && (de[e] += t[e] * i)))
                                    : (void 0 !== s && (De(s, !0), (Y = s !== ot.x)), ee.min.x !== ee.max.x && (void 0 !== o ? (de.x = o) : Y || (de.x += t.x * i)), void 0 !== s)
                            );
                        },
                        Ct = function (e) {
                            if (!("mousedown" === e.type && e.button > 0)) {
                                if (Nt) return void e.preventDefault();
                                if (!W || "mousedown" !== e.type) {
                                    if ((gt(e, !0) && e.preventDefault(), Ae("pointerDown"), q)) {
                                        var t = o.arraySearch(nt, e.pointerId, "id");
                                        t < 0 && (t = nt.length), (nt[t] = { x: e.pageX, y: e.pageY, id: e.pointerId });
                                    }
                                    var i = At(e),
                                        n = i.length;
                                    (K = null),
                                        Xe(),
                                        (V && 1 !== n) ||
                                            ((V = oe = !0),
                                            o.bind(window, p, r),
                                            (R = se = re = B = Y = Z = G = $ = !1),
                                            (ne = null),
                                            Ae("firstTouchStart", i),
                                            je(ue, de),
                                            (le.x = le.y = 0),
                                            je(tt, i[0]),
                                            je(it, tt),
                                            (ot.x = me.x * pe),
                                            (rt = [{ x: tt.x, y: tt.y }]),
                                            (H = N = Le()),
                                            Oe(y, !0),
                                            ft(),
                                            mt()),
                                        !J &&
                                            n > 1 &&
                                            !ie &&
                                            !Y &&
                                            ((v = y), ($ = !1), (J = G = !0), (le.y = le.x = 0), je(ue, de), je(Je, i[0]), je(Qe, i[1]), wt(Je, Qe, ht), (dt.x = Math.abs(ht.x) - de.x), (dt.y = Math.abs(ht.y) - de.y), (Q = pt(Je, Qe)));
                                }
                            }
                        },
                        kt = function (e) {
                            if ((e.preventDefault(), q)) {
                                var t = o.arraySearch(nt, e.pointerId, "id");
                                if (t > -1) {
                                    var i = nt[t];
                                    (i.x = e.pageX), (i.y = e.pageY);
                                }
                            }
                            if (V) {
                                var n = At(e);
                                if (ne || Z || J) K = n;
                                else if (ut.x !== me.x * pe) ne = "h";
                                else {
                                    var r = Math.abs(n[0].x - tt.x) - Math.abs(n[0].y - tt.y);
                                    Math.abs(r) >= 10 && ((ne = r > 0 ? "h" : "v"), (K = n));
                                }
                            }
                        },
                        qt = function () {
                            if (K) {
                                var e = K.length;
                                if (0 !== e)
                                    if ((je(Je, K[0]), (et.x = Je.x - tt.x), (et.y = Je.y - tt.y), J && e > 1)) {
                                        if (
                                            ((tt.x = Je.x),
                                            (tt.y = Je.y),
                                            !et.x &&
                                                !et.y &&
                                                (function (e, t) {
                                                    return e.x === t.x && e.y === t.y;
                                                })(K[1], Qe))
                                        )
                                            return;
                                        je(Qe, K[1]), $ || (($ = !0), Ae("zoomGestureStarted"));
                                        var t = pt(Je, Qe),
                                            i = jt(t);
                                        i > r.currItem.initialZoomLevel + r.currItem.initialZoomLevel / 15 && (se = !0);
                                        var n = 1,
                                            o = Ne(),
                                            s = He();
                                        if (i < o)
                                            if (a.pinchToClose && !se && v <= r.currItem.initialZoomLevel) {
                                                var c = 1 - (o - i) / (o / 1.2);
                                                Ce(c), Ae("onPinchClose", c), (re = !0);
                                            } else (n = (o - i) / o) > 1 && (n = 1), (i = o - n * (o / 3));
                                        else i > s && ((n = (i - s) / (6 * o)) > 1 && (n = 1), (i = s + n * o));
                                        n < 0 && (n = 0), wt(Je, Qe, ct), (le.x += ct.x - ht.x), (le.y += ct.y - ht.y), je(ht, ct), (de.x = Pe("x", i)), (de.y = Pe("y", i)), (R = i > y), (y = i), qe();
                                    } else {
                                        if (!ne) return;
                                        if ((oe && ((oe = !1), Math.abs(et.x) >= 10 && (et.x -= K[0].x - it.x), Math.abs(et.y) >= 10 && (et.y -= K[0].y - it.y)), (tt.x = Je.x), (tt.y = Je.y), 0 === et.x && 0 === et.y)) return;
                                        if ("v" === ne && a.closeOnVerticalDrag && "fit" === a.scaleMode && y === r.currItem.initialZoomLevel) {
                                            (le.y += et.y), (de.y += et.y);
                                            var l = St();
                                            return (B = !0), Ae("onVerticalDrag", l), Ce(l), void qe();
                                        }
                                        (function (e, t, i) {
                                            if (e - H > 50) {
                                                var n = rt.length > 2 ? rt.shift() : {};
                                                (n.x = t), (n.y = i), rt.push(n), (H = e);
                                            }
                                        })(Le(), Je.x, Je.y),
                                            (Z = !0),
                                            (ee = r.currItem.bounds),
                                            Lt("x", et) || (Lt("y", et), Me(de), qe());
                                    }
                            }
                        },
                        It = function (e) {
                            if (F.isOldAndroid) {
                                if (W && "mouseup" === e.type) return;
                                e.type.indexOf("touch") > -1 &&
                                    (clearTimeout(W),
                                    (W = setTimeout(function () {
                                        W = 0;
                                    }, 600)));
                            }
                            var t;
                            if ((Ae("pointerUp"), gt(e, !1) && e.preventDefault(), q)) {
                                var i = o.arraySearch(nt, e.pointerId, "id");
                                i > -1 &&
                                    ((t = nt.splice(i, 1)[0]),
                                    navigator.msPointerEnabled ? ((t.type = { 4: "mouse", 2: "touch", 3: "pen" }[e.pointerType]), t.type || (t.type = e.pointerType || "mouse")) : (t.type = e.pointerType || "mouse"));
                            }
                            var n,
                                s = At(e),
                                c = s.length;
                            if (("mouseup" === e.type && (c = 0), 2 === c)) return (K = null), !0;
                            1 === c && je(it, s[0]),
                                0 !== c ||
                                    ne ||
                                    ie ||
                                    (t ||
                                        ("mouseup" === e.type
                                            ? (t = { x: e.pageX, y: e.pageY, type: "mouse" })
                                            : e.changedTouches && e.changedTouches[0] && (t = { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type: "touch" })),
                                    Ae("touchRelease", e, t));
                            var l = -1;
                            if (
                                (0 === c && ((V = !1), o.unbind(window, p, r), ft(), J ? (l = 0) : -1 !== lt && (l = Le() - lt)),
                                (lt = 1 === c ? Le() : -1),
                                (n = -1 !== l && l < 150 ? "zoom" : "swipe"),
                                J && c < 2 && ((J = !1), 1 === c && (n = "zoomPointerUp"), Ae("zoomGestureEnded")),
                                (K = null),
                                Z || $ || ie || B)
                            )
                                if ((Xe(), U || (U = Tt()), U.calculateSwipeSpeed("x"), B))
                                    if (St() < a.verticalDragRange) r.close();
                                    else {
                                        var u = de.y,
                                            d = ae;
                                        Ye("verticalDrag", 0, 1, 300, o.easing.cubic.out, function (e) {
                                            (de.y = (r.currItem.initialPosition.y - u) * e + u), Ce((1 - d) * e + d), qe();
                                        }),
                                            Ae("onVerticalDrag", 1);
                                    }
                                else {
                                    if ((Y || ie) && 0 === c) {
                                        if (Pt(n, U)) return;
                                        n = "zoomPointerUp";
                                    }
                                    if (!ie) return "swipe" !== n ? void Mt() : void (!Y && y > r.currItem.fitRatio && Dt(U));
                                }
                        },
                        Tt = function () {
                            var e,
                                t,
                                i = {
                                    lastFlickOffset: {},
                                    lastFlickDist: {},
                                    lastFlickSpeed: {},
                                    slowDownRatio: {},
                                    slowDownRatioReverse: {},
                                    speedDecelerationRatio: {},
                                    speedDecelerationRatioAbs: {},
                                    distanceOffset: {},
                                    backAnimDestination: {},
                                    backAnimStarted: {},
                                    calculateSwipeSpeed: function (n) {
                                        rt.length > 1 ? ((e = Le() - H + 50), (t = rt[rt.length - 2][n])) : ((e = Le() - N), (t = it[n])),
                                            (i.lastFlickOffset[n] = tt[n] - t),
                                            (i.lastFlickDist[n] = Math.abs(i.lastFlickOffset[n])),
                                            i.lastFlickDist[n] > 20 ? (i.lastFlickSpeed[n] = i.lastFlickOffset[n] / e) : (i.lastFlickSpeed[n] = 0),
                                            Math.abs(i.lastFlickSpeed[n]) < 0.1 && (i.lastFlickSpeed[n] = 0),
                                            (i.slowDownRatio[n] = 0.95),
                                            (i.slowDownRatioReverse[n] = 1 - i.slowDownRatio[n]),
                                            (i.speedDecelerationRatio[n] = 1);
                                    },
                                    calculateOverBoundsAnimOffset: function (e, t) {
                                        i.backAnimStarted[e] ||
                                            (de[e] > ee.min[e] ? (i.backAnimDestination[e] = ee.min[e]) : de[e] < ee.max[e] && (i.backAnimDestination[e] = ee.max[e]),
                                            void 0 !== i.backAnimDestination[e] &&
                                                ((i.slowDownRatio[e] = 0.7),
                                                (i.slowDownRatioReverse[e] = 1 - i.slowDownRatio[e]),
                                                i.speedDecelerationRatioAbs[e] < 0.05 &&
                                                    ((i.lastFlickSpeed[e] = 0),
                                                    (i.backAnimStarted[e] = !0),
                                                    Ye("bounceZoomPan" + e, de[e], i.backAnimDestination[e], t || 300, o.easing.sine.out, function (t) {
                                                        (de[e] = t), qe();
                                                    }))));
                                    },
                                    calculateAnimOffset: function (e) {
                                        i.backAnimStarted[e] ||
                                            ((i.speedDecelerationRatio[e] = i.speedDecelerationRatio[e] * (i.slowDownRatio[e] + i.slowDownRatioReverse[e] - (i.slowDownRatioReverse[e] * i.timeDiff) / 10)),
                                            (i.speedDecelerationRatioAbs[e] = Math.abs(i.lastFlickSpeed[e] * i.speedDecelerationRatio[e])),
                                            (i.distanceOffset[e] = i.lastFlickSpeed[e] * i.speedDecelerationRatio[e] * i.timeDiff),
                                            (de[e] += i.distanceOffset[e]));
                                    },
                                    panAnimLoop: function () {
                                        if (
                                            Ve.zoomPan &&
                                            ((Ve.zoomPan.raf = T(i.panAnimLoop)),
                                            (i.now = Le()),
                                            (i.timeDiff = i.now - i.lastNow),
                                            (i.lastNow = i.now),
                                            i.calculateAnimOffset("x"),
                                            i.calculateAnimOffset("y"),
                                            qe(),
                                            i.calculateOverBoundsAnimOffset("x"),
                                            i.calculateOverBoundsAnimOffset("y"),
                                            i.speedDecelerationRatioAbs.x < 0.05 && i.speedDecelerationRatioAbs.y < 0.05)
                                        )
                                            return (de.x = Math.round(de.x)), (de.y = Math.round(de.y)), qe(), void $e("zoomPan");
                                    },
                                };
                            return i;
                        },
                        Dt = function (e) {
                            return (
                                e.calculateSwipeSpeed("y"),
                                (ee = r.currItem.bounds),
                                (e.backAnimDestination = {}),
                                (e.backAnimStarted = {}),
                                Math.abs(e.lastFlickSpeed.x) <= 0.05 && Math.abs(e.lastFlickSpeed.y) <= 0.05
                                    ? ((e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0), e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0)
                                    : (Ze("zoomPan"), (e.lastNow = Le()), void e.panAnimLoop())
                            );
                        },
                        Pt = function (e, t) {
                            var i, n, s;
                            if ((ie || (st = u), "swipe" === e)) {
                                var c = tt.x - it.x,
                                    l = t.lastFlickDist.x < 10;
                                c > 30 && (l || t.lastFlickOffset.x > 20) ? (n = -1) : c < -30 && (l || t.lastFlickOffset.x < -20) && (n = 1);
                            }
                            n && ((u += n) < 0 ? ((u = a.loop ? Ut() - 1 : 0), (s = !0)) : u >= Ut() && ((u = a.loop ? 0 : Ut() - 1), (s = !0)), (s && !a.loop) || ((ye += n), (pe -= n), (i = !0)));
                            var d,
                                h = me.x * pe,
                                p = Math.abs(h - ut.x);
                            return (
                                i || h > ut.x == t.lastFlickSpeed.x > 0 ? ((d = Math.abs(t.lastFlickSpeed.x) > 0 ? p / Math.abs(t.lastFlickSpeed.x) : 333), (d = Math.min(d, 400)), (d = Math.max(d, 250))) : (d = 333),
                                st === u && (i = !1),
                                (ie = !0),
                                Ae("mainScrollAnimStart"),
                                Ye("mainScroll", ut.x, h, d, o.easing.cubic.out, De, function () {
                                    Xe(), (ie = !1), (st = -1), (i || st !== u) && r.updateCurrItem(), Ae("mainScrollAnimComplete");
                                }),
                                i && r.updateCurrItem(!0),
                                i
                            );
                        },
                        jt = function (e) {
                            return (1 / Q) * e * v;
                        },
                        Mt = function () {
                            var e = y,
                                t = Ne(),
                                i = He();
                            y < t ? (e = t) : y > i && (e = i);
                            var n,
                                a = ae;
                            return re && !R && !se && y < t
                                ? (r.close(), !0)
                                : (re &&
                                      (n = function (e) {
                                          Ce((1 - a) * e + a);
                                      }),
                                  r.zoomTo(e, 0, 200, o.easing.cubic.out, n),
                                  !0);
                        };
                    Se("Gestures", {
                        publicMethods: {
                            initGestures: function () {
                                var e = function (e, t, i, n, o) {
                                    (_ = e + t), (A = e + i), (L = e + n), (C = o ? e + o : "");
                                };
                                (q = F.pointerEvent) && F.touch && (F.touch = !1),
                                    q
                                        ? navigator.msPointerEnabled
                                            ? e("MSPointer", "Down", "Move", "Up", "Cancel")
                                            : e("pointer", "down", "move", "up", "cancel")
                                        : F.touch
                                        ? (e("touch", "start", "move", "end", "cancel"), (I = !0))
                                        : e("mouse", "down", "move", "up"),
                                    (p = A + " " + L + " " + C),
                                    (f = _),
                                    q && !I && (I = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
                                    (r.likelyTouchDevice = I),
                                    (m[_] = Ct),
                                    (m[A] = kt),
                                    (m[L] = It),
                                    C && (m[C] = m[L]),
                                    F.touch && ((f += " mousedown"), (p += " mousemove mouseup"), (m.mousedown = m[_]), (m.mousemove = m[A]), (m.mouseup = m[L])),
                                    I || (a.allowPanToNext = !1);
                            },
                        },
                    });
                    var zt,
                        Ft,
                        Ot,
                        Nt,
                        Ht,
                        Ut,
                        Rt = function (t, i, n, s) {
                            var c;
                            zt && clearTimeout(zt), (Nt = !0), (Ot = !0), t.initialLayout ? ((c = t.initialLayout), (t.initialLayout = null)) : (c = a.getThumbBoundsFn && a.getThumbBoundsFn(u));
                            var d = n ? a.hideAnimationDuration : a.showAnimationDuration,
                                h = function () {
                                    $e("initialZoom"),
                                        n ? (r.template.removeAttribute("style"), r.bg.removeAttribute("style")) : (Ce(1), i && (i.style.display = "block"), o.addClass(e, "pswp--animated-in"), Ae("initialZoom" + (n ? "OutEnd" : "InEnd"))),
                                        s && s(),
                                        (Nt = !1);
                                };
                            if (!d || !c || void 0 === c.x)
                                return (
                                    Ae("initialZoom" + (n ? "Out" : "In")),
                                    (y = t.initialZoomLevel),
                                    je(de, t.initialPosition),
                                    qe(),
                                    (e.style.opacity = n ? 0 : 1),
                                    Ce(1),
                                    void (d
                                        ? setTimeout(function () {
                                              h();
                                          }, d)
                                        : h())
                                );
                            !(function () {
                                var i = l,
                                    s = !r.currItem.src || r.currItem.loadError || a.showHideOpacity;
                                t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"),
                                    n || ((y = c.w / t.w), (de.x = c.x), (de.y = c.y - j), (r[s ? "template" : "bg"].style.opacity = 0.001), qe()),
                                    Ze("initialZoom"),
                                    n && !i && o.removeClass(e, "pswp--animated-in"),
                                    s &&
                                        (n
                                            ? o[(i ? "remove" : "add") + "Class"](e, "pswp--animate_opacity")
                                            : setTimeout(function () {
                                                  o.addClass(e, "pswp--animate_opacity");
                                              }, 30)),
                                    (zt = setTimeout(
                                        function () {
                                            if ((Ae("initialZoom" + (n ? "Out" : "In")), n)) {
                                                var r = c.w / t.w,
                                                    a = { x: de.x, y: de.y },
                                                    l = y,
                                                    u = ae,
                                                    p = function (t) {
                                                        1 === t ? ((y = r), (de.x = c.x), (de.y = c.y - z)) : ((y = (r - l) * t + l), (de.x = (c.x - a.x) * t + a.x), (de.y = (c.y - z - a.y) * t + a.y)),
                                                            qe(),
                                                            s ? (e.style.opacity = 1 - t) : Ce(u - t * u);
                                                    };
                                                i ? Ye("initialZoom", 0, 1, d, o.easing.cubic.out, p, h) : (p(1), (zt = setTimeout(h, d + 20)));
                                            } else (y = t.initialZoomLevel), je(de, t.initialPosition), qe(), Ce(1), s ? (e.style.opacity = 1) : Ce(1), (zt = setTimeout(h, d + 20));
                                        },
                                        n ? 25 : 90
                                    ));
                            })();
                        },
                        Bt = {},
                        Wt = [],
                        Vt = {
                            index: 0,
                            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                            forceProgressiveLoading: !1,
                            preload: [1, 1],
                            getNumItemsFn: function () {
                                return Ft.length;
                            },
                        },
                        Gt = function (e, t, i) {
                            if (e.src && !e.loadError) {
                                var n = !i;
                                if ((n && (e.vGap || (e.vGap = { top: 0, bottom: 0 }), Ae("parseVerticalMargin", e)), (Bt.x = t.x), (Bt.y = t.y - e.vGap.top - e.vGap.bottom), n)) {
                                    var o = Bt.x / e.w,
                                        r = Bt.y / e.h;
                                    e.fitRatio = o < r ? o : r;
                                    var s = a.scaleMode;
                                    "orig" === s ? (i = 1) : "fit" === s && (i = e.fitRatio), i > 1 && (i = 1), (e.initialZoomLevel = i), e.bounds || (e.bounds = { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } });
                                }
                                if (!i) return;
                                return (
                                    (function (e, t, i) {
                                        var n = e.bounds;
                                        (n.center.x = Math.round((Bt.x - t) / 2)),
                                            (n.center.y = Math.round((Bt.y - i) / 2) + e.vGap.top),
                                            (n.max.x = t > Bt.x ? Math.round(Bt.x - t) : n.center.x),
                                            (n.max.y = i > Bt.y ? Math.round(Bt.y - i) + e.vGap.top : n.center.y),
                                            (n.min.x = t > Bt.x ? 0 : n.center.x),
                                            (n.min.y = i > Bt.y ? e.vGap.top : n.center.y);
                                    })(e, e.w * i, e.h * i),
                                    n && i === e.initialZoomLevel && (e.initialPosition = e.bounds.center),
                                    e.bounds
                                );
                            }
                            return (e.w = e.h = 0), (e.initialZoomLevel = e.fitRatio = 1), (e.bounds = { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } }), (e.initialPosition = e.bounds.center), e.bounds;
                        },
                        $t = function (e, t, i, n, o, a) {
                            t.loadError ||
                                (n &&
                                    ((t.imageAppended = !0),
                                    Yt(t, n, t === r.currItem && we),
                                    i.appendChild(n),
                                    a &&
                                        setTimeout(function () {
                                            t && t.loaded && t.placeholder && ((t.placeholder.style.display = "none"), (t.placeholder = null));
                                        }, 500)));
                        },
                        Zt = function (e) {
                            (e.loading = !0), (e.loaded = !1);
                            var t = (e.img = o.createEl("pswp__img", "img")),
                                i = function () {
                                    (e.loading = !1), (e.loaded = !0), e.loadComplete ? e.loadComplete(e) : (e.img = null), (t.onload = t.onerror = null), (t = null);
                                };
                            return (
                                (t.onload = i),
                                (t.onerror = function () {
                                    (e.loadError = !0), i();
                                }),
                                (t.src = e.src),
                                t
                            );
                        },
                        Xt = function (e, t) {
                            if (e.src && e.loadError && e.container) return t && (e.container.innerHTML = ""), (e.container.innerHTML = a.errorMsg.replace("%url%", e.src)), !0;
                        },
                        Yt = function (e, t, i) {
                            if (e.src) {
                                t || (t = e.container.lastChild);
                                var n = i ? e.w : Math.round(e.w * e.fitRatio),
                                    o = i ? e.h : Math.round(e.h * e.fitRatio);
                                e.placeholder && !e.loaded && ((e.placeholder.style.width = n + "px"), (e.placeholder.style.height = o + "px")), (t.style.width = n + "px"), (t.style.height = o + "px");
                            }
                        },
                        Kt = function () {
                            if (Wt.length) {
                                for (var e, t = 0; t < Wt.length; t++) (e = Wt[t]).holder.index === e.index && $t(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
                                Wt = [];
                            }
                        };
                    Se("Controller", {
                        publicMethods: {
                            lazyLoadItem: function (e) {
                                e = Ee(e);
                                var t = Ht(e);
                                t && ((!t.loaded && !t.loading) || S) && (Ae("gettingData", e, t), t.src && Zt(t));
                            },
                            initController: function () {
                                o.extend(a, Vt, !0),
                                    (r.items = Ft = i),
                                    (Ht = r.getItemAt),
                                    (Ut = a.getNumItemsFn),
                                    a.loop,
                                    Ut() < 3 && (a.loop = !1),
                                    _e("beforeChange", function (e) {
                                        var t,
                                            i = a.preload,
                                            n = null === e || e >= 0,
                                            o = Math.min(i[0], Ut()),
                                            s = Math.min(i[1], Ut());
                                        for (t = 1; t <= (n ? s : o); t++) r.lazyLoadItem(u + t);
                                        for (t = 1; t <= (n ? o : s); t++) r.lazyLoadItem(u - t);
                                    }),
                                    _e("initialLayout", function () {
                                        r.currItem.initialLayout = a.getThumbBoundsFn && a.getThumbBoundsFn(u);
                                    }),
                                    _e("mainScrollAnimComplete", Kt),
                                    _e("initialZoomInEnd", Kt),
                                    _e("destroy", function () {
                                        for (var e, t = 0; t < Ft.length; t++)
                                            (e = Ft[t]).container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                                        Wt = null;
                                    });
                            },
                            getItemAt: function (e) {
                                return e >= 0 && void 0 !== Ft[e] && Ft[e];
                            },
                            allowProgressiveImg: function () {
                                return a.forceProgressiveLoading || !I || a.mouseUsed || screen.width > 1200;
                            },
                            setContent: function (e, t) {
                                a.loop && (t = Ee(t));
                                var i = r.getItemAt(e.index);
                                i && (i.container = null);
                                var n,
                                    c = r.getItemAt(t);
                                if (c) {
                                    Ae("gettingData", t, c), (e.index = t), (e.item = c);
                                    var l = (c.container = o.createEl("pswp__zoom-wrap"));
                                    if ((!c.src && c.html && (c.html.tagName ? l.appendChild(c.html) : (l.innerHTML = c.html)), Xt(c), Gt(c, he), !c.src || c.loadError || c.loaded))
                                        c.src && !c.loadError && (((n = o.createEl("pswp__img", "img")).style.opacity = 1), (n.src = c.src), Yt(c, n), $t(0, c, l, n));
                                    else {
                                        if (
                                            ((c.loadComplete = function (i) {
                                                if (s) {
                                                    if (e && e.index === t) {
                                                        if (Xt(i, !0)) return (i.loadComplete = i.img = null), Gt(i, he), Ie(i), void (e.index === u && r.updateCurrZoomItem());
                                                        i.imageAppended
                                                            ? !Nt && i.placeholder && ((i.placeholder.style.display = "none"), (i.placeholder = null))
                                                            : F.transform && (ie || Nt)
                                                            ? Wt.push({ item: i, baseDiv: l, img: i.img, index: t, holder: e, clearPlaceholder: !0 })
                                                            : $t(0, i, l, i.img, 0, !0);
                                                    }
                                                    (i.loadComplete = null), (i.img = null), Ae("imageLoadComplete", t, i);
                                                }
                                            }),
                                            o.features.transform)
                                        ) {
                                            var d = "pswp__img pswp__img--placeholder";
                                            d += c.msrc ? "" : " pswp__img--placeholder--blank";
                                            var h = o.createEl(d, c.msrc ? "img" : "");
                                            c.msrc && (h.src = c.msrc), Yt(c, h), l.appendChild(h), (c.placeholder = h);
                                        }
                                        c.loading || Zt(c), r.allowProgressiveImg() && (!Ot && F.transform ? Wt.push({ item: c, baseDiv: l, img: c.img, index: t, holder: e }) : $t(0, c, l, c.img, 0, !0));
                                    }
                                    Ot || t !== u ? Ie(c) : ((te = l.style), Rt(c, n || c.img)), (e.el.innerHTML = ""), e.el.appendChild(l);
                                } else e.el.innerHTML = "";
                            },
                            cleanSlide: function (e) {
                                e.img && (e.img.onload = e.img.onerror = null), (e.loaded = e.loading = e.img = e.imageAppended = !1);
                            },
                        },
                    });
                    var Jt,
                        Qt,
                        ei = {},
                        ti = function (e, t, i) {
                            var n = document.createEvent("CustomEvent"),
                                o = { origEvent: e, target: e.target, releasePoint: t, pointerType: i || "touch" };
                            n.initCustomEvent("pswpTap", !0, !0, o), e.target.dispatchEvent(n);
                        };
                    Se("Tap", {
                        publicMethods: {
                            initTap: function () {
                                _e("firstTouchStart", r.onTapStart),
                                    _e("touchRelease", r.onTapRelease),
                                    _e("destroy", function () {
                                        (ei = {}), (Jt = null);
                                    });
                            },
                            onTapStart: function (e) {
                                e.length > 1 && (clearTimeout(Jt), (Jt = null));
                            },
                            onTapRelease: function (e, t) {
                                if (t && !Z && !G && !Ge) {
                                    var i = t;
                                    if (
                                        Jt &&
                                        (clearTimeout(Jt),
                                        (Jt = null),
                                        (function (e, t) {
                                            return Math.abs(e.x - t.x) < 25 && Math.abs(e.y - t.y) < 25;
                                        })(i, ei))
                                    )
                                        return void Ae("doubleTap", i);
                                    if ("mouse" === t.type) return void ti(e, t, "mouse");
                                    if ("BUTTON" === e.target.tagName.toUpperCase() || o.hasClass(e.target, "pswp__single-tap")) return void ti(e, t);
                                    je(ei, i),
                                        (Jt = setTimeout(function () {
                                            ti(e, t), (Jt = null);
                                        }, 300));
                                }
                            },
                        },
                    }),
                        Se("DesktopZoom", {
                            publicMethods: {
                                initDesktopZoom: function () {
                                    M ||
                                        (I
                                            ? _e("mouseUsed", function () {
                                                  r.setupDesktopZoom();
                                              })
                                            : r.setupDesktopZoom(!0));
                                },
                                setupDesktopZoom: function (t) {
                                    Qt = {};
                                    var i = "wheel mousewheel DOMMouseScroll";
                                    _e("bindEvents", function () {
                                        o.bind(e, i, r.handleMouseWheel);
                                    }),
                                        _e("unbindEvents", function () {
                                            Qt && o.unbind(e, i, r.handleMouseWheel);
                                        }),
                                        (r.mouseZoomedIn = !1);
                                    var n,
                                        a = function () {
                                            r.mouseZoomedIn && (o.removeClass(e, "pswp--zoomed-in"), (r.mouseZoomedIn = !1)), y < 1 ? o.addClass(e, "pswp--zoom-allowed") : o.removeClass(e, "pswp--zoom-allowed"), s();
                                        },
                                        s = function () {
                                            n && (o.removeClass(e, "pswp--dragging"), (n = !1));
                                        };
                                    _e("resize", a),
                                        _e("afterChange", a),
                                        _e("pointerDown", function () {
                                            r.mouseZoomedIn && ((n = !0), o.addClass(e, "pswp--dragging"));
                                        }),
                                        _e("pointerUp", s),
                                        t || a();
                                },
                                handleMouseWheel: function (e) {
                                    if (y <= r.currItem.fitRatio) return a.modal && (!a.closeOnScroll || Ge || V ? e.preventDefault() : k && Math.abs(e.deltaY) > 2 && ((l = !0), r.close())), !0;
                                    if ((e.stopPropagation(), (Qt.x = 0), "deltaX" in e)) 1 === e.deltaMode ? ((Qt.x = 18 * e.deltaX), (Qt.y = 18 * e.deltaY)) : ((Qt.x = e.deltaX), (Qt.y = e.deltaY));
                                    else if ("wheelDelta" in e) e.wheelDeltaX && (Qt.x = -0.16 * e.wheelDeltaX), e.wheelDeltaY ? (Qt.y = -0.16 * e.wheelDeltaY) : (Qt.y = -0.16 * e.wheelDelta);
                                    else {
                                        if (!("detail" in e)) return;
                                        Qt.y = e.detail;
                                    }
                                    Oe(y, !0);
                                    var t = de.x - Qt.x,
                                        i = de.y - Qt.y;
                                    (a.modal || (t <= ee.min.x && t >= ee.max.x && i <= ee.min.y && i >= ee.max.y)) && e.preventDefault(), r.panTo(t, i);
                                },
                                toggleDesktopZoom: function (t) {
                                    t = t || { x: he.x / 2 + fe.x, y: he.y / 2 + fe.y };
                                    var i = a.getDoubleTapZoom(!0, r.currItem),
                                        n = y === i;
                                    (r.mouseZoomedIn = !n), r.zoomTo(n ? r.currItem.initialZoomLevel : i, t, 333), o[(n ? "remove" : "add") + "Class"](e, "pswp--zoomed-in");
                                },
                            },
                        });
                    var ii,
                        ni,
                        oi,
                        ri,
                        ai,
                        si,
                        ci,
                        li,
                        ui,
                        di,
                        hi,
                        pi,
                        fi = { history: !0, galleryUID: 1 },
                        mi = function () {
                            return hi.hash.substring(1);
                        },
                        yi = function () {
                            ii && clearTimeout(ii), oi && clearTimeout(oi);
                        },
                        vi = function () {
                            var e = mi(),
                                t = {};
                            if (e.length < 5) return t;
                            var i,
                                n = e.split("&");
                            for (i = 0; i < n.length; i++)
                                if (n[i]) {
                                    var o = n[i].split("=");
                                    o.length < 2 || (t[o[0]] = o[1]);
                                }
                            if (a.galleryPIDs) {
                                var r = t.pid;
                                for (t.pid = 0, i = 0; i < Ft.length; i++)
                                    if (Ft[i].pid === r) {
                                        t.pid = i;
                                        break;
                                    }
                            } else t.pid = parseInt(t.pid, 10) - 1;
                            return t.pid < 0 && (t.pid = 0), t;
                        },
                        gi = function () {
                            if ((oi && clearTimeout(oi), Ge || V)) oi = setTimeout(gi, 500);
                            else {
                                ri ? clearTimeout(ni) : (ri = !0);
                                var e = u + 1,
                                    t = Ht(u);
                                t.hasOwnProperty("pid") && (e = t.pid);
                                var i = ci + "&gid=" + a.galleryUID + "&pid=" + e;
                                li || (-1 === hi.hash.indexOf(i) && (di = !0));
                                var n = hi.href.split("#")[0] + "#" + i;
                                pi ? "#" + i !== window.location.hash && history[li ? "replaceState" : "pushState"]("", document.title, n) : li ? hi.replace(n) : (hi.hash = i),
                                    (li = !0),
                                    (ni = setTimeout(function () {
                                        ri = !1;
                                    }, 60));
                            }
                        };
                    Se("History", {
                        publicMethods: {
                            initHistory: function () {
                                if ((o.extend(a, fi, !0), a.history)) {
                                    (hi = window.location),
                                        (di = !1),
                                        (ui = !1),
                                        (li = !1),
                                        (ci = mi()),
                                        (pi = "pushState" in history),
                                        ci.indexOf("gid=") > -1 && (ci = (ci = ci.split("&gid=")[0]).split("?gid=")[0]),
                                        _e("afterChange", r.updateURL),
                                        _e("unbindEvents", function () {
                                            o.unbind(window, "hashchange", r.onHashChange);
                                        });
                                    var e = function () {
                                        (si = !0), ui || (di ? history.back() : ci ? (hi.hash = ci) : pi ? history.pushState("", document.title, hi.pathname + hi.search) : (hi.hash = "")), yi();
                                    };
                                    _e("unbindEvents", function () {
                                        l && e();
                                    }),
                                        _e("destroy", function () {
                                            si || e();
                                        }),
                                        _e("firstUpdate", function () {
                                            u = vi().pid;
                                        });
                                    var t = ci.indexOf("pid=");
                                    t > -1 && "&" === (ci = ci.substring(0, t)).slice(-1) && (ci = ci.slice(0, -1)),
                                        setTimeout(function () {
                                            s && o.bind(window, "hashchange", r.onHashChange);
                                        }, 40);
                                }
                            },
                            onHashChange: function () {
                                return mi() === ci ? ((ui = !0), void r.close()) : void (ri || ((ai = !0), r.goTo(vi().pid), (ai = !1)));
                            },
                            updateURL: function () {
                                yi(), ai || (li ? (ii = setTimeout(gi, 800)) : gi());
                            },
                        },
                    }),
                        o.extend(r, Ke);
                };
            }),
            "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? (module.exports = t()) : (e.PhotoSwipe = t()),
            (function (e, t) {
                "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? (module.exports = t()) : (e.PhotoSwipeUI_Default = t());
            })(this, function () {
                "use strict";
                return function (e, t) {
                    var i,
                        n,
                        o,
                        r,
                        a,
                        s,
                        c,
                        l,
                        u,
                        d,
                        h,
                        p,
                        f,
                        m,
                        y,
                        v,
                        g,
                        b,
                        w = this,
                        S = !1,
                        E = !0,
                        x = !0,
                        _ = {
                            barsSize: { top: 44, bottom: "auto" },
                            closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                            timeToIdle: 4e3,
                            timeToIdleOutside: 1e3,
                            loadingIndicatorDelay: 1e3,
                            addCaptionHTMLFn: function (e, t) {
                                return e.title ? ((t.children[0].innerHTML = e.title), !0) : ((t.children[0].innerHTML = ""), !1);
                            },
                            closeEl: !0,
                            captionEl: !0,
                            fullscreenEl: !0,
                            zoomEl: !0,
                            shareEl: !0,
                            counterEl: !0,
                            arrowEl: !0,
                            preloaderEl: !0,
                            tapToClose: !1,
                            tapToToggleControls: !0,
                            clickToCloseNonZoomable: !0,
                            shareButtons: [
                                { id: "facebook", label: "Share on Facebook", url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" },
                                { id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" },
                                { id: "pinterest", label: "Pin it", url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" },
                                { id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0 },
                            ],
                            getImageURLForShare: function () {
                                return e.currItem.src || "";
                            },
                            getPageURLForShare: function () {
                                return window.location.href;
                            },
                            getTextForShare: function () {
                                return e.currItem.title || "";
                            },
                            indexIndicatorSep: " / ",
                            fitControlsWidth: 1200,
                        },
                        A = function (e) {
                            if (v) return !0;
                            (e = e || window.event), y.timeToIdle && y.mouseUsed && !u && M();
                            for (var i, n, o = (e.target || e.srcElement).getAttribute("class") || "", r = 0; r < N.length; r++) (i = N[r]).onTap && o.indexOf("pswp__" + i.name) > -1 && (i.onTap(), (n = !0));
                            if (n) {
                                e.stopPropagation && e.stopPropagation(), (v = !0);
                                var a = t.features.isOldAndroid ? 600 : 30;
                                setTimeout(function () {
                                    v = !1;
                                }, a);
                            }
                        },
                        L = function () {
                            return !e.likelyTouchDevice || y.mouseUsed || screen.width > y.fitControlsWidth;
                        },
                        C = function (e, i, n) {
                            t[(n ? "add" : "remove") + "Class"](e, "pswp__" + i);
                        },
                        k = function () {
                            var e = 1 === y.getNumItemsFn();
                            e !== m && (C(n, "ui--one-slide", e), (m = e));
                        },
                        q = function () {
                            C(c, "share-modal--hidden", x);
                        },
                        I = function () {
                            return (
                                (x = !x)
                                    ? (t.removeClass(c, "pswp__share-modal--fade-in"),
                                      setTimeout(function () {
                                          x && q();
                                      }, 300))
                                    : (q(),
                                      setTimeout(function () {
                                          x || t.addClass(c, "pswp__share-modal--fade-in");
                                      }, 30)),
                                x || D(),
                                !1
                            );
                        },
                        T = function (t) {
                            var i = (t = t || window.event).target || t.srcElement;
                            return (
                                e.shout("shareLinkClick", t, i),
                                !(
                                    !i.href ||
                                    (!i.hasAttribute("download") &&
                                        (window.open(i.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)),
                                        x || I(),
                                        1))
                                )
                            );
                        },
                        D = function () {
                            for (var e, t, i, n, o = "", r = 0; r < y.shareButtons.length; r++)
                                (e = y.shareButtons[r]),
                                    (t = y.getImageURLForShare(e)),
                                    (i = y.getPageURLForShare(e)),
                                    (n = y.getTextForShare(e)),
                                    (o +=
                                        '<a href="' +
                                        e.url.replace("{{url}}", encodeURIComponent(i)).replace("{{image_url}}", encodeURIComponent(t)).replace("{{raw_image_url}}", t).replace("{{text}}", encodeURIComponent(n)) +
                                        '" target="_blank" class="pswp__share--' +
                                        e.id +
                                        '"' +
                                        (e.download ? "download" : "") +
                                        ">" +
                                        e.label +
                                        "</a>"),
                                    y.parseShareButtonOut && (o = y.parseShareButtonOut(e, o));
                            (c.children[0].innerHTML = o), (c.children[0].onclick = T);
                        },
                        P = function (e) {
                            for (var i = 0; i < y.closeElClasses.length; i++) if (t.hasClass(e, "pswp__" + y.closeElClasses[i])) return !0;
                        },
                        j = 0,
                        M = function () {
                            clearTimeout(b), (j = 0), u && w.setIdle(!1);
                        },
                        z = function (e) {
                            var t = (e = e || window.event).relatedTarget || e.toElement;
                            (t && "HTML" !== t.nodeName) ||
                                (clearTimeout(b),
                                (b = setTimeout(function () {
                                    w.setIdle(!0);
                                }, y.timeToIdleOutside)));
                        },
                        F = function (e) {
                            p !== e && (C(h, "preloader--active", !e), (p = e));
                        },
                        O = function (e) {
                            var i = e.vGap;
                            if (L()) {
                                var a = y.barsSize;
                                if (y.captionEl && "auto" === a.bottom)
                                    if ((r || ((r = t.createEl("pswp__caption pswp__caption--fake")).appendChild(t.createEl("pswp__caption__center")), n.insertBefore(r, o), t.addClass(n, "pswp__ui--fit")), y.addCaptionHTMLFn(e, r, !0))) {
                                        var s = r.clientHeight;
                                        i.bottom = parseInt(s, 10) || 44;
                                    } else i.bottom = a.top;
                                else i.bottom = "auto" === a.bottom ? 0 : a.bottom;
                                i.top = a.top;
                            } else i.top = i.bottom = 0;
                        },
                        N = [
                            {
                                name: "caption",
                                option: "captionEl",
                                onInit: function (e) {
                                    o = e;
                                },
                            },
                            {
                                name: "share-modal",
                                option: "shareEl",
                                onInit: function (e) {
                                    c = e;
                                },
                                onTap: function () {
                                    I();
                                },
                            },
                            {
                                name: "button--share",
                                option: "shareEl",
                                onInit: function (e) {
                                    s = e;
                                },
                                onTap: function () {
                                    I();
                                },
                            },
                            { name: "button--zoom", option: "zoomEl", onTap: e.toggleDesktopZoom },
                            {
                                name: "counter",
                                option: "counterEl",
                                onInit: function (e) {
                                    a = e;
                                },
                            },
                            { name: "button--close", option: "closeEl", onTap: e.close },
                            { name: "button--arrow--left", option: "arrowEl", onTap: e.prev },
                            { name: "button--arrow--right", option: "arrowEl", onTap: e.next },
                            {
                                name: "button--fs",
                                option: "fullscreenEl",
                                onTap: function () {
                                    i.isFullscreen() ? i.exit() : i.enter();
                                },
                            },
                            {
                                name: "preloader",
                                option: "preloaderEl",
                                onInit: function (e) {
                                    h = e;
                                },
                            },
                        ];
                    (w.init = function () {
                        t.extend(e.options, _, !0),
                            (y = e.options),
                            (n = t.getChildByClass(e.scrollWrap, "pswp__ui")),
                            (d = e.listen),
                            (function () {
                                var e;
                                d("onVerticalDrag", function (e) {
                                    E && e < 0.95 ? w.hideControls() : !E && e >= 0.95 && w.showControls();
                                }),
                                    d("onPinchClose", function (t) {
                                        E && t < 0.9 ? (w.hideControls(), (e = !0)) : e && !E && t > 0.9 && w.showControls();
                                    }),
                                    d("zoomGestureEnded", function () {
                                        (e = !1) && !E && w.showControls();
                                    });
                            })(),
                            d("beforeChange", w.update),
                            d("doubleTap", function (t) {
                                var i = e.currItem.initialZoomLevel;
                                e.getZoomLevel() !== i ? e.zoomTo(i, t, 333) : e.zoomTo(y.getDoubleTapZoom(!1, e.currItem), t, 333);
                            }),
                            d("preventDragEvent", function (e, t, i) {
                                var n = e.target || e.srcElement;
                                n && n.getAttribute("class") && e.type.indexOf("mouse") > -1 && (n.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(n.tagName)) && (i.prevent = !1);
                            }),
                            d("bindEvents", function () {
                                t.bind(n, "pswpTap click", A), t.bind(e.scrollWrap, "pswpTap", w.onGlobalTap), e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", w.onMouseOver);
                            }),
                            d("unbindEvents", function () {
                                x || I(),
                                    g && clearInterval(g),
                                    t.unbind(document, "mouseout", z),
                                    t.unbind(document, "mousemove", M),
                                    t.unbind(n, "pswpTap click", A),
                                    t.unbind(e.scrollWrap, "pswpTap", w.onGlobalTap),
                                    t.unbind(e.scrollWrap, "mouseover", w.onMouseOver),
                                    i && (t.unbind(document, i.eventK, w.updateFullscreen), i.isFullscreen() && ((y.hideAnimationDuration = 0), i.exit()), (i = null));
                            }),
                            d("destroy", function () {
                                y.captionEl && (r && n.removeChild(r), t.removeClass(o, "pswp__caption--empty")),
                                    c && (c.children[0].onclick = null),
                                    t.removeClass(n, "pswp__ui--over-close"),
                                    t.addClass(n, "pswp__ui--hidden"),
                                    w.setIdle(!1);
                            }),
                            y.showAnimationDuration || t.removeClass(n, "pswp__ui--hidden"),
                            d("initialZoomIn", function () {
                                y.showAnimationDuration && t.removeClass(n, "pswp__ui--hidden");
                            }),
                            d("initialZoomOut", function () {
                                t.addClass(n, "pswp__ui--hidden");
                            }),
                            d("parseVerticalMargin", O),
                            (function () {
                                var e,
                                    i,
                                    o,
                                    r = function (n) {
                                        if (n)
                                            for (var r = n.length, a = 0; a < r; a++) {
                                                (e = n[a]), (i = e.className);
                                                for (var s = 0; s < N.length; s++)
                                                    (o = N[s]), i.indexOf("pswp__" + o.name) > -1 && (y[o.option] ? (t.removeClass(e, "pswp__element--disabled"), o.onInit && o.onInit(e)) : t.addClass(e, "pswp__element--disabled"));
                                            }
                                    };
                                r(n.children);
                                var a = t.getChildByClass(n, "pswp__top-bar");
                                a && r(a.children);
                            })(),
                            y.shareEl && s && c && (x = !0),
                            k(),
                            y.timeToIdle &&
                                d("mouseUsed", function () {
                                    t.bind(document, "mousemove", M),
                                        t.bind(document, "mouseout", z),
                                        (g = setInterval(function () {
                                            2 == ++j && w.setIdle(!0);
                                        }, y.timeToIdle / 2));
                                }),
                            y.fullscreenEl &&
                                !t.features.isOldAndroid &&
                                (i || (i = w.getFullscreenAPI()), i ? (t.bind(document, i.eventK, w.updateFullscreen), w.updateFullscreen(), t.addClass(e.template, "pswp--supports-fs")) : t.removeClass(e.template, "pswp--supports-fs")),
                            y.preloaderEl &&
                                (F(!0),
                                d("beforeChange", function () {
                                    clearTimeout(f),
                                        (f = setTimeout(function () {
                                            e.currItem && e.currItem.loading ? (!e.allowProgressiveImg() || (e.currItem.img && !e.currItem.img.naturalWidth)) && F(!1) : F(!0);
                                        }, y.loadingIndicatorDelay));
                                }),
                                d("imageLoadComplete", function (t, i) {
                                    e.currItem === i && F(!0);
                                }));
                    }),
                        (w.setIdle = function (e) {
                            (u = e), C(n, "ui--idle", e);
                        }),
                        (w.update = function () {
                            E && e.currItem ? (w.updateIndexIndicator(), y.captionEl && (y.addCaptionHTMLFn(e.currItem, o), C(o, "caption--empty", !e.currItem.title)), (S = !0)) : (S = !1), x || I(), k();
                        }),
                        (w.updateFullscreen = function (n) {
                            n &&
                                setTimeout(function () {
                                    e.setScrollOffset(0, t.getScrollY());
                                }, 50),
                                t[(i.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pswp--fs");
                        }),
                        (w.updateIndexIndicator = function () {
                            y.counterEl && (a.innerHTML = e.getCurrentIndex() + 1 + y.indexIndicatorSep + y.getNumItemsFn());
                        }),
                        (w.onGlobalTap = function (i) {
                            var n = (i = i || window.event).target || i.srcElement;
                            if (!v)
                                if (i.detail && "mouse" === i.detail.pointerType) {
                                    if (P(n)) return void e.close();
                                    t.hasClass(n, "pswp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? y.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(i.detail.releasePoint));
                                } else if ((y.tapToToggleControls && (E ? w.hideControls() : w.showControls()), y.tapToClose && (t.hasClass(n, "pswp__img") || P(n)))) return void e.close();
                        }),
                        (w.onMouseOver = function (e) {
                            var t = (e = e || window.event).target || e.srcElement;
                            C(n, "ui--over-close", P(t));
                        }),
                        (w.hideControls = function () {
                            t.addClass(n, "pswp__ui--hidden"), (E = !1);
                        }),
                        (w.showControls = function () {
                            (E = !0), S || w.update(), t.removeClass(n, "pswp__ui--hidden");
                        }),
                        (w.supportsFullscreen = function () {
                            var e = document;
                            return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen);
                        }),
                        (w.getFullscreenAPI = function () {
                            var t,
                                i = document.documentElement,
                                n = "fullscreenchange";
                            return (
                                i.requestFullscreen
                                    ? (t = { enterK: "requestFullscreen", exitK: "exitFullscreen", elementK: "fullscreenElement", eventK: n })
                                    : i.mozRequestFullScreen
                                    ? (t = { enterK: "mozRequestFullScreen", exitK: "mozCancelFullScreen", elementK: "mozFullScreenElement", eventK: "moz" + n })
                                    : i.webkitRequestFullscreen
                                    ? (t = { enterK: "webkitRequestFullscreen", exitK: "webkitExitFullscreen", elementK: "webkitFullscreenElement", eventK: "webkit" + n })
                                    : i.msRequestFullscreen && (t = { enterK: "msRequestFullscreen", exitK: "msExitFullscreen", elementK: "msFullscreenElement", eventK: "MSFullscreenChange" }),
                                t &&
                                    ((t.enter = function () {
                                        return (l = y.closeOnScroll), (y.closeOnScroll = !1), "webkitRequestFullscreen" !== this.enterK ? e.template[this.enterK]() : void e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                                    }),
                                    (t.exit = function () {
                                        return (y.closeOnScroll = l), document[this.exitK]();
                                    }),
                                    (t.isFullscreen = function () {
                                        return document[this.elementK];
                                    })),
                                t
                            );
                        });
                };
            });
    })();
var Events = new EventEmitter3();
(Events.trigger = Events.emit),
    (window.WAU = window.WAU || {}),
    (WAU.Slideout = (function () {
        var e = void 0;
        function t() {
            const e = document.querySelector(".slideout--active"),
                t = e.getAttribute("data-wau-slideout"),
                i = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + t + '"]'),
                o = i.getAttribute("data-slideout-direction");
            null !== e.getAttribute("data-wau-accordions-closed") && WAU.Accordion.hideAll(t), n(o);
        }
        function i(t, i, n) {
            e.classList.add("slideout-" + t + "--open"), e.classList.remove("slideout-" + t + "--closed"), i.classList.add("slideout--active"), n.setAttribute("aria-expanded", "true");
            let o = Math.abs(0 - document.querySelector(".site-wrap").getBoundingClientRect().top);
            i.querySelectorAll("*").forEach((e, t) => {
                e.removeAttribute("tabIndex");
            }),
                (e.style.overflow = "hidden"),
                (e.style.position = "fixed"),
                (e.style.top = `-${o}px`),
                (e.style.width = "100%");
        }
        function n(t) {
            const i = document.querySelectorAll(".slideout--active"),
                n = document.querySelectorAll(".js-slideout-open"),
                o = document.querySelectorAll(".js-slideout-close");
            e.classList.remove("slideout-" + t + "--open"),
                e.classList.add("slideout-" + t + "--closed"),
                i.forEach(function (e) {
                    e.classList.remove("slideout--active");
                    const t = e.getAttribute("data-wau-accordions-closed"),
                        i = e.getAttribute("data-wau-slideout");
                    null !== t && WAU.Accordion.hideAll(i),
                        e.querySelectorAll("*").forEach((e, t) => {
                            e.setAttribute("tabIndex", "-1");
                        });
                }),
                n.forEach(function (e) {
                    e.setAttribute("aria-expanded", "false");
                }),
                o.forEach(function (e) {
                    e.setAttribute("aria-expanded", "false");
                });
            let r = Math.abs(0 - document.querySelector(".site-wrap").getBoundingClientRect().top);
            e.style.removeProperty("overflow"), e.style.removeProperty("position"), e.style.removeProperty("top"), e.style.removeProperty("width"), window.scrollTo(0, r);
        }
        function o(t, i, n) {
            const o = document.createElement("aside"),
                r = document.createElement("div"),
                a = document.createElement("div"),
                s = document.querySelector('[data-wau-slideout-target="' + i + '"]'),
                c = document.querySelector('[data-wau-slideout-content="' + i + '"]'),
                l = "slideout-" + i;
            if (
                ((n = n || e),
                c.hasAttribute("data-wau-accordions-closed") && o.setAttribute("data-wau-accordions-closed", ""),
                o.classList.add("slideout"),
                o.classList.add("slideout__drawer-" + t),
                o.setAttribute("data-wau-slideout", i),
                o.setAttribute("id", l),
                r.classList.add("slideout__inner-wrapper"),
                r.classList.add("slideout__general-slide__wrapper"),
                (a.innerHTML = c.innerHTML),
                a.classList.add("slideout__inner-content-container"),
                (c.innerHTML = ""),
                c.dataset.wauSlideoutButton && "true" == c.dataset.wauSlideoutButton)
            ) {
                let e = createCloser(i, t);
                r.prepend(e);
            }
            return o.appendChild(r), r.appendChild(a), s.setAttribute("aria-controls", l), n.appendChild(o), o;
        }
        document.addEventListener("keyup", function (e) {
            "Escape" === e.key && (e.preventDefault(), t());
        }),
            document.addEventListener("click", function (e) {
                e.target === document.querySelector(".js-slideout-overlay") && t();
            });
        const r = {
            openByName: function (e) {
                const t = document.querySelector('[data-wau-slideout-target="' + e + '"]');
                i(t.getAttribute("data-slideout-direction"), document.querySelector('[data-wau-slideout="' + e + '"]'), t);
            },
            closeByName: function (e) {
                const t = document.querySelector('[data-wau-slideout-target="' + e + '"]').getAttribute("data-slideout-direction");
                document.querySelector('.js-slideout-open[data-wau-slideout-target="' + e + '"]'), n(t);
            },
            createSlideoutEl: o,
            reloadSlideoutContents: function (e) {
                const t = document.querySelector('[data-wau-slideout-content="' + e + '"]');
                document.querySelector('aside[data-wau-slideout="' + e + '"]').querySelector(".slideout__inner-content-container").innerHTML = t.innerHTML;
            },
        };
        let a = {
            init: function (t) {
                if (void 0 === t) return void console.log("The Slideout must have an associated name.");
                let r;
                (e = document.querySelector(".js-slideout-toggle-wrapper")),
                    document.querySelectorAll('.js-slideout-open[data-wau-slideout-target="' + t + '"]').forEach((n, a) => {
                        const s = n.getAttribute("data-slideout-direction");
                        n && (r = document.querySelector(`aside[data-wau-slideout=${t}]`)),
                            r || (r = o(s, t, e)),
                            Events.trigger("slideout:active:" + t),
                            n.addEventListener("click", function () {
                                i(s, r, n);
                            });
                    }),
                    document.querySelectorAll(".js-slideout-close").forEach((e, t) => {
                        const i = e.getAttribute("data-slideout-direction");
                        e.addEventListener("click", function () {
                            n(i);
                        });
                    });
            },
        };
        return (
            Object.keys(r).forEach(function (e) {
                a["_" + e] = r[e];
            }),
            a
        );
    })()),
    (WAU.Modal = (function () {
        var e = void 0;
        function t() {
            const e = document.querySelector(".modal--active");
            e.getAttribute("data-wau-modal");
            n(e.querySelector(".js-modal-close"));
        }
        function i(t, i) {
            let n = Math.abs(0 - document.querySelector(".site-wrap").getBoundingClientRect().top);
            if (
                ((e.style.top = `-${n}px`),
                (e.style.width = "100%"),
                ("quickview" == i.getAttribute("data-wau-modal-target") || ("modal-ajax-cart" == t.id && "ajax-cart" == t.getAttribute("data-wau-modal"))) && (t.style.top = `calc(${n}px + 15vh)`),
                t.hasAttribute("data-wau-modal-full") && (e.style.overflowY = "hidden"),
                e.classList.add("modal--open"),
                e.classList.remove("modal--closed"),
                t.classList.add("modal--active"),
                t.getAttribute("data-wau-modal"))
            ) {
                var o = "modal-" + (o = t.getAttribute("data-wau-modal")) + "--open";
                e.classList.add(o);
            }
            i.setAttribute("aria-expanded", "true");
        }
        function n(t) {
            const i = document.querySelectorAll(".modal--active"),
                n = document.querySelectorAll(".js-modal-open"),
                o = document.querySelectorAll(".js-modal-close");
            t && "quickview" == t.getAttribute("aria-controls") && (document.querySelector(".js-quickview-content").innerHTML = ""),
                e.classList.remove("modal--open"),
                e.classList.add("modal--closed"),
                i.forEach(function (t) {
                    if (t.getAttribute("data-wau-modal")) {
                        var i = "modal-" + (i = t.getAttribute("data-wau-modal")) + "--open";
                        e.classList.remove(i);
                    }
                    t.classList.remove("modal--active"), t.hasAttribute("data-wau-modal-full") && (e.style.overflowY = "unset");
                }),
                n.forEach(function (e) {
                    e.setAttribute("aria-expanded", "false");
                }),
                o.forEach(function (e) {
                    e.setAttribute("aria-expanded", "false");
                }),
                e.style.removeProperty("overflow"),
                e.style.removeProperty("position"),
                e.style.removeProperty("padding-right"),
                e.style.removeProperty("top"),
                e.style.removeProperty("width");
        }
        function o(t, i) {
            const n = document.createElement("div"),
                o = document.createElement("div"),
                r = document.createElement("div"),
                a = document.querySelector('[data-wau-modal-target="' + t + '"]'),
                s = document.querySelector('[data-wau-modal-content="' + t + '"]'),
                c = "modal-" + t;
            (i = i || e),
                n.classList.add("modal"),
                n.classList.add("modal__container"),
                s.hasAttribute("data-wau-modal-full") && n.setAttribute("data-wau-modal-full", ""),
                n.setAttribute("data-wau-modal", t),
                n.setAttribute("id", c),
                o.classList.add("modal__inner-wrapper"),
                o.classList.add("modal__general-modal__wrapper"),
                (r.innerHTML = s.innerHTML),
                r.classList.add("modal__inner-content-container");
            let l = (function (e) {
                const t = document.createElement("div"),
                    i = document.createElement("button"),
                    n = document.createElement("div");
                return (
                    t.classList.add("slideout__trigger--close"),
                    t.classList.add("slideout__trigger-" + e + "__wrapper"),
                    t.classList.add("slideout__trigger-general-modal__wrapper"),
                    i.classList.add("slideout__trigger-" + e),
                    i.classList.add("slideout__trigger-general-modal"),
                    i.classList.add("js-modal-close"),
                    i.setAttribute("aria-controls", "modal-" + e),
                    i.setAttribute("aria-label", "Close modal"),
                    n.classList.add("icn-close"),
                    i.appendChild(n),
                    t.appendChild(i),
                    t
                );
            })(t);
            return o.prepend(l), n.appendChild(o), o.appendChild(r), a.setAttribute("aria-controls", c), i.appendChild(n), n;
        }
        document.addEventListener("keyup", function (e) {
            "Escape" === e.key && (e.preventDefault(), t());
        }),
            document.addEventListener("click", function (e) {
                e.target === document.querySelector(".js-modal-overlay") && t();
            });
        const r = {
            openByName: function (e) {
                const t = document.querySelector('[data-wau-modal-target="' + e + '"]');
                i(document.querySelector('[data-wau-modal="' + e + '"]'), t);
            },
            closeByName: function (e) {
                document.querySelector('[data-wau-modal-target="' + e + '"]'), n(document.querySelector('.js-modal-open[data-wau-modal-target="' + e + '"]'));
            },
            createModalEl: o,
        };
        let a = {
            init: function (t) {
                if (void 0 === t) return void console.log("The Modal must have an associated name.");
                e = document.querySelector(".js-modal-toggle-wrapper");
                const r = document.querySelectorAll('.js-modal-open[data-wau-modal-target="' + t + '"]');
                let a;
                r && (a = document.querySelector(`div[data-wau-modal=${t}]`)),
                    a || (a = o(t, e)),
                    r.forEach((e, t) => {
                        e.addEventListener("click", function () {
                            i(a, e);
                        });
                    }),
                    document.querySelectorAll(".js-modal-close").forEach(function (e) {
                        e.addEventListener("click", function () {
                            n(e);
                        });
                    });
            },
        };
        return (
            Object.keys(r).forEach(function (e) {
                a["_" + e] = r[e];
            }),
            a
        );
    })()),
    (WAU.Accordion = (function () {
        const e = { show: "is-active", open: "js-accordion-is-open", mobileNavAccordion: "js-accordion-mobile-nav" },
            t = ".js-accordion",
            i = ".js-accordion-link",
            n = ".js-accordion-header",
            o = {},
            r = function (e) {
                if (e) return e.split(".")[1];
            };
        return (
            (o.getConfigClass = function (t) {
                if (t) return !(!e[t] || "" == e[t]) && e[t];
            }),
            (o.hide = function (e) {
                e.setAttribute("aria-expanded", "false"), e.parentNode.classList.remove("accordion-expanded");
                const t = document.querySelector(`#${e.getAttribute("aria-controls")}`);
                t.setAttribute("hidden", ""),
                    setTimeout(function () {
                        t.style.display = "none";
                    }, 350);
            }),
            (o.hideAll = function (e) {
                if (!document.querySelector('[data-accordion-family="' + e + '"]')) return !1;
                document.querySelectorAll('[data-accordion-family="' + e + '"] > .js-accordion-header').forEach((e, t) => {
                    const i = e.querySelector('[data-toggle="accordion"]');
                    i.setAttribute("aria-expanded", "false"), i.parentNode.classList.remove("accordion-expanded");
                    const n = document.querySelector(`#${i.getAttribute("aria-controls")}`);
                    n.setAttribute("hidden", ""),
                        setTimeout(function () {
                            n.style.display = "none";
                        }, 350);
                });
            }),
            (o.show = function (t, i) {
                const n = document.querySelector(`#${t.getAttribute("aria-controls")}`),
                    r = t.closest(n.getAttribute("data-parent")),
                    a = !(!i && !r.hasAttribute("data-accordion-allow-multiple")),
                    s = r.classList.contains(e.mobileNavAccordion);
                if (!a && n.hasAttribute("data-parent")) {
                    let e = "";
                    if (((e = s ? ':scope > li > [aria-expanded="true"]' : ':scope > [aria-expanded="true"]'), !e)) return;
                    const i = t.closest(n.getAttribute("data-parent")).querySelectorAll(e);
                    if (!i) return;
                    i.forEach(function (e) {
                        o.hide(e);
                    });
                }
                t.setAttribute("aria-expanded", "true"), t.parentNode.classList.add("accordion-expanded"), n.removeAttribute("hidden"), (n.style.display = "block");
            }),
            (o.toggle = function (e, t) {
                "true" != e.getAttribute("aria-expanded") ? o.show(e, t) : o.hide(e);
            }),
            (o.init = function () {
                document.querySelectorAll(`[data-toggle="accordion"]:not(.${e.open})`).forEach(function (e, t) {
                    o.hide(e);
                }),
                    document.addEventListener("keydown", function (o) {
                        let a = o.target;
                        const s = o.which.toString(),
                            c = { preventScroll: !1 },
                            l = a.classList.contains("dropdown-arrow");
                        if ((a.classList.contains(r(n)) || a.classList.contains(r(i)) || l) && s.match(/38|40/)) {
                            const o = !!a.closest(t).classList.contains(e.mobileNavAccordion),
                                r = o ? `:scope > li > ${i}` : `:scope > ${n}`,
                                u = a.closest(t).querySelectorAll(r);
                            if (o && l) return void a.previousElementSibling.focus(c);
                            let d;
                            u.forEach(function (e, t) {
                                e == a && (d = t);
                            });
                            const h = s.match(/34|40/) ? 1 : -1,
                                p = u.length;
                            u[(d + p + h) % p].focus(c);
                        }
                    }),
                    document.addEventListener("click", function (e) {
                        const t = e.target.matches('[data-toggle="accordion"]') ? e.target : e.target.closest('[data-toggle="accordion"]');
                        if (!t) return !1;
                        e.preventDefault(), o.toggle(t);
                    }),
                    document.addEventListener("click", function (e) {
                        if (e.target.classList.contains("js-accordion-link")) {
                            if ("" == e.target.getAttribute("href")) {
                                e.preventDefault();
                                let t = e.target.parentNode.querySelector('[data-toggle="accordion"]');
                                o.toggle(t);
                            }
                        }
                    });
            }),
            o
        );
    })()),
    (WAU.Sections = void document.querySelectorAll("[data-section-type]").forEach(function (e) {
        new IntersectionObserver((t, i) => {
            t.forEach((t) => {
                t.isIntersecting && e.hasAttribute("data-section-loaded") && e.setAttribute("data-section-loaded", "true");
            });
        }).observe(e),
            document.addEventListener("shopify:section:select", function (t) {
                e.dataset.sectionId == t.detail.sectionId && e.hasAttribute("data-section-loaded") && t.target.classList.add("section--reloaded");
            }),
            document.addEventListener("shopify:section:load", function (e) {
                e.target.classList.add("section--reloaded");
            });
    })),
    (window.theme = window.theme || {}),
    (theme.a11yHelpers = (function () {
        let e = !1;
        return {
            setUpAriaExpansion: function () {
                document.querySelectorAll(".js-aria-expand").forEach(function (e) {
                    e.addEventListener("mouseover", function (t) {
                        e.setAttribute("aria-expanded", "true");
                    }),
                        e.addEventListener("mouseout", function (t) {
                            e.setAttribute("aria-expanded", "false");
                        });
                });
            },
            setUpAccessibleNavigationMenus: function () {
                function t() {
                    document.querySelectorAll(".navigation__menuitem--active").forEach(function (e) {
                        e.classList.remove("navigation__menuitem--active"), e.setAttribute("aria-expanded", "false");
                    });
                }
                function i() {
                    document.querySelectorAll(".js-menuitem-with-nested-dropdown").forEach(function (e) {
                        e.classList.remove("dropdown__menuitem--active"), e.setAttribute("aria-expanded", "false");
                    });
                }
                function n() {
                    document.querySelectorAll(".js-megamenu-listitem-with-nested-dropdown").forEach(function (e) {
                        e.classList.remove("megamenu__listitem--active"), e.setAttribute("aria-expanded", "false");
                    });
                }
                function o(e) {
                    setTimeout(function () {
                        theme.DOMHelpers.isElementPastEdge(e) ? e.classList.add("dropdown--edge") : e.classList.remove("dropdown--edge");
                    }, 0);
                }
                e ||
                    document.addEventListener("keyup", function (e) {
                        if ("Escape" === e.key) {
                            const o = document.querySelectorAll(".dropdown__menuitem--active"),
                                r = document.querySelectorAll(".navigation__menuitem--active"),
                                a = document.querySelectorAll(".megamenu__listitem--active");
                            if ((e.preventDefault(), o.length >= 1)) return void i();
                            if (a.length >= 1) return void n();
                            if (r.length >= 1) return void t();
                        }
                    }),
                    e ||
                        document.addEventListener("keydown", function (e) {
                            if ("Enter" === e.key) {
                                if (
                                    ((document.activeElement.classList.contains("js-open-dropdown-on-key") ||
                                        document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown") ||
                                        document.activeElement.parentNode.classList.contains("js-megamenu-listitem-with-nested-dropdown")) &&
                                        (e.stopPropagation(), e.preventDefault()),
                                    document.activeElement.parentNode.classList.contains("navigation__menuitem--active"))
                                )
                                    return void t();
                                if (document.activeElement.parentNode.classList.contains("dropdown__menuitem--active")) return void i();
                                if (document.activeElement.parentNode.classList.contains("megamenu__listitem--active")) return void n();
                                if (document.activeElement.classList.contains("js-open-dropdown-on-key")) return void document.activeElement.parentNode.classList.add("navigation__menuitem--active");
                                if (document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown"))
                                    return document.activeElement.parentNode.classList.add("dropdown__menuitem--active"), void o(document.activeElement.parentNode);
                                if (document.activeElement.parentNode.classList.contains("js-megamenu-listitem-with-nested-dropdown"))
                                    return document.activeElement.parentNode.classList.add("megamenu__listitem--active"), void o(document.activeElement.parentNode);
                            }
                        }),
                    (e = !0);
            },
            focusOnElement: function (e) {
                const t = e.querySelector('a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])');
                t && t.focus();
            },
        };
    })()),
    (theme.DOMHelpers = {
        isElementPastEdge: function (e) {
            const t = e.getBoundingClientRect(),
                i = t.left,
                n = t.width;
            return document.documentElement.clientHeight, i + n >= document.documentElement.clientWidth;
        },
        wrapIframe: function (e) {
            e.iframes.forEach(function (t) {
                var i = document.createElement("div");
                i.classList.add(e.iframeWrapperClass), t.parentNode.insertBefore(i, t), i.appendChild(t), (t.src = t.src);
            });
        },
        wrapTable: function (e) {
            e.tables.forEach(function (t) {
                var i = document.createElement("div");
                i.classList.add(e.tableWrapperClass), t.parentNode.insertBefore(i, t), i.appendChild(t);
            });
        },
        adjustElementXPosition: function (e, t) {
            const i = e.getBoundingClientRect(),
                n = i.left,
                o = i.width,
                r = (document.documentElement.clientHeight, n + o - document.documentElement.clientWidth);
            return r > 0 && ((e.style.transform = `translateX(-${r + t}px)`), !0);
        },
    }),
    (theme.Helpers = (function () {
        var e = !1;
        return {
            setTouch: function () {
                e = !0;
            },
            isTouch: function () {
                return e;
            },
            debounce: function (e, t, i) {
                var n;
                return function () {
                    var o = this,
                        r = arguments,
                        a = function () {
                            (n = null), i || e.apply(o, r);
                        },
                        s = i && !n;
                    clearTimeout(n), (n = setTimeout(a, t)), s && e.apply(o, r);
                };
            },
            makeSticky: function (e, t, i) {
                const n = document.querySelector(".js-clear-element"),
                    o = document.querySelector(t),
                    r = i + "px";
                window.pageYOffset > e ? (o.classList.add("sticky--active"), (n.style.height = r)) : (o.classList.remove("sticky--active"), (n.style.height = "0px"));
            },
            Toggle: function (e) {
                var t = document.getElementById(e);
                t.classList.contains("animate-hide")
                    ? (t.classList.remove("animate-hide", "fadeOut"), t.classList.add("animate-show", "fadeIn"), (t.style.visibility = "visible"))
                    : (t.classList.remove("animate-show", "fadeIn"), t.classList.add("animate-hide", "fadeOut"), (t.style.visibility = "hidden"));
            },
            toggleClass: function (e, t) {
                var i = document.getElementById(e);
                if (!i) return !1;
                i.classList.contains(t) ? i.classList.remove(t) : i.classList.add(t);
            },
            Accordion: function (e, t, i) {
                let n = e.querySelector(i);
                if (!e.querySelector(t)) return !1;
                e.querySelector(t).addEventListener("click", function (e) {
                    e.preventDefault(),
                        this.classList.contains("closed")
                            ? (this.classList.remove("closed"), this.parentElement.classList.remove("closed"), this.setAttribute("aria-expanded", "true"))
                            : (this.classList.add("closed"), this.parentElement.classList.add("closed"), this.setAttribute("aria-expanded", "false")),
                        n.classList.contains("closed") ? (n.classList.remove("closed"), (n.style.display = "block")) : (n.classList.add("closed"), (n.style.display = "none"));
                });
            },
            fadeOut: function (e) {
                (e.style.opacity = 1),
                    (function t() {
                        (e.style.opacity -= 0.1) < 0 ? (e.style.display = "none") : requestAnimationFrame(t);
                    })();
            },
            fadeIn: function (e, t) {
                (e.style.opacity = 0),
                    (e.style.display = t || "block"),
                    (function t() {
                        var i = parseFloat(e.style.opacity);
                        (i += 0.1) > 1 || ((e.style.opacity = i), requestAnimationFrame(t));
                    })();
            },
            getScrollbarWidth: function () {
                const e = document.createElement("div");
                (e.style.visibility = "hidden"), (e.style.overflow = "scroll"), (e.style.msOverflowStyle = "scrollbar"), document.body.appendChild(e);
                const t = document.createElement("div");
                e.appendChild(t);
                const i = e.offsetWidth - t.offsetWidth;
                return e.parentNode.removeChild(e), i;
            },
            smoothScrollTo: function (e, t, i) {
                let n = window.scrollX || window.pageXOffset,
                    o = window.scrollY || window.pageYOffset,
                    r = e - n,
                    a = t - o,
                    s = new Date().getTime(),
                    c = function (e, t, i, n) {
                        return (e /= n / 2) < 1 ? (i / 2) * e * e * e * e + t : (-i / 2) * ((e -= 2) * e * e * e - 2) + t;
                    },
                    l = window.setInterval(function () {
                        let e = new Date().getTime() - s,
                            t = c(e, n, r, i),
                            u = c(e, o, a, i);
                        e >= i && window.clearInterval(l), window.scrollTo(t, u);
                    }, 1e3 / 60);
            },
            formatMoney: function (e, t) {
                "string" == typeof e && (e = e.replace(".", ""));
                let i = "";
                const n = /\{\{\s*(\w+)\s*\}\}/,
                    o = t || "${{amount}}";
                function r(e, t = 2, i = ",", n = ".") {
                    if (isNaN(e) || null == e) return 0;
                    const o = (e = (e / 100).toFixed(t)).split(".");
                    return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) + (o[1] ? n + o[1] : "");
                }
                switch (o.match(n)[1]) {
                    case "amount":
                        i = r(e, 2);
                        break;
                    case "amount_no_decimals":
                        i = r(e, 0);
                        break;
                    case "amount_with_comma_separator":
                        i = r(e, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        i = r(e, 0, ".", ",");
                }
                return o.replace(n, i);
            },
        };
    })()),
    (theme.LibraryLoader = (function () {
        var e = "link",
            t = "script",
            i = "requested",
            n = "loaded",
            o = "https://cdn.shopify.com/shopifycloud/",
            r = {
                youtubeSdk: { tagId: "youtube-sdk", src: "https://www.youtube.com/iframe_api", type: t },
                plyrShopifyStyles: { tagId: "plyr-shopify-styles", src: o + "shopify-plyr/v1.0/shopify-plyr.css", type: e },
                modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: o + "model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: e },
            };
        return {
            load: function (o, a) {
                var s = r[o];
                if (s && s.status !== i)
                    if (((a = a || function () {}), s.status !== n)) {
                        var c;
                        switch (((s.status = i), s.type)) {
                            case t:
                                c = (function (e, t) {
                                    var i = document.createElement("script");
                                    return (
                                        (i.src = e.src),
                                        i.addEventListener("load", function () {
                                            (e.status = n), t();
                                        }),
                                        i
                                    );
                                })(s, a);
                                break;
                            case e:
                                c = (function (e, t) {
                                    var i = document.createElement("link");
                                    return (
                                        (i.href = e.src),
                                        (i.rel = "stylesheet"),
                                        (i.type = "text/css"),
                                        i.addEventListener("load", function () {
                                            (e.status = n), t();
                                        }),
                                        i
                                    );
                                })(s, a);
                        }
                        (c.id = s.tagId), (s.element = c);
                        var l = document.getElementsByTagName(s.type)[0];
                        l.parentNode.insertBefore(c, l);
                    } else a();
            },
        };
    })()),
    (theme.Sections = function () {
        (this.constructors = {}),
            (this.instances = []),
            document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
            document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
            document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
            document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
            document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
            document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
        _createInstance: function (e, t) {
            var i = e.getAttribute("data-section-id"),
                n = e.getAttribute("data-section-type");
            if (void 0 !== (t = t || this.constructors[n])) {
                var o = Object.assign(new t(e), { id: i, type: n, container: e });
                this.instances.push(o);
            }
        },
        _onSectionLoad: function (e) {
            var t = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
            t && this._createInstance(t);
        },
        _onSectionUnload: function (e) {
            this.instances = this.instances.filter(function (t) {
                var i = t.id === e.detail.sectionId;
                return i && "function" == typeof t.onUnload && t.onUnload(e), !i;
            });
        },
        _onSelect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
        },
        _onDeselect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        },
        register: function (e, t) {
            (this.constructors[e] = t),
                document.querySelectorAll('[data-section-type="' + e + '"]').forEach(
                    function (e) {
                        this._createInstance(e, t);
                    }.bind(this)
                );
        },
    })),
    (theme.Disclosure = (function () {
        var e = "[data-disclosure-form]",
            t = "[data-disclosure-list]",
            i = "[data-disclosure-toggle]",
            n = "[data-disclosure-input]",
            o = "[data-disclosure-option]",
            r = "disclosure-list--visible";
        function a(e) {
            (this.container = e), this._cacheSelectors(), this._setupListeners();
        }
        return (
            (a.prototype = Object.assign({}, a.prototype, {
                _cacheSelectors: function () {
                    this.cache = {
                        disclosureForm: this.container.closest(e),
                        disclosureList: this.container.querySelector(t),
                        disclosureToggle: this.container.querySelector(i),
                        disclosureInput: this.container.querySelector(n),
                        disclosureOptions: this.container.querySelectorAll(o),
                    };
                },
                _setupListeners: function () {
                    (this.eventHandlers = this._setupEventHandlers()),
                        this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList),
                        this.cache.disclosureOptions.forEach(function (e) {
                            e.addEventListener("click", this.eventHandlers.connectOptions);
                        }, this),
                        this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                        this.cache.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                        this.cache.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
                },
                _setupEventHandlers: function () {
                    return {
                        connectOptions: this._connectOptions.bind(this),
                        toggleList: this._toggleList.bind(this),
                        onBodyClick: this._onBodyClick.bind(this),
                        onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                        onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                        onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
                    };
                },
                _connectOptions: function (e) {
                    e.preventDefault(), this._submitForm(e.currentTarget.dataset.value);
                },
                _onDisclosureToggleFocusOut: function (e) {
                    !1 === this.container.contains(e.relatedTarget) && this._hideList();
                },
                _onDisclosureListFocusOut: function (e) {
                    var t = e.currentTarget.contains(e.relatedTarget);
                    this.cache.disclosureList.classList.contains(r) && !t && this._hideList();
                },
                _onDisclosureKeyUp: function (e) {
                    27 === e.which && (this._hideList(), this.cache.disclosureToggle.focus());
                },
                _onBodyClick: function (e) {
                    var t = this.container.contains(e.target);
                    this.cache.disclosureList.classList.contains(r) && !t && this._hideList();
                },
                _submitForm: function (e) {
                    (this.cache.disclosureInput.value = e), this.cache.disclosureForm.submit();
                },
                _hideList: function () {
                    this.cache.disclosureList.classList.remove(r), this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
                },
                _toggleList: function () {
                    var e = "true" === this.cache.disclosureToggle.getAttribute("aria-expanded");
                    this.cache.disclosureList.classList.toggle(r), this.cache.disclosureToggle.setAttribute("aria-expanded", !e);
                },
                destroy: function () {
                    this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList),
                        this.cache.disclosureOptions.forEach(function (e) {
                            e.removeEventListener("click", this.eventHandlers.connectOptions);
                        }, this),
                        this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                        this.cache.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                        this.cache.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                        document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
                },
            })),
            a
        );
    })()),
    (Shopify.theme.cart = (function (e) {
        "use strict";
        function t() {
            return JSON.parse(JSON.stringify({ credentials: "same-origin", headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json;" } }));
        }
        function i(e, t) {
            return fetch(e, t).then(function (e) {
                if (!e.ok) throw e;
                return e.json();
            });
        }
        function n() {
            return i("/cart.js", t());
        }
        function o(e, n) {
            var o = t();
            return (n = n || {}), (o.method = "POST"), (o.body = JSON.stringify({ line: e, quantity: n.quantity, properties: n.properties })), i("/cart/change.js", o);
        }
        function r(e) {
            var n = t();
            return (n.method = "POST"), (n.body = JSON.stringify(e)), i("/cart/update.js", n);
        }
        function a(e) {
            if ("string" != typeof e || 2 !== e.split(":").length) throw new TypeError("Theme Cart: Provided key value is not a string with the format xxx:xxx");
        }
        function s(e) {
            if ("number" != typeof e || isNaN(e)) throw new TypeError("Theme Cart: Variant ID must be a number");
        }
        function c(e) {
            if ("object" != typeof e) throw new TypeError("Theme Cart: Options must be an object");
            if (void 0 === e.quantity && void 0 === e.properties) throw new Error("Theme Cart: You muse define a value for quantity or properties");
            void 0 !== e.quantity &&
                (function (e) {
                    if ("number" != typeof e || isNaN(e)) throw new TypeError("Theme Cart: An object which specifies a quantity or properties value is required");
                })(e.quantity),
                void 0 !== e.properties &&
                    (function (e) {
                        if ("object" != typeof e) throw new TypeError("Theme Cart: Properties must be an object");
                    })(e.properties);
        }
        function l(e) {
            return (
                a(e),
                n().then(function (t) {
                    var i = -1;
                    return (
                        t.items.forEach(function (t, n) {
                            i = t.key === e ? n + 1 : i;
                        }),
                        -1 === i ? Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")) : i
                    );
                })
            );
        }
        function u() {
            return n().then(function (e) {
                return e.attributes;
            });
        }
        function d(e) {
            return r({ attributes: e });
        }
        return (
            (e.getState = function () {
                return n().then(function (e) {
                    Events.trigger("cart:ready", e);
                });
            }),
            (e.getCart = function () {
                return n().then(function (e) {
                    return e;
                });
            }),
            (e.getItemIndex = l),
            (e.getItem = function (e) {
                return (
                    a(e),
                    n().then(function (t) {
                        var i = null;
                        return (
                            t.items.forEach(function (t) {
                                i = t.key === e ? t : i;
                            }),
                            null === i ? Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")) : i
                        );
                    })
                );
            }),
            (e.addItem = function (e, n) {
                return (
                    (n = n || {}),
                    s(e),
                    (function (e, n, o) {
                        var r = t();
                        return (r.method = "POST"), (r.body = JSON.stringify({ id: e, quantity: n, properties: o })), i("/cart/add.js", r);
                    })(e, n.quantity, n.properties)
                );
            }),
            (e.addItemFromForm = function (e) {
                !(function (e) {
                    if (!(e instanceof HTMLFormElement)) throw new TypeError("Theme Cart: Form must be an instance of HTMLFormElement");
                })(e);
                var n = new FormData(e);
                return (
                    s(parseInt(n.get("id"), 10)),
                    (function (e) {
                        var n = t();
                        return delete n.headers["Content-Type"], (n.method = "POST"), (n.body = e), i("/cart/add.js", n);
                    })(n)
                );
            }),
            (e.updateItem = function (e, t) {
                return (
                    a(e),
                    c(t),
                    l(e).then(function (e) {
                        return o(e, t);
                    })
                );
            }),
            (e.removeItem = function (e) {
                return (
                    a(e),
                    l(e).then(function (e) {
                        return o(e, { quantity: 0 });
                    })
                );
            }),
            (e.clearItems = function () {
                return ((e = t()), (e.method = "POST"), i("/cart/clear.js", e)).then(function () {
                    Events.trigger("cart:clear");
                });
                var e;
            }),
            (e.getAttributes = u),
            (e.updateAttributes = d),
            (e.clearAttributes = function () {
                return u().then(function (e) {
                    for (var t in e) e[t] = "";
                    return d(e);
                });
            }),
            (e.getNote = function () {
                return n().then(function (e) {
                    return e.note;
                });
            }),
            (e.updateNote = function (e) {
                return r({ note: e });
            }),
            (e.clearNote = function () {
                return r({ note: "" });
            }),
            (e.getShippingRates = function () {
                return i("/cart/shipping_rates.json", t());
            }),
            e
        );
    })({})),
    (Shopify.theme.ajaxCart = {
        init: function () {
            let e = document.getElementById("cart-config");
            if (!e) return !1;
            e = JSON.parse(e.innerHTML || "{}");
            var t = ".js-mini-cart-trigger",
                i = ".js-ajax-submit";
            this.initializeAjaxCart(e),
                "no_js_cart" == e.cart_action
                    ? document.querySelector(".js-ajax-cart-content") && document.querySelector(".js-ajax-cart-content").remove()
                    : document.querySelector(".js-ajax-cart-content-nojs") && document.querySelector(".js-ajax-cart-content-nojs").remove(),
                "drawer" == e.cart_action ? WAU.Slideout.init("ajax-cart") : "modal_cart" == e.cart_action ? WAU.Modal.init("ajax-cart") : "mini_cart" == e.cart_action && WAU.Modal.init("mini-ajax-cart"),
                document.querySelectorAll(i).forEach((t, i) => {
                    t.addEventListener("click", function (i) {
                        i.preventDefault();
                        var n = this.closest("form");
                        return Shopify.theme.ajaxCart.addToCart(n, t.parentNode, e, !1), !1;
                    });
                }),
                document.querySelector("body").classList.contains("template-cart") &&
                    Shopify.theme.cart.getCart().then((t) => {
                        Shopify.theme.ajaxCart.updateView(e, t),
                            setTimeout(function () {
                                document.querySelector("body").classList.add("cart-loaded"), Shopify.theme.ajaxCart.cartStickyBar();
                            }, 800);
                    }),
                document.querySelectorAll(t).forEach((t, i) => {
                    t.addEventListener("click", function (t) {
                        return (
                            t.preventDefault(),
                            Shopify.theme.cart.getCart().then((t) => {
                                Shopify.theme.ajaxCart.updateView(e, t),
                                    "drawer" == e.cart_action
                                        ? Shopify.theme.ajaxCart.showDrawer(e)
                                        : "modal_cart" == e.cart_action || "mini_cart" == e.cart_action
                                        ? Shopify.theme.ajaxCart.showModal(e)
                                        : (window.location.href = e.cart_url);
                            }),
                            !1
                        );
                    });
                });
          console.log('opened');
        },
        cartStickyBar: function () {
            let e = 0,
                t = !1;
            document.addEventListener("scroll", function (i) {
                (e = window.scrollY),
                    t ||
                        (window.requestAnimationFrame(function () {
                            !(function (e) {
                                var t = document.querySelectorAll(".js-cart-form");
                                if (!t) return !1;
                                t.forEach((t, i) => {
                                    var n = t.offsetTop,
                                        o = e >= n,
                                        r = document.getElementById("footer"),
                                        a = document.querySelector(".js-sticky-cart");
                                    if (1 === i) return !1;
                                    o && !a.classList.contains("show")
                                        ? (a.classList.add("show"), r.classList.add("padding-sticky"))
                                        : !o && a.classList.contains("show") && (a.classList.remove("show"), r.classList.remove("padding-sticky"));
                                });
                            })(e),
                                (t = !1);
                        }),
                        (t = !0));
            });
        },
        cartEvents: function (e) {
            console.log("updates");
            var t = ".js-cart-remove",
                i = "[data-item-qty]",
                n = "[data-ajax-qty-decrease]",
                o = "[data-ajax-qty-increase]",
                r = ".js-cart-note",
                a = document.querySelectorAll(i);
            if (0 === a.length) return !1;
            a.forEach((t, i) => {
                t.addEventListener("change", function (i) {
                    i.preventDefault();
                    var n = parseInt(this.value),
                        o = this.dataset.itemKey,
                        r = this.dataset.limit,
                        a = t.closest(".ajax-cart__cart-item");
                    return (
                        (t.value = n),
                        setTimeout(function () {
                            0 === n
                                ? Shopify.theme.ajaxCart.removeFromCart(o, e)
                                : (Shopify.theme.ajaxCart.checkLimit(r, n, a, e),
                                  Shopify.theme.cart.updateItem(o, { quantity: n }).then((t) => {
                                      Shopify.theme.ajaxCart.updateView(e, t);
                                  }));
                        }, 250),
                        !1
                    );
                });
            }),
                document.querySelectorAll(t).forEach((t, i) => {
                    t.addEventListener("click", function (t) {
                        t.preventDefault();
                        var i = this.dataset.itemKey;
                        return Shopify.theme.ajaxCart.removeFromCart(i, e), !1;
                    });
                }),
                document.querySelectorAll(n).forEach((t, i) => {
                    t.addEventListener("click", function (t) {
                        if ((t.preventDefault(), "1" === this.nextElementSibling.value)) {
                            var i = this.dataset.itemKey;
                            Shopify.theme.ajaxCart.removeFromCart(i, e);
                        } else {
                            var n = this.dataset.ajaxQtyDecrease;
                            Shopify.theme.ajaxCart.adjustQty(-1, n, e);
                        }
                        return !1;
                    });
                }),
                document.querySelectorAll(o).forEach((t, i) => {
                    t.addEventListener("click", function (t) {
                        t.preventDefault();
                        var i = this.dataset.ajaxQtyIncrease;
                        return Shopify.theme.ajaxCart.adjustQty(1, i, e), !1;
                    });
                }),
                document.querySelectorAll(r).forEach((t, i) => {
                    t.addEventListener("blur", (i) => {
                        let n = t.value;
                        Shopify.theme.cart.updateNote(n).then((t) => {
                            Shopify.theme.ajaxCart.updateView(e, t);
                        });
                    });
                }),
                e.show_calculator &&
                    setTimeout(function () {
                        Shopify.theme.shippingCalculator.init();
                    }, 1e3),
                Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize();

               console.log("variant change111");
                   $("li.js-cart-remove").on("click", function(){
                        console.log("remove item");
                          location.reload();
                      });
                  
                    $(".cart-variant").change(function(){ 
                        //var element = $(this); 
                         var selValue = $(this).val();
                       console.log(selValue); 
                      $(this).parent().parent().find('.textFieldValueJQ').val(selValue);
                      $(".cart-submits").attr("data-url", selValue);
                      $('.cart-submits').removeAttr("disabled");
                    });
                   $('.cart-submits').on("click", function(){

                       var variation = $(this).attr("data-url");
                       console.log("click variant"+variation);
                                
                        $.ajax({
                          type: 'POST', 
                          url: '/cart/add.js',
                          dataType: 'json', 
                          data: {id:variation},
                          success: function(data){
                                 location.href="/cart";
                          }
                       });
                     });
          $('.slider_wrap').addClass('showflick');
                    $('.slider_wrap').flickity({
                      cellAlign: 'left',
                      contain: 'true',
                      wrapAround:'true',
                      dragThreshold:'true',
                      pauseAutoPlayOnHover:'false',
                      freeScroll: 'true',
                      prevNextButtons: 'true',
                      pageDots: 'false',
                      groupCells: 'false'
                    });
        },
        showDrawer: function (e) {
            if ("drawer" != e.cart_action) return !1;
            WAU.Slideout._openByName("ajax-cart");
        },
        hideDrawer: function (e) {
            if ("drawer" != e.cart_action) return !1;
            WAU.Slideout._closeByName("ajax-cart");
        },
        showModal: function (e) {
            "modal_cart" == e.cart_action ? WAU.Modal._openByName("ajax-cart") : "mini_cart" == e.cart_action && WAU.Modal._openByName("mini-ajax-cart");
        },
        hideModal: function (e) {
            "modal_cart" == e.cart_action ? WAU.Modal._closeByName("ajax-cart") : "mini_cart" == e.cart_action && WAU.Modal._closeByName("mini-ajax-cart");
        },
        removeFromCart: function (e, t, i) {
            Shopify.theme.cart.removeItem(e).then((e) => {
                Shopify.theme.ajaxCart.updateView(t, e);
            });
        },
        adjustQty: function (e, t, i) {
            var n = { lineItem: ".item_" + t, updatesItem: ".updates_" + t };
            document.querySelectorAll(n.lineItem).forEach(
                (t, o) => (
                    (elementInput = t.querySelector(n.updatesItem)),
                    (key = elementInput.dataset.itemKey),
                    (max = elementInput.dataset.limit),
                    (quantity = parseInt(elementInput.value) + parseInt(e)),
                    !Shopify.theme.ajaxCart.checkLimit(max, quantity, t, i) &&
                        0 !== quantity &&
                        ((elementInput.value = quantity),
                        void setTimeout(function () {
                            Shopify.theme.cart.updateItem(key, { quantity: quantity }).then((e) => {
                                Shopify.theme.ajaxCart.updateView(i, e);
                            });
                        }, 250))
                )
            );
        },
        checkLimit: function (e, t, i, n) {
            if ("" != e && t > e) {
                let e = document.createElement("div");
                e.classList.add("mini-cart__cart-note"), (e.innerHTML = '<p class="a-center"><b>' + n.cart_error + "</b>&nbsp;&nbsp;" + n.update_qty_error + "</p>");
                let t = i.querySelector(".js-item-quantity"),
                    o = t.parentNode;
                return (
                    o.appendChild(e, t),
                    setTimeout(function () {
                        theme.Helpers.fadeOut(e), o.removeChild(e);
                    }, 2e3),
                    !0
                );
            }
        },
        addToCart: function (e, t, i, n) {
            var o = ".js-ajax-submit",
                r = ".js-added-msg";
            let a;
            (a = n ? document.querySelector(".js-quickview-content") : t),
                (a.querySelector(o).value = i.adding_to_cart),
                a.querySelector(o).classList.add("disabled"),
                a.querySelector(o).getAttribute("disabled", "disabled"),
                Shopify.theme.cart
                    .addItemFromForm(e)
                    .then((e) => {
                        (a.querySelector(o).value = i.added_to_cart),
                            a.querySelector(o).classList.remove("disabled"),
                            a.querySelector(o).removeAttribute("disabled", "disabled"),
                            setTimeout(function () {
                                a.querySelector(o).value = i.add_to_cart;
                            }, 3e3),
                            Shopify.theme.cart.getCart().then((e) => {
                                n && "product_page" != i.cart_added_event
                                    ? Shopify.theme.quickview.hideModal()
                                    : n &&
                                      "product_page" == i.cart_added_event &&
                                      (theme.Helpers.fadeIn(a.querySelector(r)),
                                      setTimeout(function () {
                                          theme.Helpers.fadeOut(a.querySelector(r));
                                      }, 3e3)),
                                    "drawer" == i.cart_action && "go_to_active_cart" == i.cart_added_event
                                        ? Shopify.theme.ajaxCart.showDrawer(i)
                                        : ("modal_cart" == i.cart_action && "go_to_active_cart" == i.cart_added_event) || ("mini_cart" == i.cart_action && "go_to_active_cart" == i.cart_added_event)
                                        ? Shopify.theme.ajaxCart.showModal(i)
                                        : "page_only" == i.cart_action && "go_to_active_cart" == i.cart_added_event
                                        ? (window.location.href = i.cart_url)
                                        : "product_page" == i.cart_added_event
                                        ? (theme.Helpers.fadeIn(a.querySelector(r)),
                                          setTimeout(function () {
                                              theme.Helpers.fadeOut(a.querySelector(r));
                                          }, 3e3))
                                        : (window.location.href = i.cart_url),
                                    Shopify.theme.ajaxCart.updateView(i, e);
                            });
                    })
                    .catch((e) => {
                        422 == e.status
                            ? (theme.Helpers.fadeIn(a.querySelector(".js-error-msg")),
                              (a.querySelector(o).value = i.add_to_cart),
                              a.querySelector(o).classList.remove("disabled"),
                              a.querySelector(o).removeAttribute("disabled", "disabled"),
                              setTimeout(function () {
                                  theme.Helpers.fadeOut(a.querySelector(".js-error-msg"));
                              }, 3e3))
                            : console.log(e);
                    });
        },
        getAjaxCart: function (e) {
            const t = document.createElement("div");
            t.innerHTML = e;
            JSON.parse(t.querySelector("[data-options]").innerHTML);
            const i = t.querySelectorAll("[data-html]");
            let n = {};
            if (1 === i.length && "" === i[0].getAttribute("data-html")) n = i[0].innerHTML;
            else for (let e = 0; e < i.length; e++) n[i[e].getAttribute("data-html")] = i[e].innerHTML;
            return n;
        },
        initializeAjaxCart: function (e) {
            let t;
            (t = e.cart_url + "/?view=ajax"),
                fetch(t, undefined)
                    .then((e) => e.text())
                    .then((e) => {
                        let t = Shopify.theme.ajaxCart.getAjaxCart(e);
                        document.querySelectorAll(".js-ajax-cart-content").forEach((e, i) => {
                            e.innerHTML = t.content;
                        });
                    })
                    .then((t) => {
                        e.show_calculator &&
                            setTimeout(function () {
                                Shopify.theme.shippingCalculator.init();
                            }, 1e3);
                    })
                    .catch((e) => {
                        console.log(e);
                    });
        },
        updateView: function (e, t) {
            let i;
            (i = e.cart_url + "/?view=ajax"),
                fetch(i, undefined)
                    .then((e) => e.text())
                    .then((i) => {
                        let n = Shopify.theme.ajaxCart.getAjaxCart(i);
                        var o = ".js-ajax-cart-content",
                            r = ".js-cart-empty",
                            a = ".js-cart-form",
                            s = ".js-cart-accordion",
                            c = ".js-cart-count";
                        const l = function (e, t, i = !1) {
                            const n = ".js-sticky-cart",
                                o = ".js-cart-total",
                                r = ".js-sticky-checkout-btn";
                            if (!e) return console.log("Error. updateStickyCart requires a Cart object"), !1;
                            if (!t) return console.log("Error. updateStickyCart requires a config object"), !1;
                            var a = document.querySelectorAll(n);
                            if (0 === a.length) return !1;
                            a.forEach((n, a) => {
                                let s = n.querySelector(o),
                                    c = theme.Helpers.formatMoney(e.total_price, t.money_format);
                                s || console.log("Error. No original price element found in sticky cart"), (s.innerHTML = c);
                                let l = n.querySelector(r);
                                i && l && 0 == l.disabled ? (l.disabled = !0) : (l.disabled = !1);
                            });
                        };
                        0 === t.item_count
                            ? (document.querySelectorAll(a).forEach((e, t) => {
                                  e.classList.add("hide");
                              }),
                              document.querySelectorAll(r).forEach((e, t) => {
                                  e.classList.remove("hide");
                              }),
                              document.querySelectorAll(c).forEach((e, t) => {
                                  e.innerHTML = "0";
                              }),
                              document.querySelector("body").classList.contains("template-cart") && l(t, e, !0))
                            : (document.querySelectorAll(r).forEach((e, t) => {
                                  e.classList.add("hide");
                              }),
                              document.querySelectorAll(c).forEach((e, i) => {
                                  e.innerHTML = t.item_count;
                              }),
                              document.querySelectorAll(o).forEach((e, t) => {
                                  e.innerHTML = n.content;
                              }),
                              document.querySelectorAll(s).forEach((e, t) => {
                                  theme.Helpers.Accordion(e, ".tlink.has_sub_menu a", ".accordion-content.sub"), theme.Helpers.Accordion(e, ".tlink2.has_sub_menu a", ".accordion-content2.sub");
                              }),
                              document.querySelector("body").classList.contains("template-cart") && l(t, e),
                              Shopify.theme.ajaxCart.cartEvents(e)),
                            setTimeout(function () {
                                document.querySelector("body").classList.add("cart-loaded"),
                                    "mini_cart" == e.cart_action
                                        ? document.querySelectorAll("#dynamic-checkout-cart").length > 2 &&
                                          document.querySelectorAll(".js-mini-cart-wrapper #dynamic-checkout-cart").forEach((e, t) => {
                                              e.remove();
                                          })
                                        : document.querySelectorAll("#dynamic-checkout-cart").length >= 2 && document.querySelectorAll("#dynamic-checkout-cart")[1].remove();
                            }, 500);
                    })
                    .catch((e) => {
                        console.log(e);
                    });
        },
    }),
    (Shopify.theme.shippingCalculator = {
        init: function () {
            if (!(t = document.getElementById("cart-config"))) return !1;
            var e,
                t = JSON.parse(t.innerHTML || "{}"),
                i = ".js-shipping-calc-wrapper",
                n = ".js-shipping-calc-submit",
                o = ".js-shipping-calc-address-zip",
                r = ".js-shipping-calc-address-country",
                a = ".js-shipping-calc-address-province",
                s = ".js-shipping-calc-address-province-label",
                c = ".js-shipping-calc-response";
            if (
                ("mini_cart" == t.cart_action
                    ? (document.querySelectorAll(i)[0] && (document.querySelectorAll(i)[0].innerHTML = ""), (e = document.querySelectorAll(i)[1]))
                    : (document.querySelectorAll(i)[1] && (document.querySelectorAll(i)[1].innerHTML = ""), (e = document.querySelectorAll(i)[0])),
                !e)
            )
                return !1;
            if (!document.querySelector("body").classList.contains("template-cart")) return !1;
            new Shopify.CountryProvinceSelector("address_country", "address_province", { hideElement: "address_province_container" });
            var l = e.querySelector(r),
                u = e.querySelector(s);
            "undefined" != typeof Countries &&
                (Countries.updateProvinceLabel(l.val(), u),
                l.change(function () {
                    Countries.updateProvinceLabel(l.val(), u);
                })),
                e.querySelector(n).addEventListener("click", function (i) {
                    i.preventDefault(), Shopify.theme.shippingCalculator.disableButtons(t, e), (e.querySelector(c).style.display = "none");
                    let n = {};
                    (n.zip = e.querySelector(o).value || ""), (n.country = e.querySelector(r).value || ""), (n.province = e.querySelector(a).value || ""), Shopify.theme.shippingCalculator.getRates(t, n, e);
                });
        },
        enableButtons: function (e, t) {
            var i = ".js-shipping-calc-submit";
            t.querySelector(i).removeAttribute("disabled"), t.querySelector(i).classList.remove("disabled"), (t.querySelector(i).value = e.calculator_submit);
        },
        disableButtons: function (e, t) {
            var i = ".js-shipping-calc-submit";
            t.querySelector(i).setAttribute("disabled", "disabled"), t.querySelector(i).classList.add("disabled"), (t.querySelector(i).value = e.calculator_calculating);
        },
        getRates: function (e, t, i) {
            let n = "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" + t.zip + "&shipping_address%5Bcountry%5D=" + t.country + "&shipping_address%5Bprovince%5D=" + t.province;
            fetch(n, { method: "GET", headers: { Accept: "application/json", "Content-Type": "application/json" } })
                .then((e) => e.json())
                .then((n) => {
                    if (n.shipping_rates) {
                        let o = n.shipping_rates;
                        Shopify.theme.shippingCalculator.onRatesUpdate(o, t, e, i);
                    } else Shopify.theme.shippingCalculator.onError(n, e, i);
                })
                .catch((t) => {
                    Shopify.theme.shippingCalculator.onError(t, e, i);
                });
        },
        onError: function (e, t, i) {
            Shopify.theme.shippingCalculator.enableButtons(t, i);
            let n = t.calculator_error + " " + Object.keys(e)[0] + " " + Object.values(e)[0];
            Shopify.theme.shippingCalculator.render({ rates: [], errorFeedback: n, success: !1 }, i, t),
                (i.querySelector(".js-shipping-calc-rates").style.display = "none"),
                (i.querySelector(".js-shipping-calc-response").style.display = "block");
        },
        onRatesUpdate: function (e, t, i, n) {
            Shopify.theme.shippingCalculator.enableButtons(i, n);
            var o = "";
            if ((t.zip && (o += t.zip + ", "), t.province && (o += t.province + ", "), (o += t.country), !e)) return !1;
            e.forEach((e, t) => {
                e.price = Shopify.theme.shippingCalculator.formatRate(e.price, i);
            }),
                Shopify.theme.shippingCalculator.render({ rates: e, address: o, success: !0 }, n, i);
        },
        formatRate: function (e, t) {
            let i = ((n = ((n = e) + "").replace(/[^\d.-]/g, "")) && n.includes(".") && (n = n.substring(0, n.indexOf(".") + 3)), n ? Math.round(100 * parseFloat(n)) : 0);
            var n;
            return theme.Helpers.formatMoney(i, t.money_format);
        },
        render: function (e, t, i) {
            let n = document.querySelector(".js-shipping-calc-rates-feedback"),
                o = document.querySelector(".js-shipping-calc-rates");
            (n.innerHTML = ""),
                e.rates.length > 1
                    ? (n.innerHTML = i.shipping_multi_rate_one + e.rates.length + i.shipping_multi_rate_two + e.address + i.shipping_multi_rate_three + e.rates[0].price)
                    : 1 === e.rates.length
                    ? (n.innerHTML = i.shipping_single_rate + e.address)
                    : (n.innerHTML = i.shipping_no_destination),
                (o.innerHTML = ""),
                e.rates.forEach((e, t) => {
                    const i = document.createElement("li");
                    i.classList.add("shipping-calc__rate"), (i.innerHTML = e.name + " at " + e.price), o.appendChild(i);
                }),
                (t.querySelector(".js-shipping-calc-rates").style.display = "block"),
                (document.querySelector(".js-shipping-calc-response").style.display = "block");
        },
    }),
    (Shopify.theme.quickview = {
        init: function () {
            document.querySelectorAll(".js-quickview-trigger").forEach((e, t) => {
                e.addEventListener("click", function (e) {
                    e.preventDefault();
                    var t = this.dataset.productUrl;
                    t = Shopify.theme.quickview.cleanUrl(t, "variant");
                    Shopify.theme.quickview.getTemplate(t);
                });
            });
        },
        formatTemplate: function (e) {
            const t = document.createElement("div");
            t.innerHTML = e;
            const i = t.querySelectorAll("[data-html]");
            let n = {};
            if (1 === i.length && "" === i[0].getAttribute("data-html")) n = i[0].innerHTML;
            else for (let e = 0; e < i.length; e++) n[i[e].getAttribute("data-html")] = i[e].innerHTML;
            return n;
        },
        showModal: function () {
            WAU.Modal._openByName("quickview");
        },
        hideModal: function () {
            (document.querySelector(".js-quickview-content").innerHTML = ""), WAU.Modal._closeByName("quickview");
        },
        cleanUrl: function (e, t) {
            return e.split("?")[0] + "?view=quick";
        },
        getTemplate: function (e) {
            let t;
            (t = e),
                fetch(t, undefined)
                    .then((e) => e.text())
                    .then((e) => {
                        let t = Shopify.theme.quickview.formatTemplate(e);
                        document.querySelector(".js-quickview-content").innerHTML = t.content;
                    })
                    .then((e) => {
                        let t = document.querySelector(".js-quickview-wrapper");
                        theme.Product(t);
                    })
                    .then((e) => {
                        "true" == document.querySelector(".js-quickview-wrapper").dataset.paymentButton && Shopify.PaymentButton && Shopify.PaymentButton.init();
                    })
                    .then((e) => {
                        document
                            .querySelector(".js-quickview-wrapper")
                            .querySelector(".js-ajax-submit")
                            .addEventListener("click", function (e) {
                                e.preventDefault();
                                var t = this.closest("form");
                                let i = document.getElementById("cart-config");
                                return !!i && ((i = JSON.parse(i.innerHTML || "{}")), Shopify.theme.ajaxCart.addToCart(t, null, i, !0), !1);
                            });
                    })
                    .then((e) => {
                        Shopify.theme.quickview.showModal();
                    })
                    .catch((e) => {
                        console.log(e);
                    });
        },
    }),
    Shopify.theme.quickview.init(),
    Shopify.theme.ajaxCart.init(),
    document.addEventListener("shopify:section:select", function (e) {
        Shopify.theme.quickview.init(), Shopify.theme.ajaxCart.init();
    });
const ViewedProducts = function (e) {
    const t = {};
    var i = { howManyToShow: 3, howManyToStoreInMemory: 30, wrapperId: "recently-viewed-products", onComplete: null },
        n = [],
        o = null,
        r = 0,
        a = {
            configuration: { expires: 90, path: "/", domain: window.location.hostname },
            name: "shopify_recently_viewed",
            write: function (e) {
                Cookies.set(this.name, e.join(" "), this.configuration);
            },
            read: function () {
                var e = [],
                    t = Cookies.get(this.name);
                return void 0 !== t && "" !== t && (e = t.split(" ")), e;
            },
            destroy: function () {
                Cookies.remove(this.name, null, this.configuration);
            },
            remove: function (e) {
                var t = this.read(),
                    i = t.indexOf(e);
                -1 !== i && (t.splice(i, 1), this.write(t));
            },
        },
        s = function () {
            if (n.length && r < i.howManyToShow) {
                let e = `/products/${n[0]}?view=listing`;
                fetch(e)
                    .then((e) => e.text())
                    .then((e) => {
                        let t = ((e) => {
                            if (!e) return console.log("Error. Must provide a valid product in order to format it"), !1;
                            var t = new DOMParser().parseFromString(e, "text/html").querySelector('[data-html="listing"]');
                            if (!t) return console.log("Error. Could not find template elment."), !1;
                            let i = document.createElement("div");
                            return i.classList.add("product", "product-index", "recently-viewed-products__product", "js-product-listing"), i.appendChild(t.content), i;
                        })(e);
                        o.appendChild(t), n.shift(), r++, s();
                    })
                    .catch((e) => {
                        console.log(e.message), a.remove(n[0]), n.shift(), s();
                    });
            } else
                !(function () {
                    if (!(r > 0)) return console.log("No recently viewed products to show"), !1;
                    if ((o.classList.contains("recently-viewed-products--hidden") && o.classList.remove("recently-viewed-products--hidden"), i.onComplete))
                        try {
                            i.onComplete();
                        } catch (e) {}
                })();
        };
    return (
        (t.showRecentlyViewed = function (e) {
            (e = e || {}), (i = Object.assign(i, e)), (r = 0), (n = []), (o = null), (template = null), (n = a.read()), (o = document.getElementById(i.wrapperId)), i.howManyToShow && o && s();
        }),
        (t.getConfig = function () {
            return i;
        }),
        (t.clearList = function () {
            a.destroy();
        }),
        (t.getCount = function () {
            return a.read().length;
        }),
        t.showRecentlyViewed(e),
        t
    );
};
Shopify.RecordViewedProducts = (function () {
    var e = { howManyToShow: 3, howManyToStoreInMemory: 30, wrapperId: "recently-viewed-products", onComplete: null },
        t = {
            configuration: { expires: 90, path: "/", domain: window.location.hostname },
            name: "shopify_recently_viewed",
            write: function (e) {
                Cookies.set(this.name, e.join(" "), this.configuration);
            },
            read: function () {
                var e = [],
                    t = Cookies.get(this.name);
                return void 0 !== t && "" !== t && (e = t.split(" ")), e;
            },
            destroy: function () {
                Cookies.remove(this.name, null, this.configuration);
            },
            remove: function (e) {
                var t = this.read(),
                    i = t.indexOf(e);
                -1 !== i && (t.splice(i, 1), this.write(t));
            },
        };
    return {
        getConfig: function () {
            return e;
        },
        clearList: function () {
            t.destroy();
        },
        getCount: function () {
            return t.read().length;
        },
        recordRecentlyViewed: function (i) {
            i = i || {};
            e = Object.assign(e, i);
            var n = t.read();
            if (-1 !== window.location.pathname.indexOf("/products/")) {
                var o = new URL(window.location).pathname,
                    r = decodeURIComponent(o).split("/"),
                    a = r[r.indexOf("products") + 1];
                if (!a) return console.log("Error, no product handle found."), !1;
                var s = n.indexOf(a);
                -1 === s ? (n.unshift(a), (n = n.splice(0, e.howManyToStoreInMemory))) : (n.splice(s, 1), n.unshift(a)), t.write(n);
            }
        },
    };
})();
var mobile = window.matchMedia("(max-width: 740px)"),
    tablet = window.matchMedia("(max-width: 979px) and (min-width: 741px)"),
    desktop = window.matchMedia("(min-width: 980px)");
document.addEventListener("DOMContentLoaded", function () {
    !(function () {
        document.querySelector('[data-wau-modal-content="product-size-chart"]') && WAU.Modal.init("product-size-chart"),
            document.querySelector('[data-wau-modal-content="create-customer"]') && WAU.Modal.init("create-customer"),
            document.querySelector('[data-wau-modal-content="recover-password"]') && WAU.Modal.init("recover-password"),
            document.querySelector('[data-wau-modal-content="new-address"]') && WAU.Modal.init("new-address");
        var e = document.querySelectorAll("[data-wau-modal-content]");
        if (!e) return !1;
        e.forEach((e, t) => {
            e.dataset.wauModalContent.includes("edit-address") && WAU.Modal.init(e.dataset.wauModalContent);
        });
    })();
});
var selectors = { disclosureLocale: "[data-disclosure-locale]", disclosureCurrency: "[data-disclosure-currency]" };
(theme.AnnouncementBar = (function () {
    function e(e) {
        (this.container = e),
            (this.cache = {}),
            this.cacheSelectors(),
            this.cache.localeDisclosure && (this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure)),
            this.cache.currencyDisclosure && (this.currencyDisclosure = new theme.Disclosure(this.cache.currencyDisclosure));
    }
    return (
        (e.prototype = _.assignIn({}, e.prototype, {
            cacheSelectors: function () {
                this.cache = { localeDisclosure: this.container.querySelector(selectors.disclosureLocale), currencyDisclosure: this.container.querySelector(selectors.disclosureCurrency) };
            },
            onUnload: function () {
                this.cache.localeDisclosure && this.localeDisclosure.destroy(), this.cache.currencyDisclosure && this.currencyDisclosure.destroy();
            },
        })),
        e
    );
})()),
    (theme.Header = (function () {
        function e(e) {
            const t = document.querySelector(".js-mobile-header"),
                i = document.querySelector(".js-block-header"),
                n = (document.querySelector(".js-clear-element"), document.querySelectorAll(".js-menuitem-with-nested-dropdown")),
                o = document.querySelectorAll(".js-doubletap-to-go"),
                r = document.querySelector(".js-top-bar");
            window.innerWidth, window.innerWidth;
            function a() {
                let e,
                    n,
                    o,
                    a = document.querySelector(".header__wrapper").classList.contains("mobile-style-true");
                switch (window.innerWidth < 740 || a) {
                    case !0:
                        (o = r.clientHeight), (e = ".js-mobile-header"), (n = t.clientHeight);
                        break;
                    case !1:
                        (o = i ? r.clientHeight + i.clientHeight : r.clientHeight), (e = ".js-theme-header"), (n = document.querySelector(".js-theme-header").clientHeight);
                }
                return theme.Helpers.makeSticky(o, e, n);
            }
            window.addEventListener("scroll", function (e) {
                a();
            }),
                window.addEventListener("resize", function (e) {
                    a();
                }),
                window.addEventListener("shopify:section:select", function (e) {
                    a();
                }),
                theme.a11yHelpers.setUpAriaExpansion(),
                theme.a11yHelpers.setUpAccessibleNavigationMenus(),
                n.forEach(function (e) {
                    e.addEventListener("mouseenter", function (t) {
                        const i = e.querySelector(".js-dropdown-nested");
                        i && theme.DOMHelpers.isElementPastEdge(i) && i.classList.add("dropdown--edge");
                    });
                }),
                o.forEach(function (e) {
                    let t,
                        i = !1;
                    const n = e.getAttribute("data-active-class");
                    Events.on("device:touchstart", function () {
                        i = !0;
                    }),
                        e.addEventListener("click", function (e) {
                            i && e.preventDefault();
                        }),
                        e.addEventListener("touchstart", function (e) {
                            e.target.setAttribute("aria-expanded", "false"),
                                (function (e) {
                                    document.querySelectorAll(`[data-active-class="${e}"]`).forEach(function (t) {
                                        t.classList.remove(e);
                                    });
                                })(n),
                                t === e.target ? (i = !1) : (e.target.classList.toggle(n), e.target.setAttribute("aria-expanded", "true")),
                                (t = e.target);
                        });
                });
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                onSelect: function () {
                    WAU.Slideout.init("mobile-navigation"), document.querySelector('[data-wau-modal-content="search-modal"]') && WAU.Modal.init("search-modal");
                },
            })),
            e
        );
    })()),
    (theme.Carousel = function (e) {
        document.querySelectorAll(".js-slideshow").forEach((e) => {
            const t = e.getAttribute("data-flickity"),
                i = JSON.parse(t);
            new Flickity(e, i);
        });
    }),
    (theme.Carousel.prototype = _.assignIn({}, theme.Carousel.prototype, {
        onLoad: function (e) {
            const t = e.target.closest(".js-slideshow").getAttribute("data-flickity"),
                i = JSON.parse(t);
            new Flickity(".js-slideshow", i);
        },
        onBlockSelect: function (e) {
            const t = e.target.closest(".js-slideshow"),
                i = Flickity.data(t),
                n = e.target.getAttribute("data-slider-index");
            i.select(n);
        },
    })),
    (theme.CollectionList = (function () {
        function e(e) {}
        return (e.prototype = _.assignIn({}, e.prototype, {})), e;
    })()),
    (theme.Collection = (function () {
        function e(e) {
            e.querySelector("[data-collection-sidebar]") && WAU.Slideout.init("collection-sidebar"), theme.CollectionPage.init(e, e.dataset.sectionId);
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                onBlockSelect: function (e) {
                    WAU.Slideout._openByName("collection-sidebar");
                    const t = document.querySelector(".slideout--active").getAttribute("data-wau-slideout");
                    WAU.Accordion.hideAll(t),
                        setTimeout(function () {
                            var t = e.target.nextElementSibling;
                            theme.CollectionPage.openAccordions(t);
                        }, 500),
                        document.addEventListener("shopify:section:unload", function (e) {
                            WAU.Slideout._closeByName("collection-sidebar");
                        });
                },
            })),
            e
        );
    })()),
    (theme.CollectionPage = {
        init: function (e, t) {
            e.querySelector("[data-collection-filter-results]") && theme.CollectionPage.currentFilters(),
                e.querySelector("[data-collection-grid-layout]") && theme.CollectionPage.gridLayout(),
                e.querySelector("[data-collection-accordion-links]") && theme.CollectionPage.slideoutLinks(),
                (e.querySelector("[data-collection-sidebar]") || e.querySelector("[data-collection-sort-by]")) && theme.CollectionPage.sidebarFilters(),
                e.querySelector("[data-collection-filters-price-range]") && (theme.CollectionPage.priceRange(), theme.CollectionPage.priceSlider()),
                (this.filterData = []);
        },
        priceRange: function () {
            const e = document.querySelectorAll(".js-filter-range-input");
            e.length > 0 &&
                e.forEach((e, t) => {
                    e.addEventListener("change", function (t) {
                        setTimeout(function () {
                            const t = new FormData(e.closest("form")),
                                i = new URLSearchParams(t).toString(),
                                n = e.closest(".c-accordion__panel");
                            theme.CollectionPage.renderPage(i, n, !0);
                        }, 1e3);
                    });
                });
        },
        priceSlider: function () {
            var e = document.querySelectorAll(".js-price-range");
            if (!e) return !1;
            e.forEach((e, t) => {
                var i = e.querySelectorAll("input[type=range]"),
                    n = e.querySelectorAll("input[type=number]");
                i.forEach(function (e) {
                    e.oninput = function () {
                        var e = parseFloat(i[0].value),
                            t = parseFloat(i[1].value),
                            o = (Math.round(100 * e) / 100).toFixed(2),
                            r = (Math.round(100 * t) / 100).toFixed(2);
                        parseFloat(o) > parseFloat(r) && ([o, r] = [r, o]), (n[0].value = o), (n[1].value = r);
                    };
                }),
                    (i[0].onchange = function () {
                        n[0].dispatchEvent(new Event("change", { bubbles: !0 }));
                    }),
                    (i[1].onchange = function () {
                        n[1].dispatchEvent(new Event("change", { bubbles: !0 }));
                    }),
                    n.forEach(function (e) {
                        e.oninput = function () {
                            var e = parseFloat(n[0].value),
                                t = parseFloat(n[1].value),
                                o = (Math.round(100 * e) / 100).toFixed(2),
                                r = (Math.round(100 * t) / 100).toFixed(2);
                            if (o > r) {
                                var a = o;
                                (n[0].value = r), (n[1].value = a);
                            }
                            (i[0].value = o), (i[1].value = r);
                        };
                    });
            });
        },
        currentFilters: function () {
            document.querySelectorAll(".js-current-filter").forEach((e, t) => {
                e.addEventListener("click", (e) => {
                    e.preventDefault(), theme.CollectionPage.onActiveFilterClick(e);
                });
            });
        },
        sidebarFilters: function (e) {
            document.querySelectorAll(".js-collection-side-filter").forEach((e, t) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault(),
                        e.querySelector('input[type="checkbox"]').checked
                            ? (e.classList.remove("current"), (e.querySelector('input[type="checkbox"]').checked = !1))
                            : (e.classList.add("current"), (e.querySelector('input[type="checkbox"]').checked = !0));
                    const i = new FormData(e.closest("form")),
                        n = new URLSearchParams(i).toString(),
                        o = e.closest(".c-accordion__panel");
                    theme.CollectionPage.renderPage(n, o, !0);
                });
            });
        },
        gridLayout: function () {
            var e = document.querySelectorAll(".js-collection-layout");
            if (!e) return !1;
            e.forEach((t, i) => {
                t.addEventListener("click", function () {
                    e.forEach((e) => {
                        e.classList.remove("active");
                    }),
                        t.classList.add("active");
                    var i = t.dataset.gridType;
                    document.querySelector(".product-loop").setAttribute("data-grid-type", i);
                });
            });
        },
        slideoutLinks: function () {
            document.querySelectorAll(".js-collection-slideout-link").forEach((e, t) => {
                e.addEventListener("click", (t) => {
                    theme.CollectionPage.openAccordions(e);
                });
            });
        },
        openAccordions: function (e) {
            const t = e.getAttribute("data-accordion-context");
            document
                .getElementById("CollectionSidebarFiltersForm")
                .querySelectorAll('.js-accordion-header[data-accordion-context="' + t + '"]')
                .forEach((e, t) => {
                    const i = e.querySelector('[data-toggle="accordion"]');
                    WAU.Accordion.show(i, !0);
                });
        },
        renderFilters: function (e, t) {
            document.querySelector("[data-collection-filter-results]") && theme.CollectionPage.currentFilters(),
                (document.querySelector("[data-collection-sidebar]") || document.querySelector("[data-collection-sort-by]")) &&
                    (WAU.Slideout.init("collection-sidebar"), theme.CollectionPage.sidebarFilters(), t && (WAU.Slideout._openByName("collection-sidebar"), null != e && theme.CollectionPage.openAccordions(e))),
                document.querySelector("[data-collection-filters-price-range]") && (theme.CollectionPage.priceRange(), theme.CollectionPage.priceSlider()),
                document.querySelector("[data-collection-grid-layout]") && theme.CollectionPage.gridLayout(),
                document.querySelector("[data-collection-accordion-links]") && theme.CollectionPage.slideoutLinks(),
                Shopify.theme.quickview.init();
        },
        renderSectionFromFetch: function (e, t, i, n) {
            fetch(e)
                .then((e) => e.text())
                .then((t) => {
                    const o = t;
                    (this.filterData = [...this.filterData, { html: o, url: e }]), theme.CollectionPage.renderProductGrid(o), theme.CollectionPage.renderFilters(i, n);
                });
        },
        renderSectionFromCache: function (e, t, i, n) {
            const o = this.filterData.find(e).html;
            theme.CollectionPage.renderProductGrid(o), theme.CollectionPage.renderFilters(i, n);
        },
        renderPage: function (e, t, i, n = !0) {
            theme.CollectionPage.getSections().forEach((n) => {
                const o = `${window.location.pathname}?section_id=${n.section}&${e}`,
                    r = (e) => e.url === o;
                this.filterData.some(r) ? theme.CollectionPage.renderSectionFromCache(r, n, t, i) : theme.CollectionPage.renderSectionFromFetch(o, n, t, i);
            }),
                n && theme.CollectionPage.updateURLHash(e);
        },
        renderProductGrid: function (e) {
            const t = new DOMParser().parseFromString(e, "text/html").getElementById("CollectionProductGrid").innerHTML;
            document.getElementById("CollectionProductGrid").innerHTML = t;
        },
        onActiveFilterClick: function (e) {
            e.preventDefault(), theme.CollectionPage.renderPage(new URL(e.currentTarget.href).searchParams.toString(), !1);
        },
        updateURLHash: function (e) {
            history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
        },
        getSections: function () {
            return [{ id: "main-collection-product-grid", section: document.getElementById("main-collection-product-grid").dataset.id }];
        },
    }),
    (theme.Search = (function () {
        function e(e) {
            e.querySelector("[data-collection-sidebar]") && WAU.Slideout.init("collection-sidebar"), theme.SearchPage.init(e, e.dataset.sectionId);
        }
        return (e.prototype = _.assignIn({}, e.prototype, {})), e;
    })()),
    (theme.SearchPage = {
        init: function (e, t) {
            e.querySelector("[data-collection-filter-results]") && theme.SearchPage.currentFilters(),
                e.querySelector("[data-collection-grid-layout]") && theme.SearchPage.gridLayout(),
                e.querySelector("[data-collection-accordion-links]") && theme.SearchPage.slideoutLinks(),
                (e.querySelector("[data-collection-sidebar]") || e.querySelector("[data-collection-sort-by]")) && theme.SearchPage.sidebarFilters(),
                e.querySelector("[data-collection-filters-price-range]") && (theme.SearchPage.priceRange(), theme.SearchPage.priceSlider()),
                (this.filterData = []);
        },
        priceRange: function () {
            const e = document.querySelectorAll(".js-filter-range-input");
            e.length > 0 &&
                e.forEach((e, t) => {
                    e.addEventListener("change", function (t) {
                        setTimeout(function () {
                            const t = new FormData(e.closest("form")),
                                i = new URLSearchParams(t).toString(),
                                n = e.closest(".c-accordion__panel");
                            const o = window.location.search.toString().replace("?", "") + "&" + i;
                            theme.SearchPage.renderPage(o, n, !0);
                        }, 1e3);
                    });
                });
        },
        priceSlider: function () {
            var e = document.querySelectorAll(".js-price-range");
            if (!e) return !1;
            e.forEach((e, t) => {
                var i = e.querySelectorAll("input[type=range]"),
                    n = e.querySelectorAll("input[type=number]");
                i.forEach(function (e) {
                    e.oninput = function () {
                        var e = parseFloat(i[0].value),
                            t = parseFloat(i[1].value),
                            o = (Math.round(100 * e) / 100).toFixed(2),
                            r = (Math.round(100 * t) / 100).toFixed(2);
                        parseFloat(o) > parseFloat(r) && ([o, r] = [r, o]), (n[0].value = o), (n[1].value = r);
                    };
                }),
                    (i[0].onchange = function () {
                        n[0].dispatchEvent(new Event("change", { bubbles: !0 }));
                    }),
                    (i[1].onchange = function () {
                        n[1].dispatchEvent(new Event("change", { bubbles: !0 }));
                    }),
                    n.forEach(function (e) {
                        e.oninput = function () {
                            var e = parseFloat(n[0].value),
                                t = parseFloat(n[1].value),
                                o = (Math.round(100 * e) / 100).toFixed(2),
                                r = (Math.round(100 * t) / 100).toFixed(2);
                            if (o > r) {
                                var a = o;
                                (n[0].value = r), (n[1].value = a);
                            }
                            (i[0].value = o), (i[1].value = r);
                        };
                    });
            });
        },
        currentFilters: function () {
            document.querySelectorAll(".js-current-filter").forEach((e, t) => {
                e.addEventListener("click", (e) => {
                    e.preventDefault(), theme.SearchPage.onActiveFilterClick(e);
                });
            });
        },
        sidebarFilters: function (e) {
            document.querySelectorAll(".js-collection-side-filter").forEach((e, t) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault(),
                        e.querySelector('input[type="checkbox"]').checked
                            ? (e.classList.remove("current"), (e.querySelector('input[type="checkbox"]').checked = !1))
                            : (e.classList.add("current"), (e.querySelector('input[type="checkbox"]').checked = !0));
                    const i = new FormData(e.closest("form")),
                        n = new URLSearchParams(i).toString(),
                        o = e.closest(".c-accordion__panel");
                    const r = window.location.search.toString().replace("?", "") + "&" + n;
                    theme.SearchPage.renderPage(r, o, !0);
                });
            });
        },
        gridLayout: function () {
            var e = document.querySelectorAll(".js-collection-layout");
            if (!e) return !1;
            e.forEach((t, i) => {
                t.addEventListener("click", function () {
                    e.forEach((e) => {
                        e.classList.remove("active");
                    }),
                        t.classList.add("active");
                    var i = t.dataset.gridType;
                    document.querySelector(".search__grid").setAttribute("data-grid-type", i);
                });
            });
        },
        slideoutLinks: function () {
            document.querySelectorAll(".js-collection-slideout-link").forEach((e, t) => {
                e.addEventListener("click", (t) => {
                    theme.SearchPage.openAccordions(e);
                });
            });
        },
        openAccordions: function (e) {
            const t = e.getAttribute("data-accordion-context");
            document
                .getElementById("CollectionSidebarFiltersForm")
                .querySelectorAll('.js-accordion-header[data-accordion-context="' + t + '"]')
                .forEach((e, t) => {
                    const i = e.querySelector('[data-toggle="accordion"]');
                    WAU.Accordion.show(i, !0);
                });
        },
        renderFilters: function (e, t) {
            document.querySelector("[data-collection-filter-results]") && theme.SearchPage.currentFilters(),
                (document.querySelector("[data-collection-sidebar]") || document.querySelector("[data-collection-sort-by]")) &&
                    (WAU.Slideout.init("collection-sidebar"), theme.SearchPage.sidebarFilters(), t && (WAU.Slideout._openByName("collection-sidebar"), null != e && theme.SearchPage.openAccordions(e))),
                document.querySelector("[data-collection-filters-price-range]") && (theme.SearchPage.priceRange(), theme.SearchPage.priceSlider()),
                document.querySelector("[data-collection-grid-layout]") && theme.SearchPage.gridLayout(),
                document.querySelector("[data-collection-accordion-links]") && theme.SearchPage.slideoutLinks(),
                Shopify.theme.quickview.init();
        },
        renderSectionFromFetch: function (e, t, i, n) {
            fetch(e)
                .then((e) => e.text())
                .then((t) => {
                    const o = t;
                    (this.filterData = [...this.filterData, { html: o, url: e }]), theme.SearchPage.renderSearchGrid(o), theme.SearchPage.renderFilters(i, n);
                });
        },
        renderSectionFromCache: function (e, t, i, n) {
            const o = this.filterData.find(e).html;
            theme.SearchPage.renderSearchGrid(o), theme.SearchPage.renderFilters(i, n);
        },
        renderPage: function (e, t, i, n = !0) {
            theme.SearchPage.getSections().forEach((n) => {
                const o = `${window.location.pathname}?section_id=${n.section}&${e}`,
                    r = (e) => e.url === o;
                this.filterData.some(r) ? theme.SearchPage.renderSectionFromCache(r, n, t, i) : theme.SearchPage.renderSectionFromFetch(o, n, t, i);
            }),
                n && theme.SearchPage.updateURLHash(e);
        },
        renderSearchGrid: function (e) {
            const t = new DOMParser().parseFromString(e, "text/html").getElementById("searchResultsWrapper").innerHTML;
            document.getElementById("searchResultsWrapper").innerHTML = t;
        },
        onActiveFilterClick: function (e) {
            e.preventDefault();
            const t = new URL(e.currentTarget.href).searchParams.toString(),
                i = new URL(window.location).searchParams.get("q");
            var n = t || "q=" + i;
            theme.SearchPage.renderPage(n);
        },
        updateURLHash: function (e) {
            history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
        },
        getSections: function () {
            return [{ id: "main-search-results", section: document.getElementById("main-search-results").dataset.id }];
        },
    });
(mobile = window.matchMedia("(max-width: 740px)")), (tablet = window.matchMedia("(max-width: 979px) and (min-width: 741px)")), (desktop = window.matchMedia("(min-width: 980px)"));
function onYouTubeIframeAPIReady() {
    theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}
(theme.ProductForm = function (e, t, i, n) {
    var o,
        r,
        a,
        s = e.querySelector(`#product-form-${t}`),
        c = JSON.parse(s.dataset.productForm || "{}");
    if (
        (e.querySelectorAll(".formVariantId").forEach((e, t) => {
            e.setAttribute("name", "id");
        }),
        (function () {
            var t = e.querySelectorAll("[name=quantity]");
            if (!t) return !1;
            t.forEach((e, t) => {
                i.on("quantitycontrol:click", function (t) {
                    var i = parseInt(e.value) + t;
                    if (i < 1) return !1;
                    e.value = i;
                }),
                    i.on("variantchange", function () {
                        e.value = 1;
                    });
            });
        })(),
        (function () {
            function t(t, n) {
                var o = e.querySelector(t);
                if (!o) return !1;
                o.addEventListener("click", function (e) {
                    e.preventDefault(), i.trigger("quantitycontrol:click", n);
                });
            }
            t(".quantity-control-up", 1), t(".quantity-control-down", -1);
        })(),
        1 == n.variants.length)
    )
        return e.querySelector("[data-store-availability-container]") && i.trigger("storeavailability:variant", n.variants[0].id, n.title, e), !1;
    if (n.has_only_default_variant) return !1;
    function l(e) {
        return theme.Helpers.formatMoney(e, c.money_format);
    }
    function u(e) {
        return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
    }
    (o = e.querySelectorAll(".js-variant-selector")).forEach((t, s) => {
        t.addEventListener("change", function (t) {
            if ((t.preventDefault(), "swatches" == c.swatches)) {
                const e = Array.from(o);
                r = e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value);
            } else r = Array.from(e.querySelectorAll("select.js-variant-selector"), (e) => e.value);
            (a = n.variants.find((e) => !e.options.map((e, t) => r[t] === e).includes(!1))),
                (function (e, t, o) {
                    if (!t) return i.trigger("variantunavailable", o), void Events.trigger("storeavailability:unavailable");
                    if (1 == n.variants.length) {
                        if (!t.available) e.querySelector(".product-price").innerHTML = o.sold_out;
                        return;
                    }
                    i.trigger("variantchange", t, o),
                        i.trigger("variantchange:option1:" + t.option1),
                        i.trigger("variantchange:option2:" + t.option2),
                        i.trigger("variantchange:option3:" + t.option3),
                        e.querySelector("[data-store-availability-container]") && i.trigger("storeavailability:variant", t.id, n.title, e);
                    t.featured_media && Events.trigger("variantchange:image", t.featured_media.id, e);
                    o.enable_history &&
                        (function (e, t) {
                            if (!e) return;
                            window.history.replaceState({}, "", `${t.dataset.url}?variant=${e.id}`);
                        })(t, e);
                    !(function (e, t) {
                        t.querySelectorAll(".formVariantId").forEach((t, i) => {
                            t.setAttribute("name", "id"), (t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
                        });
                    })(t, e);
                })(e, a, c);
        });
    }),
        (function () {
            const t = "icon",
                n = "percentage",
                o = "amount",
                r = e.querySelector(".price__badge.price__badge--sale"),
                a = e.dataset.saleFormat,
                s = c.savings;
            if (a == t) return console.log("sale_icon:: Error. Format does not match an accepted format."), !1;
            if (!c) return console.log("sale_icon:: Error. Do not have access to the config object for translations."), !1;
            if (!r) return console.log("sale_icon:: Error. No Sale icon element to work with."), !1;
            function u(e, t, i, r = /{{ savings }}/i) {
                if (!e) return console.log("Error. No variant passed into function."), !1;
                if (!t) return console.log("Error. No format was passed into function."), !1;
                if (!i) return console.log("Error. No string passed into function."), !1;
                switch (t) {
                    case n:
                        return i.replace(
                            r,
                            (function (e) {
                                const t = e.compare_at_price - e.price;
                                return Math.floor((t / e.compare_at_price) * 100) + "%";
                            })(e)
                        );
                    case o:
                        return i.replace(
                            r,
                            (function (e) {
                                return l(e.compare_at_price - e.price);
                            })(e)
                        );
                }
            }
            i.on("variantchange", function (e) {
                e.compare_at_price > e.price && (r.innerHTML = u(e, a, s));
            });
        })(),
        (function () {
            const t = "visually-hidden",
                n = { variantStockLevels: "." + "js-variant-stock-levels", variantStockLevelsMessage: "." + "js-variant-stock-levels__message", variantStockLevelsTheshold: "data-variant-stock-level-threshold" },
                o = e.querySelector(n.variantStockLevels),
                r = e.querySelector(n.variantStockLevelsMessage);
            if (!o) return console.log("Error. Could not find product inventory element."), !1;
            const a = void 0 !== o.getAttribute(n.variantStockLevelsTheshold) ? parseInt(o.dataset.stockLevelThreshold, 10) : 11,
                s = () => "function" == typeof theme.Helpers.fadeIn && "function" == typeof theme.Helpers.fadeOut,
                l = (e) => {
                    e && s && theme.Helpers.fadeOut(e);
                };
            i.on("variantchange", (e) => {
                var i;
                e.inventory_management && e.inventory_quantity < a && e.inventory_quantity > 0
                    ? ((r.innerHTML = ((e, t, i = /{{ count }}/) =>
                          1 == t ? (e.only_left.one.includes(i.source) ? e.only_left.one.replace(i, t) : e.only_left.one) : e.only_left.one.includes(i.source) ? e.only_left.other.replace(i, t) : e.only_left.other)(c, e.inventory_quantity)),
                      (i = o) && (i.classList.remove(t), s && theme.Helpers.fadeIn(i)))
                    : l(o);
            }),
                i.on("variantunavailable", (e) => {
                    l(o);
                });
        })(),
        (function () {
            var t = e.querySelectorAll("[type=radio]");
            if (!t) return !1;
            var o = function (e) {
                    e.parentElement.classList.add("soldout");
                },
                r = function (e) {
                    e.parentElement.classList.remove("soldout");
                };
            i.on("variantunavailable", function () {
                var e = {};
                document.querySelectorAll("[type=radio]:checked").forEach(function (t) {
                    var i = "option" + t.getAttribute("data-position"),
                        n = t.value;
                    e[i] = n;
                }),
                    t.forEach(function (t) {
                        var i = !1,
                            a = "option" + t.getAttribute("data-position"),
                            s = t.value,
                            c = ["option1", "option2", "option3"].filter(function (t) {
                                return e[t] && t != a;
                            });
                        n.variants.forEach(function (t) {
                            t.available && t[a] == s && (t[c[0]] != e[c[0]] || t[c[1]] != e[c[1]] || (i = !0));
                        }),
                            i ? r(t) : o(t);
                    });
            }),
                t.forEach(function (t) {
                    var a = t.getAttribute("data-position"),
                        s = "option" + a,
                        c = ["option1", "option2", "option3"].filter(function (e) {
                            return e != s;
                        });
                    t.addEventListener("change", function (n) {
                        (e.querySelector("#selected-option-" + a).innerHTML = t.value), i.trigger("swatch:change:" + a, t.value);
                    }),
                        i.on("variantchange:option" + a + ":" + t.value, function () {
                            t.checked = !0;
                        }),
                        i.on("variantchange", function (e) {
                            var i = !1;
                            n.variants.forEach(function (n) {
                                n.available && n[s] == t.value && n[c[0]] == e[c[0]] && n[c[1]] == e[c[1]] && (i = !0);
                            }),
                                i ? r(t) : o(t);
                        });
                }),
                e.querySelectorAll(".swatches__form--label").forEach(function (e) {
                    e.addEventListener("keyup", function (e) {
                        if (13 === e.keyCode) {
                            e.preventDefault();
                            e.target.parentNode.querySelector(".swatches__form--input").click();
                        }
                    });
                });
        })(),
        (function () {
            var t = e.querySelector(".price__regular .price-item--regular");
            if (!t) return !1;
            i.on("variantchange", function (e) {
                var n = l(e.price);
                (t.innerHTML = n),
                    i.on("variantunavailable", function (e) {
                        (n = c.unavailable), (t.innerHTML = n);
                    });
            });
        })(),
        (function () {
            var t = e.querySelector("[data-price]");
            if (!t) return !1;
            i.on("variantchange", function (e) {
                e.available && e.compare_at_price > e.price
                    ? (t.classList.add("price--on-sale"), t.classList.remove("price--sold-out"))
                    : !e.available && e.compare_at_price > e.price
                    ? (t.classList.add("price--sold-out"), t.classList.add("price--on-sale"))
                    : e.available
                    ? (t.classList.remove("price--on-sale"), t.classList.remove("price--sold-out"))
                    : (t.classList.add("price--sold-out"), t.classList.remove("price--on-sale")),
                    e.unit_price_measurement ? t.classList.add("price--unit-available") : t.classList.remove("price--unit-available");
            });
        })(),
        (function () {
            var t = e.querySelector("[data-unit-price]"),
                n = e.querySelector(".price__unit");
            if (!t) return !1;
            i.on("variantchange", function (e) {
                var i = "";
                e.unit_price ? ((i = theme.Helpers.formatMoney(e.unit_price, c.money_format)), c.unit_price_separator, u(e), (n.style.display = "flex")) : (n.style.display = "none"), (t.innerHTML = i);
            });
        })(),
        (function () {
            var t = e.querySelector(".price__sale .price-item--sale"),
                n = e.querySelector(".price__sale .price-item--regular");
            if (!t) return !1;
            i.on("variantchange", function (e) {
                var i = "",
                    o = "";
                e.compare_at_price > e.price && ((o = l(e.compare_at_price)), (i = l(e.price))), (t.innerHTML = i), (n.innerHTML = o);
            });
        })(),
        (function () {
            var t = e.querySelector(".js-ajax-submit");
            if (!t) return !1;
            i.on("variantchange", function (e) {
                var i = c.button,
                    n = !1;
                e.available || ((i = c.sold_out), (n = !0)), (t.value = i), (t.disabled = n);
            }),
                i.on("variantunavailable", function () {
                    (t.value = c.unavailable), (t.disabled = !0);
                });
        })(),
        (function () {
            const t = e.querySelector(".product-form-installment");
            if (!t) return !1;
            const n = t.querySelector('input[name="id"]'),
                o = t.querySelector('select[name="id"]');
            i.on("variantchange", function (e) {
                (o.value = parseInt(e.id)), (n.value = e.id), o.dispatchEvent(new Event("change", { bubbles: !0 })), n.dispatchEvent(new Event("change", { bubbles: !0 }));
            });
        })(),
        (function () {
            var t = e.querySelector(".shopify-payment-button");
            if (!t) return !1;
            i.on("variantchange", function (e) {
                e.available ? (t.style.display = "block") : (t.style.display = "none");
            });
        })(),
        (function () {
            var t = document.getElementById("sticky-cart");
            if (!t) return !1;
            i.on("variantchange", function (n) {
                var o, r;
                if (null === e.getAttribute("data-main-product")) return !1;
                (o = e.querySelector("#sticky-cart .price__regular .price-item--regular")),
                    (r = l(n.price)),
                    (o.innerHTML = r),
                    i.on("variantunavailable", function (e) {
                        (r = c.unavailable), (o.innerHTML = r);
                    }),
                    (function () {
                        var t = e.querySelector("#sticky-cart [data-price]");
                        n.available && n.compare_at_price > n.price
                            ? (t.classList.add("price--on-sale"), t.classList.remove("price--sold-out"))
                            : !n.available && n.compare_at_price > n.price
                            ? (t.classList.add("price--sold-out"), t.classList.add("price--on-sale"))
                            : n.available
                            ? (t.classList.remove("price--on-sale"), t.classList.remove("price--sold-out"))
                            : (t.classList.add("price--sold-out"), t.classList.remove("price--on-sale")),
                            n.unit_price_measurement ? t.classList.add("price--unit-available") : t.classList.remove("price--unit-available");
                    })(),
                    (function () {
                        var t = e.querySelector("#sticky-cart [data-unit-price]"),
                            i = e.querySelector("#sticky-cart .price__unit");
                        if (!t) return !1;
                        var o = "";
                        n.unit_price ? ((o = theme.Helpers.formatMoney(n.unit_price, c.money_format)), c.unit_price_separator, u(n), (i.style.display = "flex")) : (i.style.display = "none"), (t.innerHTML = o);
                    })(),
                    (function () {
                        var t = e.querySelector("#sticky-cart .price__sale .price-item--sale"),
                            i = e.querySelector("#sticky-cart .price__sale .price-item--regular");
                        if (!t) return !1;
                        var o = "",
                            r = "";
                        n.compare_at_price > n.price && ((r = l(n.compare_at_price)), (o = l(n.price))), (t.innerHTML = o), (i.innerHTML = r);
                    })(),
                    t.querySelector("#current-option-1 .option-selected") && (t.querySelector("#current-option-1 .option-selected").innerHTML = n.option1),
                    t.querySelector("#current-option-2 .option-selected") && (t.querySelector("#current-option-2 .option-selected").innerHTML = n.option2),
                    t.querySelector("#current-option-3 .option-selected") && (t.querySelector("#current-option-3 .option-selected").innerHTML = n.option3);
                var a = t.querySelector(".sticky-add"),
                    s = c.button,
                    d = !1;
                n.available || ((s = c.sold_out), (d = !0)),
                    (a.value = s),
                    (a.disabled = d),
                    i.on("variantunavailable", function () {
                        (a.value = c.unavailable), (a.disabled = !0);
                    });
            });
        })(),
        (function () {
            var t = e.querySelector(".js-variant-weight");
            if (!t) return !1;
            i.on("variantchange", function (i) {
                var n = `${i.weight_in_unit} ${i.weight_unit}`;
                (t.innerHTML = n), "" === n ? e.querySelector(".js-variant-weight-container").classList.add("hide") : e.querySelector(".js-variant-weight-container").classList.remove("hide");
            }),
                i.on("variantunavailable", function (e) {
                    var i = c.unavailable;
                    t.innerHTML = i;
                });
        })(),
        (function () {
            var t = e.querySelector(".js-variant-inventory");
            if (!t) return !1;
            i.on("variantchange", function (i) {
                var n = i.inventory_quantity;
                (t.innerHTML = n), "" === n ? e.querySelector(".js-variant-inventory-container").classList.add("hide") : e.querySelector(".js-variant-inventory-container").classList.remove("hide");
            }),
                i.on("variantunavailable", function (e) {
                    var i = c.unavailable;
                    t.innerHTML = i;
                });
        })(),
        (function () {
            var t = e.querySelector(".js-variant-selected");
            if (!t) return !1;
            i.on("variantchange", function (i) {
                var n = i.title;
                (t.innerHTML = n), "" === n ? e.querySelector(".js-variant-selected-container").classList.add("hide") : e.querySelector(".js-variant-selected-container").classList.remove("hide");
            }),
                i.on("variantunavailable", function (e) {
                    var i = c.unavailable;
                    t.innerHTML = i;
                });
        })(),
        (function () {
            var t = e.querySelector(".js-product-sku");
            if (!t) return !1;
            i.on("variantchange", function (i) {
                var n = i.sku;
                (t.innerHTML = n), "" === n ? e.querySelector(".js-product-sku-container").classList.add("hide") : e.querySelector(".js-product-sku-container").classList.remove("hide");
            }),
                i.on("variantunavailable", function (e) {
                    var i = c.unavailable;
                    t.innerHTML = i;
                });
        })();
}),
    (theme.ProductGallery = {
        init: function (e, t, i, n) {
            let o = JSON.parse(e.querySelector(".js-product-gallery").dataset.galleryConfig || "{}"),
                r = e.querySelector(".js-carousel-main"),
                a = e.querySelector(".js-thumb-carousel-nav");
            if (!r) return !1;
            this.mainSlider(r, a, o, e), "bottom" == o.thumbPosition && 1 == o.thumbSlider && this.thumbSlider(a, r, e), o.clickToEnlarge && theme.ProductGallery.enlargePhoto(e);
        },
        mainSlider: function (e, t, i, n) {
            let o,
                r = e.querySelector("[data-image-id='" + n.dataset.initialVariant + "']");
            if (((o = r ? r.dataset.slideIndex : 0), "dots" == i.navStyle))
                var a = !0,
                    s = !1;
            else (a = !1), (s = !0);
            var c = new Flickity(e, {
                fade: !0,
                wrapAround: !0,
                cellAlign: "left",
                draggable: !0,
                contain: !0,
                pageDots: a,
                prevNextButtons: s,
                autoPlay: !1,
                selectedAttraction: 0.01,
                dragThreshold: 5,
                adaptiveHeight: !0,
                imagesLoaded: !0,
                initialIndex: o,
                on: {
                    ready: function () {
                        this.selectedElement.dataset.imageId, (n.querySelector(".js-product-gallery").style.visibility = "visible");
                    },
                    change: function () {
                        theme.ProductGallery.removeFocus(n),
                            theme.ProductGallery.addFocus(this.selectedElement, n),
                            theme.ProductGallery.setActiveThumbnail(this.selectedElement.dataset.imageId, this.selectedElement, n),
                            theme.ProductGallery.switchMedia(this.selectedElement.dataset.imageId, n),
                            this.selectedElement.classList.contains("model-slide") && this.isDraggable && ((this.options.draggable = !this.options.draggable), this.updateDraggable());
                    },
                    dragStart: function () {
                        document.ontouchmove = (e) => e.preventDefault();
                    },
                    dragEnd: function () {
                        document.ontouchmove = () => !0;
                    },
                },
            });
            theme.ProductGallery.galleryEvents(c, n), t && theme.ProductGallery.thumbnails(c, t, i, n);
        },
        thumbSlider: function (e, t, i) {
            new Flickity(e, { asNavFor: t, wrapAround: !1, groupCells: !0, cellAlign: "left", draggable: !1, contain: !0, imagesLoaded: !0, pageDots: !1, autoPlay: !1, selectedAttraction: 0.01, dragThreshold: 5, accessibility: !1 });
        },
        thumbnails: function (e, t, i, n) {
            if (!t) return !1;
            let o = t.querySelectorAll(".js-thumb-item");
            if (!o) return !1;
            o.forEach((i, o) => {
                i.addEventListener("click", function (i) {
                    i.preventDefault();
                    let o = this.dataset.slideIndex,
                        r = t.querySelectorAll(".js-thumb-item")[o],
                        a = this.dataset.imageId;
                    theme.ProductGallery.setActiveThumbnail(a, r, n), theme.ProductGallery.switchMedia(a, n), theme.ProductGallery.setThumbPos(this, t), e.select(o);
                }),
                    i.addEventListener("keypress", function (i) {
                        if ((i.preventDefault(), 13 == i.which)) {
                            let i = this.dataset.slideIndex,
                                o = t.querySelectorAll(".js-thumb-item")[i],
                                r = this.dataset.imageId;
                            theme.ProductGallery.setActiveThumbnail(r, o, n), theme.ProductGallery.switchMedia(r, n), theme.ProductGallery.setThumbPos(this, t), e.select(i);
                        }
                    });
            });
        },
        setThumbPos: function (e, t) {
            t.scrollTo({ top: e.offsetTop - 20, left: 0, behavior: "smooth" });
        },
        galleryEvents: function (e, t) {
            Events.on("variantchange:image", function (e, t) {
                if (null === e) return !1;
                var i, n, o;
                (o = (n = (i = t.querySelector(".js-carousel-main")).querySelector("[data-image-id='" + e + "']")).dataset.slideIndex),
                    theme.ProductGallery.setActiveThumbnail(e, n, t),
                    theme.ProductGallery.switchMedia(e, t),
                    Flickity.data(i).select(o);
            });
        },
        removeFocus: function (e) {
            let t;
            (t = e || e.querySelector(".js-carousel-main")),
                e.querySelectorAll(".js-carousel-main *").forEach((e, t) => {
                    e.setAttribute("tabIndex", "-1"), e.blur();
                }),
                e.querySelectorAll(".flickity-button *").forEach((e, t) => {
                    e.setAttribute("tabIndex", "-1"), e.classList.add("js-hide-focus");
                }),
                t.classList.contains(".flickity-enabled") && (t.setAttribute("tabIndex", "-1"), t.classList.add("js-hide-focus"));
        },
        addFocus: function (e, t) {
            e.classList.contains("image-slide")
                ? e.querySelector("img").setAttribute("tabIndex", "0")
                : e.classList.contains("video-slide")
                ? e.querySelectorAll(".plyr__controls *").forEach((e, t) => {
                      e.setAttribute("tabIndex", "0");
                  })
                : e.classList.contains("external_video-slide")
                ? e.querySelector("iframe").setAttribute("tabIndex", "0")
                : e.classList.contains("model-slide") &&
                  e.querySelectorAll(".shopify-model-viewer-ui__controls-area *").forEach((e, t) => {
                      e.setAttribute("tabIndex", "0");
                  });
        },
        enlargePhoto: function (e) {
            let t = e.querySelectorAll("a.zoom_btn");
            if (!t) return !1;
            t.forEach((e, t) => {
                e.addEventListener("click", function (e) {
                    e.preventDefault();
                    var t = e.target.getAttribute("data-ps-slide-index");
                    (t = parseInt(t, 10)), i(t);
                });
            });
            var i = function (t) {
                var i = document.querySelectorAll(".pswp")[0];
                let n = e.querySelectorAll(".js-carousel-main .image-slide");
                if (n.length < 2) var o = !1;
                else o = !0;
                let r = [];
                n.forEach((e, t) => {
                    let i = e.querySelector(".product__image"),
                        n = { src: i.getAttribute("data-zoom-src"), w: i.getAttribute("data-width"), h: i.getAttribute("data-height") };
                    r.push(n);
                });
                var a = new PhotoSwipe(i, PhotoSwipeUI_Default, r, {
                    index: t,
                    arrowEl: o,
                    captionEl: !1,
                    closeOnScroll: !1,
                    counterEl: !1,
                    history: !1,
                    fullscreenEl: !1,
                    preloaderEl: !1,
                    shareEl: !1,
                    tapToClose: !1,
                    getThumbBoundsFn: function (t) {
                        var i = window.pageYOffset || document.documentElement.scrollTop,
                            n = e.querySelector(".product__image").getBoundingClientRect();
                        return { x: n.left, y: n.top + i, w: n.width };
                    },
                });
                a.init(),
                    a.listen("afterChange", function () {
                        var e = Flickity.data(".slides.carousel-main"),
                            t = a.getCurrentIndex();
                        let i = document.querySelector(`[data-ps-slide-index="${t}"]`),
                            n = parseInt(i.dataset.index, 10);
                        e.select(n);
                    });
            };
        },
        switchMedia: function (e, t) {
            let i = t.querySelector(".js-carousel-main"),
                n = i.querySelector("[data-product-single-media-wrapper]:not(.inactive)"),
                o = i.querySelector("[data-product-single-media-wrapper][data-thumbnail-id='product-template-" + e + "']"),
                r = i.querySelectorAll("[data-product-single-media-wrapper]:not([data-thumbnail-id='product-template-" + e + "'])");
            n.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 })),
                o.classList.add("active-slide"),
                o.classList.remove("inactive"),
                o.dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 })),
                r.forEach(
                    function (e) {
                        e.classList.add("inactive"), e.classList.remove("active-slide");
                    }.bind(this)
                );
        },
        setActiveThumbnail: function (e, t, i) {
            let n = i.querySelector(".js-carousel-main"),
                o = i.querySelector(".js-thumb-carousel-nav");
            void 0 === e && (e = n.querySelector("[data-product-single-media-wrapper]:not(.hide)").dataset.mediaId),
                o &&
                    o.querySelectorAll(".js-thumb-item").forEach((e, t) => {
                        e.classList.remove("is-nav-selected"), e.classList.remove("active-slide"), e.removeAttribute("aria-current");
                    });
            let r = i.querySelector(".js-thumb-item[data-image-id='" + e + "']");
            r && (r.classList.add("is-nav-selected"), r.classList.add("active-slide"), r.setAttribute("aria-current", !0));
        },
    }),
    (theme.ProductFullGallery = {
        init: function (e, t, i, n) {
            let o = JSON.parse(e.querySelector(".js-product-gallery").dataset.galleryConfig || "{}"),
                r = e.querySelector(".js-carousel-main");
            if (!r) return !1;
            this.mainSlider(r, o, e), o.clickToEnlarge && theme.ProductFullGallery.enlargePhoto(e);
        },
        mainSlider: function (e, t, i) {
            let n,
                o = e.querySelector("[data-image-id='" + i.dataset.initialVariant + "']");
            n = o ? o.dataset.slideIndex : 0;
            var r = new Flickity(e, {
                fade: !1,
                wrapAround: !1,
                cellAlign: "center",
                draggable: !0,
                contain: !0,
                imagesLoaded: !0,
                lazyLoad: 2,
                pageDots: !0,
                prevNextButtons: !0,
                autoPlay: !1,
                selectedAttraction: 0.1,
                friction: 0.8,
                adaptiveHeight: !1,
                initialIndex: n,
                dragThreshold: 5,
                on: {
                    ready: function () {
                        this.selectedElement.dataset.imageId, (i.querySelector(".js-product-gallery").style.visibility = "visible");
                    },
                    change: function () {
                        theme.ProductFullGallery.removeFocus(i),
                            theme.ProductFullGallery.addFocus(this.selectedElement, i),
                            theme.ProductFullGallery.switchMedia(this.selectedElement.dataset.imageId, i),
                            this.selectedElement.classList.contains("model-slide") && this.isDraggable && ((this.options.draggable = !this.options.draggable), this.updateDraggable());
                    },
                    dragStart: function () {
                        document.ontouchmove = (e) => e.preventDefault();
                    },
                    dragEnd: function () {
                        document.ontouchmove = () => !0;
                    },
                },
            });
            theme.ProductFullGallery.galleryEvents(r, i);
        },
        galleryEvents: function (e, t) {
            Events.on("variantchange:image", function (t, i) {
                if (null === t) return !1;
                let n = i.querySelector(".js-carousel-main").querySelector("[data-image-id='" + t + "']").dataset.slideIndex;
                theme.ProductFullGallery.switchMedia(t, i), e.select(n);
            });
        },
        removeFocus: function (e) {
            let t;
            (t = e || e.querySelector(".js-carousel-main")),
                e.querySelectorAll(".js-carousel-main *").forEach((e, t) => {
                    e.setAttribute("tabIndex", "-1"), e.blur();
                }),
                e.querySelectorAll(".flickity-button *").forEach((e, t) => {
                    e.setAttribute("tabIndex", "-1"), e.classList.add("js-hide-focus");
                }),
                t.classList.contains(".flickity-enabled") && (t.setAttribute("tabIndex", "-1"), t.classList.add("js-hide-focus"));
        },
        addFocus: function (e, t) {
            t.querySelectorAll(".flickity-button").forEach((e, t) => {
                e.setAttribute("tabIndex", "0");
            }),
                e.classList.contains("image-slide")
                    ? e.querySelector("img").setAttribute("tabIndex", "0")
                    : e.classList.contains("video-slide")
                    ? e.querySelectorAll(".plyr__controls *").forEach((e, t) => {
                          e.setAttribute("tabIndex", "0");
                      })
                    : e.classList.contains("external_video-slide")
                    ? e.querySelector("iframe").setAttribute("tabIndex", "0")
                    : e.classList.contains("model-slide") &&
                      e.querySelectorAll(".shopify-model-viewer-ui__controls-area *").forEach((e, t) => {
                          e.setAttribute("tabIndex", "0");
                      });
        },
        enlargePhoto: function (e) {
            let t = e.querySelectorAll("a.zoom_btn");
            if (!t) return !1;
            t.forEach((e, t) => {
                e.addEventListener("click", function (e) {
                    e.preventDefault();
                    var t = e.target.getAttribute("data-ps-slide-index");
                    (t = parseInt(t, 10)), i(t);
                });
            });
            var i = function (t) {
                var i = document.querySelectorAll(".pswp")[0];
                let n = e.querySelectorAll(".js-carousel-main .image-slide");
                if (n.length < 2) var o = !1;
                else o = !0;
                let r = [];
                n.forEach((e, t) => {
                    let i = e.querySelector(".product__image"),
                        n = { src: i.getAttribute("data-zoom-src"), w: i.getAttribute("data-width"), h: i.getAttribute("data-height") };
                    r.push(n);
                });
                var a = new PhotoSwipe(i, PhotoSwipeUI_Default, r, {
                    index: t,
                    arrowEl: o,
                    captionEl: !1,
                    closeOnScroll: !1,
                    counterEl: !1,
                    history: !1,
                    fullscreenEl: !1,
                    preloaderEl: !1,
                    shareEl: !1,
                    tapToClose: !1,
                    getThumbBoundsFn: function (t) {
                        var i = window.pageYOffset || document.documentElement.scrollTop,
                            n = e.querySelector(".product__image").getBoundingClientRect();
                        return { x: n.left, y: n.top + i, w: n.width };
                    },
                });
                a.init(),
                    a.listen("afterChange", function () {
                        var e = Flickity.data(".slides.carousel-main"),
                            t = a.getCurrentIndex();
                        let i = document.querySelector(`[data-ps-slide-index="${t}"]`),
                            n = parseInt(i.dataset.index, 10);
                        e.select(n);
                    });
            };
        },
        switchMedia: function (e, t) {
            let i = t.querySelector(".js-carousel-main"),
                n = i.querySelector("[data-product-single-media-wrapper]:not(.inactive)"),
                o = i.querySelector("[data-product-single-media-wrapper][data-thumbnail-id='product-template-" + e + "']"),
                r = i.querySelectorAll("[data-product-single-media-wrapper]:not([data-thumbnail-id='product-template-" + e + "'])");
            n.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 })),
                o.classList.add("active-slide"),
                o.classList.remove("inactive"),
                o.dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 })),
                r.forEach(
                    function (e) {
                        e.classList.add("inactive"), e.classList.remove("active-slide");
                    }.bind(this)
                );
        },
    }),
    (theme.ProductVideo = (function (e, t) {
        var i = {},
            n = { html5: "html5", youtube: "youtube" },
            o = "[data-product-single-media-wrapper]",
            r = "enable-video-looping",
            a = "video-id";
        function s(e) {
            e
                ? (function () {
                      for (var e in i)
                          if (i.hasOwnProperty(e)) {
                              var t = i[e];
                              if (t.nativeVideo) continue;
                              t.host === n.html5 && (t.element.setAttribute("controls", "controls"), (t.nativeVideo = !0));
                          }
                  })()
                : u(n.html5);
        }
        function c() {
            window.YT.Player && u(n.youtube);
        }
        function l(e) {
            return "VIDEO" === e.tagName ? n.html5 : "IFRAME" === e.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e.src) ? n.youtube : null;
        }
        function u(e) {
            for (var t in i)
                if (i.hasOwnProperty(t)) {
                    var n = i[t];
                    n.host === e && n.ready();
                }
        }
        return {
            init: function (e, t) {
                if (e) {
                    var u = e.querySelector("iframe, video");
                    if (u) {
                        var d = e.getAttribute("data-media-id");
                        switch (
                            ((i[d] = {
                                mediaId: d,
                                sectionId: t,
                                host: l(u),
                                container: e,
                                element: u,
                                ready: function () {
                                    !(function (e) {
                                        if (e.player) return;
                                        var t = e.container.closest(o),
                                            i = "true" === t.getAttribute("data-" + r);
                                        switch (e.host) {
                                            case n.html5:
                                                (e.player = new Shopify.Plyr(e.element, { loop: { active: i }, muted: !0, hideControlsOnPause: !0, tooltips: { controls: !1, seek: !0 } })),
                                                    e.player.on("ready", (t) => {
                                                        e.container.querySelector(".plyr--full-ui").setAttribute("tabindex", "-1"),
                                                            e.container.querySelectorAll(".plyr--full-ui *").forEach((e, t) => {
                                                                e.setAttribute("tabindex", "-1");
                                                            });
                                                    }),
                                                    e.player.on("play", (t) => {
                                                        e.container.querySelectorAll(".plyr__controls *").forEach((e, t) => {
                                                            e.setAttribute("tabIndex", "0");
                                                        });
                                                    });
                                                break;
                                            case n.youtube:
                                                var s = t.getAttribute("data-" + a);
                                                e.player = new YT.Player(e.element, {
                                                    videoId: s,
                                                    events: {
                                                        onStateChange: function (e) {
                                                            0 === e.data && i && e.target.seekTo(0);
                                                        },
                                                        onReady: function (t) {
                                                            e.player.mute();
                                                        },
                                                    },
                                                });
                                        }
                                        var c = function () {
                                            e.player && (e.host === n.html5 && e.player.pause(), e.host === n.youtube && e.player.pauseVideo && e.player.pauseVideo());
                                        };
                                        t.addEventListener("mediaHidden", c),
                                            t.addEventListener("xrLaunch", c),
                                            t.addEventListener("mediaHidden xrLaunch", function () {
                                                e.player && (e.host === n.html5 && e.player.pause(), e.host === n.youtube && e.player.pauseVideo && e.player.pauseVideo());
                                            }),
                                            t.addEventListener("mediaVisible", function () {
                                                theme.Helpers.isTouch() || (e.player && (e.host === n.html5 && desktop.matches && e.player.play(), e.host === n.youtube && e.player.playVideo && desktop.matches && e.player.playVideo()));
                                            });
                                    })(this);
                                },
                            }),
                            i[d].host)
                        ) {
                            case n.html5:
                                window.Shopify.loadFeatures([{ name: "video-ui", version: "1.0", onLoad: s }]), theme.LibraryLoader.load("plyrShopifyStyles");
                                break;
                            case n.youtube:
                                theme.LibraryLoader.load("youtubeSdk", c);
                        }
                    }
                }
            },
            hosts: n,
            loadVideos: u,
            removeSectionVideos: function (e) {
                for (var t in i)
                    if (i.hasOwnProperty(t)) {
                        var n = i[t];
                        n.sectionId === e && (n.player && n.player.destroy(), delete i[t]);
                    }
            },
        };
    })()),
    (theme.ProductModel = (function () {
        var e = {},
            t = {},
            i = {},
            n = "[data-product-single-media-group]",
            o = "[data-shopify-xr]";
        function r(t) {
            if (!t)
                if (window.ShopifyXR) {
                    for (var i in e)
                        if (e.hasOwnProperty(i)) {
                            var n = e[i];
                            if (n.loaded) continue;
                            var o = document.querySelector("#ModelJson-" + i);
                            if (!o) return !1;
                            window.ShopifyXR.addModels(JSON.parse(o.innerHTML)), (n.loaded = !0);
                        }
                    window.ShopifyXR.setupXRElements();
                } else
                    document.addEventListener("shopify_xr_initialized", function () {
                        r();
                    });
        }
        function a(e) {
            if (!e)
                for (var i in t)
                    if (t.hasOwnProperty(i)) {
                        var n = t[i];
                        n.modelViewerUi || (n.modelViewerUi = new Shopify.ModelViewerUI(n.element)), s(n);
                    }
        }
        function s(e) {
            var t = i[e.sectionId];
            e.container.addEventListener("mediaVisible", function () {
                t.element.setAttribute("data-shopify-model3d-id", e.modelId), mobile.matches || e.modelViewerUi.play();
            }),
                e.container.addEventListener("mediaHidden", function () {
                    t.element.setAttribute("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause();
                }),
                e.container.addEventListener("xrLaunch", function () {
                    e.modelViewerUi.pause();
                });
        }
        return {
            init: function (s, c) {
                (e[c] = { loaded: !1 }),
                    s.forEach(function (e, r) {
                        var a = e.getAttribute("data-media-id"),
                            s = e.querySelector("model-viewer"),
                            l = s.getAttribute("data-model-id");
                        if (0 === r) {
                            var u = e.closest(n).querySelector(o);
                            i[c] = { element: u, defaultId: l };
                        }
                        t[a] = { modelId: l, sectionId: c, container: e, element: s };
                    }),
                    window.Shopify.loadFeatures([
                        { name: "shopify-xr", version: "1.0", onLoad: r },
                        { name: "model-viewer-ui", version: "1.0", onLoad: a },
                    ]),
                    theme.LibraryLoader.load("modelViewerUiStyles");
            },
            removeSectionModels: function (i) {
                for (var n in t) {
                    if (t.hasOwnProperty(n)) t[n].sectionId === i && (t[n].modelViewerUi.destroy(), delete t[n]);
                }
                delete e[i];
            },
        };
    })()),
    (theme.ProductDetails = function (e, t, i) {
        !(function () {
            var i = e.querySelector(".variant_sku");
            if (!i) return !1;
            t.on("variantchange", function (e, t) {
                var n = e.sku;
                i.innerHTML = n;
            }),
                t.on("variantunavailable", function (e, t) {
                    var n = t.unavailable;
                    i.innerHTML = n;
                });
        })(),
            (function () {
                var i = e.querySelector(".variant_selected");
                if (!i) return !1;
                t.on("variantchange", function (e) {
                    var t = e.title;
                    i.innerHTML = t;
                }),
                    t.on("variantunavailable", function (e, t) {
                        var n = t.unavailable;
                        i.innerHTML = n;
                    });
            })(),
            (function () {
                var i = e.querySelector(".variant_inventory");
                if (!i) return !1;
                t.on("variantchange", function (e, t) {
                    var n = e.inventory_quantity;
                    i.innerHTML = n > 0 ? n : t.unavailable;
                }),
                    t.on("variantunavailable", function (e, t) {
                        var n = t.unavailable;
                        i.innerHTML = n;
                    });
            })(),
            (function () {
                var i = e.querySelector(".variant_weight");
                if (!i) return !1;
                t.on("variantchange", function (e, t) {
                    var n = e.weight_in_unit,
                        o = e.weight_unit;
                    i.innerHTML = n > 0 ? n + "&nbsp;" + o : t.unavailable;
                }),
                    t.on("variantunavailable", function (e, t) {
                        var n = t.unavailable;
                        i.innerHTML = n;
                    });
            })();
    }),
    (theme.ProductAccordion = function () {
        document.addEventListener("shopify:block:select", function (e) {
            const t = e.target.querySelector(".js-accordion-header");
            t.classList.contains(WAU.Accordion.getConfigClass("mobileNavAccordion")) || WAU.Accordion.show(t, !0);
        }),
            document.addEventListener("shopify:block:deselect", function (e) {
                const t = e.target.querySelector(".js-accordion-header");
                t.classList.contains(WAU.Accordion.getConfigClass("mobileNavAccordion")) || t.classList.contains(WAU.Accordion.getConfigClass("open")) || WAU.Accordion.hide(t, !0);
            });
    }),
    (theme.ProductStickyBar = function () {
        if (!document.getElementById("sticky-cart")) return !1;
        let e = 0,
            t = !1;
        document.addEventListener("scroll", function (i) {
            (e = window.scrollY),
                t ||
                    (window.requestAnimationFrame(function () {
                        !(function (e) {
                            var t = document.querySelectorAll(".js-product-bottom");
                            if (!t) return !1;
                            t.forEach((t, i) => {
                                var n = t.offsetTop,
                                    o = e >= n,
                                    r = document.getElementById("footer"),
                                    a = document.querySelector(".js-sticky-cart");
                                if (1 === i) return !1;
                                o && !a.classList.contains("show") ? (a.classList.add("show"), r.classList.add("padding-sticky")) : !o && a.classList.contains("show") && (a.classList.remove("show"), r.classList.remove("padding-sticky"));
                            });
                        })(e),
                            (t = !1);
                    }),
                    (t = !0));
        });
    }),
    (theme.Accordion = function () {
        document.addEventListener("shopify:block:select", function (e) {
            e.target.classList.contains(WAU.Accordion.getConfigClass("mobileNavAccordion")) || WAU.Accordion.show(e.target, !0);
        }),
            document.addEventListener("shopify:block:deselect", function (e) {
                e.target.classList.contains(WAU.Accordion.getConfigClass("mobileNavAccordion")) || e.target.classList.contains(WAU.Accordion.getConfigClass("open")) || WAU.Accordion.hide(e.target, !0);
            });
    }),
    (theme.RecentlyViewed = function (e) {
        if (!e) return console.log("Error. Recently viewed section must be provided a container in order to work."), !1;
        const t = e.dataset.limit ? e.dataset.limit : 6,
            i = e.dataset.grid,
            n = "true" === (!!e.dataset.carousel && e.dataset.carousel),
            o = e.dataset.wrapperId;
        new ViewedProducts({
            howManyToShow: t,
            wrapperId: o,
            onComplete: ((e, t, n) => {
                ((e = "recently-viewed") => {
                    if (!e) return console.log("Error. must provide a wrapperId as an argument."), !1;
                    let t = document.getElementById(e);
                    if (!t) return console.log("Error. No wrapper element was found."), !1;
                    void 0 === typeof theme.Helpers.fadeIn ? (t.style.display = "block") : "function" == typeof theme.Helpers.fadeIn && theme.Helpers.fadeIn(t);
                })(t.id),
                    !0 === e &&
                        ((e) => {
                            if (!e) return console.log("Error. Must provide a wrapper element to initialze the carousel on."), !1;
                            const t = document.getElementById(e);
                            if (!t) return console.log("Error. No carousel element for recently viewed products found!"), !1;
                            const n = t.dataset.flickityConfig,
                                o = JSON.parse(n);
                            Shopify.RecordViewedProducts.getCount() > i && ((o.wrapAround = !0), (o.prevNextButtons = !0), (o.draggable = !0)), new Flickity(t, o);
                        })(n, this.container),
                    Shopify.theme.quickview.init();
            }).bind(this, n, e, o),
        });
    }),
    (theme.ProductRecommendations = function () {
        var e = function () {
            var e = document.querySelector(".js-product-rec-wrapper");
            if (!e) return !1;
            var t = e.dataset.baseUrl;
            if (null !== e) {
                var i = e.dataset.productId,
                    n = e.dataset.sectionId,
                    o = e.dataset.limit;
                fetch(t + "?section_id=" + n + "&limit=" + o + "&product_id=" + i)
                    .then(function (e) {
                        return e.text();
                    })
                    .then(function (t) {
                        "" !== t.trim() && ((e.innerHTML = t), (e.innerHTML = e.firstElementChild.innerHTML));
                    });
            }
        };
        document.addEventListener("shopify:section:select", function (t) {
            t.detail.sectionId.includes("product-recommendations") && e();
        }),
            e();
    }),
    (theme.Product = (function () {
        function e(e) {
            var t = new EventEmitter3();
            t.trigger = t.emit;
            var i = e.querySelector(".product-json");
            if (!i) return !1;
            var n = i.innerHTML,
                o = ((n = JSON.parse(n || "{}")), e.dataset.sectionId);
            theme.ProductAccordion(n),
                document.body.classList.contains("template-product") && Shopify.RecordViewedProducts.recordRecentlyViewed(),
                e.querySelector("[data-product-details]") && theme.ProductDetails(e, t, n),
                e.querySelector("[data-gallery-thumbnails]") && theme.ProductGallery.init(e, o, t, n),
                e.querySelector("[data-store-availability-container]") && theme.StoreAvailability(e, n, t),
                e.querySelector("[data-gallery-fullwidth]") && theme.ProductFullGallery.init(e, o, t, n),
                e.querySelector("[data-product-form]") && theme.ProductForm(e, o, t, n),
                e.querySelector("[data-product-sticky-bar]") && theme.ProductStickyBar(e, t, n),
                e.querySelectorAll("[data-product-media-type-video]").forEach(function (e, t) {
                    theme.ProductVideo.init(e, t);
                });
            let r = e.querySelectorAll("[data-product-media-type-model]");
            r.length > 0 && theme.ProductModel.init(r, o);
            var a = this;
            document.addEventListener("shopify_xr_launch", function () {
                document.querySelector("[data-product-single-media-wrapper]:not(.inactive)", a).dispatchEvent(new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }));
            });
        }
        return (
            document.addEventListener("shopify:section:load", function (t) {
                if (t.target.querySelector('[data-section-type="product__section"]')) return e;
            }),
            e
        );
    })()),
    (theme.StoreAvailability = function (e, t, i) {
        function n(e, t, i) {
            const n = i.querySelector("[data-store-availability-container]"),
                o = "/variants/" + e + "/?section_id=pickup-availability";
            (n.innerHTML = ""),
                fetch(o)
                    .then(function (e) {
                        return e.text();
                    })
                    .then(function (e) {
                        if ("" === e.trim()) return;
                        if (
                            ((n.innerHTML = e),
                            (n.innerHTML = n.firstElementChild.innerHTML),
                            (n.style.opacity = 1),
                            (n.style.visibility = "visible"),
                            n.querySelector(".store-availability-container").classList.remove("fadeOut"),
                            (n.querySelector(".store-availability-container").style.display = "block"),
                            Events.on("storeavailability:unavailable", function () {
                                n.querySelector(".store-availability-container").classList.add("fadeOut"), (n.querySelector(".store-availability-container").style.display = "none");
                            }),
                            document.querySelector('[data-pick-up-available="false"]'))
                        )
                            return (n.style.display = "none"), !1;
                        n.style.display = "block";
                        const i = document.getElementById("StoreAvailabilityModal"),
                            o = document.querySelector(".js-slideout-toggle-wrapper"),
                            r = document.getElementById("slideout-store-availability");
                        if (r) (r.innerHTML = ""), r.appendChild(i);
                        else {
                            WAU.Slideout._createSlideoutEl("right", "store-availability", o).appendChild(i);
                        }
                        WAU.Slideout.init("store-availability");
                        document.querySelector("[data-store-availability-modal-product-title]").textContent = t;
                    });
        }
        n(e.querySelector("[data-store-availability-container]").dataset.variantId, e.querySelector("[data-store-availability-container]").dataset.productTitle, e),
            i.on("storeavailability:variant", function (e, t, i) {
                n(e, t, i);
            });
    }),
    (theme.Slideshow = function (e) {
        document.querySelectorAll(".js-slideshow").forEach((e) => {
            const t = e.getAttribute("data-flickity"),
                i = JSON.parse(t);
            new Flickity(e, i);
        });
    }),
    (theme.Slideshow.prototype = _.assignIn({}, theme.Slideshow.prototype, {
        onLoad: function (e) {
            const t = e.target.closest(".js-slideshow").getAttribute("data-flickity"),
                i = JSON.parse(t);
            new Flickity(".js-slideshow", i);
        },
        onBlockSelect: function (e) {
            const t = e.target.closest(".js-slideshow"),
                i = Flickity.data(t),
                n = e.target.getAttribute("data-slider-index");
            i.select(n), i.pausePlayer();
        },
        onBlockDeselect: function () {
            const e = event.target.closest(".js-slideshow");
            Flickity.data(e).unpausePlayer();
        },
    })),
    (theme.Maps = (function () {
        var e = !1;
        var t = new EventEmitter3();
        (t.trigger = t.emit),
            (window.gm_authFailure = function () {
                (e = !1), Shopify.designMode ? t.trigger("gmauthfailure:themeeditor") : t.trigger("gmauthfailure");
            });
        const i = (e) =>
            new Promise((t, i) => {
                const n = document.createElement("script");
                (n.src = e),
                    (n.async = !0),
                    (n.onerror = i),
                    (n.onload = n.onreadystatechange = function () {
                        const e = this.readyState;
                        (e && "loaded" !== e && "complete" !== e) || ((n.onload = n.onreadystatechange = null), t());
                    }),
                    document.head.appendChild(n);
            });
        function n(n) {
            var o,
                r = n.querySelector("[data-map-config]").innerHTML;
            if (!(r = JSON.parse(r)).api_key) return !1;
            !(function () {
                var e = n;
                function i() {
                    e.classList.add("map-section-load-error");
                }
                t.on("gmauthfailure:themeeditor", i), t.on("map:error", i);
            })(),
                (o = n.querySelector("[data-bg-image]")),
                t.on("gmauthfailure", function () {
                    o.classList.add("show-image");
                }),
                (function () {
                    var e = n.querySelector("[data-map-overlay]");
                    function i(t) {
                        (t = t || r.auth_error), (e.innerHTML = '<div class="map-section-error errors text-center">' + t + "</div>");
                    }
                    t.on("gmauthfailure:themeeditor", i), t.on("map:error", i);
                })(),
                (function () {
                    var e = n.querySelector("[data-map]");
                    t.on("ready", function () {
                        new google.maps.Geocoder().geocode({ address: r.address }, function (i, n) {
                            n == google.maps.GeocoderStatus.OK
                                ? (function (t) {
                                      e.innerHTML = "";
                                      var i = new google.maps.Map(e, { zoom: r.zoom, center: t[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, styles: r.styles, disableDefaultUI: !0 }),
                                          n = i.getCenter();
                                      new google.maps.Marker({ map: i, position: n }),
                                          google.maps.event.addDomListener(window, "resize", function () {
                                              theme.Helpers.debounce(function () {
                                                  google.maps.event.trigger(i, "resize"), i.setCenter(n);
                                              }, 250);
                                          }),
                                          document.addEventListener("shopify:section:unload", function () {
                                              google.maps.event.clearListeners(i, "resize");
                                          });
                                  })(i)
                                : (function (e) {
                                      var i = r.address_error;
                                      switch (e) {
                                          case "ZERO_RESULTS":
                                              i = r.address_no_results;
                                              break;
                                          case "OVER_QUERY_LIMIT":
                                              i = r.address_query_limit;
                                              break;
                                          case "REQUEST_DENIED":
                                              i = r.auth_error;
                                      }
                                      Shopify.designMode && t.trigger("map:error", i);
                                  })(n);
                        });
                    });
                })(),
                !0 === e
                    ? t.trigger("ready")
                    : "loading" !== e &&
                      ((e = "loading"),
                      void 0 === window.google &&
                          i("https://maps.googleapis.com/maps/api/js?key=" + r.api_key)
                              .then(() => {
                                  (e = !0), t.trigger("ready");
                              })
                              .catch(() => {
                                  t.trigger("map:error", "Could not load map with API key. Check billing with Google."), console.error("Could not load script with api given");
                              }));
        }
        return (n.prototype = _.assignIn({}, n.prototype, {})), n;
    })()),
    (theme.FeaturedCollection = (function () {
        function e(e) {
            const t = {
                fade: !1,
                wrapAround: !1,
                cellAlign: "center",
                draggable: !0,
                contain: !0,
                imagesLoaded: !0,
                lazyLoad: 2,
                pageDots: !0,
                selectedAttraction: 0.6,
                friction: 1,
                dragThreshold: 15,
                on: {
                    dragStart: function () {
                        document.ontouchmove = (e) => e.preventDefault();
                    },
                    dragEnd: function () {
                        document.ontouchmove = () => !0;
                    },
                },
            };
            var i = e.querySelector(".featured__collection-carousel");
            if (!i) return !1;
            const n = i.getAttribute("data-flickity-config"),
                o = JSON.parse(n);
            Object.assign({}, t, o);
            new Flickity(i, o),
                document.addEventListener("shopify:section:unload", function (e) {
                    var t = e.target.closest(".featured__collection-carousel");
                    if (!t) return !1;
                    Flickity.data(t).destroy();
                }),
                document.addEventListener("shopify:section:load", function (e) {
                    var t = e.target.closest(".js-carousel");
                    if (!t) return !1;
                    const i = t.getAttribute("data-flickity"),
                        n = JSON.parse(i);
                    new Flickity(".js-carousel", n);
                });
        }
        return (e.prototype = _.assignIn({}, e.prototype, {})), e;
    })()),
    (theme.mobileNav = (function () {
        function e(e) {
            WAU.Slideout.init("mobile-navigation");
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                onSelect: function () {
                    WAU.Slideout._openByName("mobile-navigation");
                },
                onDeselect: function () {
                    WAU.Slideout._closeByName("mobile-navigation");
                },
                onBlockSelect: function () {
                    WAU.Slideout._openByName("mobile-navigation");
                },
            })),
            e
        );
    })()),
    (theme.CollectionSlider = function () {
        let e = (function () {
            "use strict";
            let e = {},
                t = [],
                i = [],
                n = function (e) {
                    return i.indexOf(e);
                },
                o = function (e, t) {
                    r(e, t);
                },
                r = function (e, n) {
                    let o = document.getElementById(i[n]).querySelectorAll(".slide");
                    e > o.length && (t[n] = 1),
                        e < 1 && (t[n] = o.length),
                        o.forEach((e) => {
                            e.style.display = "none";
                        }),
                        (o[t[n] - 1].style.display = "flex");
                };
            return (
                (e.selectSlide = function (e, i) {
                    let r = n(i);
                    o((t[r] = e), r);
                }),
                (e.nextSlide = function (e) {
                    let i = n(e);
                    o((t[i] += 1), i);
                }),
                (e.prevSlide = function (e) {
                    let i = n(e);
                    o((t[i] += -1), i);
                }),
                (e.init = function () {
                    let n = document.querySelectorAll(".featured-collections-slider");
                    n
                        ? (n.forEach((e, n) => {
                              t.push(1), i.push(e.id), r(1, n);
                          }),
                          document.addEventListener("click", (t) => {
                              let i = t.target;
                              if (((i.classList.contains("left-arrow") || i.classList.contains("right-arrow")) && (i = i.parentElement), i.hasAttribute("data-arrow-prev"))) e.prevSlide(i.dataset.parent);
                              else if (i.hasAttribute("data-arrow-next")) e.nextSlide(i.dataset.parent);
                              else {
                                  if (!i.hasAttribute("data-slide-to")) return;
                                  e.selectSlide(Number(i.dataset.slideTo), i.dataset.parent);
                              }
                          }))
                        : console.log("Error, no slideshows");
                }),
                e
            );
        })();
        e.init(),
            document.addEventListener("shopify:block:select", function (t) {
                t.detail.blockId;
                let i = t.target.parentElement.id,
                    n = t.target.dataset.slideIndex;
                e.selectSlide(Number(n), i);
            });
    });
selectors = { disclosureLocale: "[data-disclosure-locale]", disclosureCurrency: "[data-disclosure-currency]" };
(theme.Footer = (function () {
    function e(e) {
        (this.container = e),
            (this.cache = {}),
            this.cacheSelectors(),
            this.cache.localeDisclosure && (this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure)),
            this.cache.currencyDisclosure && (this.currencyDisclosure = new theme.Disclosure(this.cache.currencyDisclosure));
    }
    return (
        (e.prototype = _.assignIn({}, e.prototype, {
            cacheSelectors: function () {
                this.cache = { localeDisclosure: this.container.querySelector(selectors.disclosureLocale), currencyDisclosure: this.container.querySelector(selectors.disclosureCurrency) };
            },
            onUnload: function () {
                this.cache.localeDisclosure && this.localeDisclosure.destroy(), this.cache.currencyDisclosure && this.currencyDisclosure.destroy();
            },
        })),
        e
    );
})()),
    (theme.Password = (function () {
        function e(e) {
            window.addEventListener("DOMContentLoaded", (e) => {
                if (!document.querySelector(".errors")) return !1;
                WAU.Slideout._openByName("password");
            }),
                WAU.Slideout.init("password"),
                window.addEventListener("shopify:section:select", (e) => {
                    WAU.Slideout.init("password");
                });
        }
        return (e.prototype = _.assignIn({}, e.prototype, {})), e;
    })()),
    (theme.MailingPopup = (function () {
        const e = (function () {
            const e = {
                selectors: { popupContainer: ".newsletter__popup-container", popupOverlay: ".newsletter__popup-overlay", popupCloseButton: ".newsletter__popup-container-close" },
                classes: { visible: "is-visible" },
                viewportWidth: 740,
                overlay: !0,
                defaultFrequency: 5,
                defaultPopupDelay: 5e3,
                cookieSetName: "popupShown",
                debug: !1,
                escape: !0,
                successMessage: !1,
                fadeAnimation: !1,
                formId: "#mailing-popup-form",
            };
            let t, i;
            const n = {},
                o = () => {
                    if ((settings.debug && console.log("checkURLQueryString() ran"), settings.successMessage)) {
                        const e = new URL(location);
                        if (e.hash == settings.formId && "true" == e.searchParams.get("customer_posted")) return !0;
                    }
                    return !1;
                },
                r = (e) => {
                    e.target === document.querySelector(`${settings.selectors.popupOverlay}.${settings.classes.visible}`) && n.close();
                },
                a = (e) => {
                    "Escape" === e.key && (e.preventDefault(), n.close());
                },
                s = () => settings.fadeAnimation && "function" == typeof theme.Helpers.fadeIn && "function" == typeof theme.Helpers.fadeOut,
                c = (e) => {
                    n.close(e);
                },
                l = () => Shopify.designMode;
            return (
                (n.open = () => {
                    (window.innerWidth || document.documentElement.clientWidth) < settings.viewportWidth ||
                        (settings.overlay && document.querySelector(settings.selectors.popupOverlay) && document.querySelector(settings.selectors.popupOverlay).classList.add(settings.classes.visible),
                        document.querySelector(settings.selectors.popupContainer) &&
                            (s() ? theme.Helpers.fadeIn(document.querySelector(settings.selectors.popupContainer)) : (document.querySelector(settings.selectors.popupContainer).style.display = "block")),
                        !0 !== l() && Cookies.set(settings.cookieSetName, "yes", { expires: i }),
                        "function" == typeof theme.a11yHelpers.focusOnElement && theme.a11yHelpers.focusOnElement(document.querySelector(settings.selectors.popupContainer)));
                }),
                (n.close = (e) => {
                    document.querySelector(settings.selectors.popupContainer) &&
                        (s() ? theme.Helpers.fadeOut(document.querySelector(settings.selectors.popupContainer)) : (document.querySelector(settings.selectors.popupContainer).style.display = "none")),
                        settings.overlay && document.querySelector(settings.selectors.popupOverlay) && document.querySelector(settings.selectors.popupOverlay).classList.remove(settings.classes.visible),
                        e && e.preventDefault(),
                        t && t.focus();
                }),
                (n.init = (s) => {
                    (settings = Object.assign({}, e, s)),
                        (i = document.querySelector(settings.selectors.popupContainer).getAttribute("data-popup-frequency")
                            ? Number(document.querySelector(settings.selectors.popupContainer).getAttribute("data-popup-frequency"))
                            : settings.defaultFrequency);
                    const u = document.querySelector(settings.selectors.popupContainer).getAttribute("data-popup-delay");
                    let d = 1e3 * Number(u);
                    const h = document.querySelector(settings.selectors.popupCloseButton);
                    h || (settings.debug && console.log("err. no popup close button"));
                    const p = "true" == document.querySelector(settings.selectors.popupContainer).getAttribute("data-popup-enabled");
                    h.addEventListener("click", c),
                        settings.escape && document.addEventListener("keyup", a),
                        settings.overlay && document.addEventListener("click", r),
                        !l() &&
                            p &&
                            (o() && (d = 10),
                            setTimeout(function () {
                                if (o()) (t = document.activeElement), n.open();
                                else {
                                    Cookies.get(settings.cookieSetName) || ((t = document.activeElement), n.open());
                                }
                            }, d));
                }),
                n
            );
        })();
        function t(t) {
            e.init({ selectors: { popupContainer: ".js-popup", popupOverlay: ".js-popup-overlay", popupCloseButton: ".js-popup-close" }, overlay: !0, successMessage: !0 });
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                onSelect: function () {
                    e.open();
                },
                onDeselect: function () {
                    e.close();
                },
            })),
            t
        );
    })());
(mobile = window.matchMedia("(max-width: 740px)")), (tablet = window.matchMedia("(max-width: 979px) and (min-width: 741px)")), (desktop = window.matchMedia("(min-width: 980px)"));
window.addEventListener("DOMContentLoaded", (e) => {
    WAU.Accordion.init(),
        document.querySelector('[data-wau-modal-content="search-modal"]') && WAU.Modal.init("search-modal"),
        theme.DOMHelpers.wrapIframe({ iframes: document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'), iframeWrapperClass: "video-wrapper" }),
        theme.DOMHelpers.wrapTable({ tables: document.querySelectorAll(".rte table"), tableWrapperClass: "table-wrapper" }),
        mobile.matches && Events.trigger("mediaquery:mobile"),
        tablet.matches && Events.trigger("mediaquery:tablet"),
        desktop.matches && Events.trigger("mediaquery:desktop"),
        window.addEventListener("resize", function () {
            mobile.matches && Events.trigger("mediaquery:mobile"), tablet.matches && Events.trigger("mediaquery:tablet"), desktop.matches && Events.trigger("mediaquery:desktop");
        }),
        window.addEventListener("touchstart", function e() {
            Events.trigger("device:touchstart"), window.removeEventListener("touchstart", e, !1);
        }),
        document.addEventListener("shopify:section:select", function (e) {
            Events.trigger("editor:section:select", e);
        }),
        document.addEventListener("shopify:section:deselect", function (e) {
            Events.trigger("editor:section:deselect", e);
        }),
        document.addEventListener("shopify:section:load", function (e) {
            Events.trigger("editor:section:load", e);
        }),
        document.addEventListener("shopify:section:unload", function (e) {
            Events.trigger("editor:section:unload", e);
        }),
        document.addEventListener("shopify:block:select", function (e) {
            Events.trigger("editor:block:select", e);
        }),
        document.addEventListener("shopify:block:deselect", function (e) {
            Events.trigger("editor:block:deselect", e);
        }),
        document.addEventListener("lazyloaded", function (e) {
            Events.trigger("lazyLoad:complete");
        }),
        void 0 !== theme.DOMHelpers.isElementPastEdge && void 0 !== theme.DOMHelpers.adjustElementXPosition
            ? document.addEventListener("click", (e) => {
                  let t = e.target;
                  if (!t.classList.contains("disclosure__toggle")) return;
                  let i = t.closest(".disclosure").querySelector(".disclosure-list");
                  theme.DOMHelpers.isElementPastEdge(i) && theme.DOMHelpers.adjustElementXPosition(i, 10);
              })
            : console.log("Error. Missing helper functions"),
        (function () {
            const e = 'input[type="search"]',
                t = "#predictive-search";
            class i extends HTMLElement {
                constructor() {
                    super(),
                        this.featureDetections(),
                        (this.routesPredictiveSearchURL = this.dataset.routes),
                        (this.showOnlyProducts = this.dataset.showOnlyProducts),
                        (this.resultsPerResource = this.dataset.resultsPerResource),
                        (this.inputSelector = this.dataset.inputSelector),
                        (this.resultsSelector = this.dataset.resultsSelector),
                        (this.input = this.querySelector(this.inputSelector) ? this.querySelector(this.inputSelector) : this.querySelector(e)),
                        (this.predictiveSearchResults = this.querySelector(this.resultsSelector) ? this.querySelector(this.resultsSelector) : this.querySelector(t)),
                        this.input.addEventListener(
                            "input",
                            theme.Helpers.debounce((e) => {
                                this.onChange(e);
                            }, 300).bind(this)
                        ),
                        this.addEventListener("focusout", this.onFocusOut.bind(this));
                }
                featureDetections() {
                    return this.isFunction(theme.Helpers.debounce)
                        ? window.fetch
                            ? void 0
                            : (console.log("Error. Web browser does not support fetch required for predictive search"), !1)
                        : (console.log("Error. Missing debouce theme helper method for predictive search."), !1);
                }
                getTypeOf(e) {
                    return Object.prototype.toString.call(e);
                }
                isFunction(e) {
                    return "[object Function]" === this.getTypeOf(e);
                }
                onChange() {
                    const e = this.input.value.trim();
                    e.length ? this.getSearchResults(e) : this.close();
                }
                getSearchResults(e) {
                    let t = "true" === this.showOnlyProducts ? "product" : "product,collection,article,page",
                        i = this.resultsPerResource;
                    fetch(`${this.routesPredictiveSearchURL}?q=${e}&resources[type]=${t}&resources[limit]=${i}&section_id=predictive-search`)
                        .then((e) => {
                            if (!e.ok) {
                                var t = new Error(e.status);
                                throw (this.close(), t);
                            }
                            return e.text();
                        })
                        .then((e) => {
                            const t = new DOMParser().parseFromString(e, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
                            (this.predictiveSearchResults.innerHTML = t), this.open();
                        })
                        .catch((e) => {
                            throw (this.close(), e);
                        });
                }
                open() {
                    "function" == typeof theme.Helpers.fadeIn ? theme.Helpers.fadeIn(this.predictiveSearchResults) : (this.predictiveSearchResults.style.display = "block");
                }
                close() {
                    "function" == typeof theme.Helpers.fadeOut ? theme.Helpers.fadeOut(this.predictiveSearchResults) : (this.predictiveSearchResults.style.display = "none");
                }
                onFocusOut() {
                    setTimeout(() => {
                        this.contains(document.activeElement) || this.close();
                    });
                }
            }
            customElements.define("predictive-search", i);
        })();
}),
    document.addEventListener("DOMContentLoaded", function () {
        var e = new theme.Sections();
        e.register("slideshow-section", theme.Slideshow),
            e.register("collection-slider", theme.CollectionSlider),
            e.register("featured-collection", theme.FeaturedCollection),
            e.register("product-section", theme.Product),
            e.register("product-recommendations", theme.ProductRecommendations),
            e.register("recently-viewed", theme.RecentlyViewed),
            e.register("store-availability", theme.StoreAvailability),
            e.register("collection-list-section", theme.CollectionList),
            e.register("collection-section", theme.Collection),
            e.register("search-section", theme.Search),
            e.register("mobile-navigation", theme.mobileNav),
            e.register("header-section", theme.Header),
            e.register("announcement-bar", theme.AnnouncementBar),
            e.register("footer-section", theme.Footer),
            e.register("image-carousel", theme.Carousel),
            e.register("map", theme.Maps),
            e.register("password-page", theme.Password),
            e.register("mailing-popup", theme.MailingPopup),
            e.register("accordion", theme.Accordion);
    }),
    (log = function () {
        var e = Array.prototype.slice.call(arguments);
        return e.unshift(console), Function.prototype.bind.apply(console.log, e);
    }),
    log("Vantage Version 9.1.1 by Underground", { bar: 1 })();

$('input.swatches__form--input[name="size"]').click(function () {
    //alert("hi");
    $("p.option-label span").removeClass("disabled");
    $("input.disabled.AddtoCart").removeClass("disabled");
    //$("input.AddtoCart").addClass("js-ajax-submit");
    $(".swatch-element").removeClass("disa");
    $("input.AddtoCart").removeAttr("disabled");
});

// jquery('.slider_wrap').slick({
//   centerMode: true,
//   centerPadding: '60px',
//   slidesToShow: 3,
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 3
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 1
//       }
//     }
//   ]
// });
